/* ========================================================================
   McDuffy Quiz Funnel — JavaScript
   Subscription acquisition funnel at /pages/quiz
   Scoped to #mcduffy-quiz to avoid conflicts with theme
   Flow: Dog Names(1) → Profile(2) → Contact(3) → Weight(4) → Body(5) → Activity(6) → Health(7) → Routine(8) → Loading(12) → Results(13) → Treats Upsell(14)
   Recipe(9) is edit-only from the plan screen; Screens 10 and 11 are legacy fallbacks skipped by the default path.
   ======================================================================== */
(function() {
  'use strict';

  var root = document.getElementById('mcduffy-quiz');
  if (!root) return;

  var $ = function(s) { return root.querySelector(s); };
  var $$ = function(s) { return root.querySelectorAll(s); };

  /* ===== Constants ===== */
  var PRICE_BY_RECIPE = { surf_turf: 259, farmyard_feast: 259, coastal_blend: 259, chicken_rice: 259, beef_rice: 259, pork_rice: 259 };
  var SUB_PRICE_BY_RECIPE = { surf_turf: 259, farmyard_feast: 259, coastal_blend: 259, chicken_rice: 259, beef_rice: 259, pork_rice: 259 };
  function getPricePerBag(recipe) { return PRICE_BY_RECIPE[recipe || 'chicken_rice'] || 259; }
  var BAG_GRAMS = 500;
  var SUB_DISCOUNT = 1.00;
  var INTRO_DISCOUNT = 0.60;
  var SECOND_BOX_DISCOUNT = 0.80;
  /* New subscriptions pay one fixed delivery charge per physical drop. This
     legacy funnel only creates monthly plans, so both the first and recurring
     monthly totals include exactly one non-discountable ₱199 delivery. */
  var SUBSCRIPTION_DELIVERY_PHP = 199;
  /* Subscription bulk benefit REMOVED 2026-07-14 (owner): recurring food = FULL
     LIST at every qty; intro = 40% off list. One-time volume ladder is separate + kept. */
  function subscriptionBulkDiscountForBags(totalBags) {
    return 0;
  }
  function getSubPricePerBag(recipe, totalBags) {
    return SUB_PRICE_BY_RECIPE[recipe || 'chicken_rice'] || 259;
  }
  function getIntroPricePerBag(recipe, totalBags) {
    return getSubPricePerBag(recipe, totalBags) * INTRO_DISCOUNT;
  }
  function roundMoney(value) {
    return Math.round((Number(value) || 0) * 100) / 100;
  }
  function getSecondBoxPricePerBag(recipe, totalBags) {
    return roundMoney(getSubPricePerBag(recipe, totalBags) * SECOND_BOX_DISCOUNT);
  }
  var BACKEND_URL = 'https://mcduffy-backend-production.up.railway.app';
  var INPUT_STEPS = 11; /* screens 1-11 are input, 12=loading, 13=results, 14=treats upsell */
  var freshFacts = {
    1: 'Personalized portions start with your dog, not a generic scoop.',
    2: 'Saving your email early means we can recover your recommendation if you get interrupted before checkout.',
    3: 'Age, sex, and spay or neuter status help us understand life stage and calorie needs before we build the first box.',
    4: 'Weight is the anchor for daily grams. This is how we avoid one-size-fits-all scoops and reduce wasted food.',
    5: 'Body condition adjusts the portion up or down, because two dogs at the same weight can need different amounts.',
    6: 'Activity changes calorie needs. A casual walker and an athlete should not get the same bowl.',
    7: 'Health details help us recommend recipes more intelligently, especially for sensitive stomachs, skin, coat, and weight concerns.',
    8: 'Treats count too. Snacks add calories, so we factor them into the daily portion instead of ignoring them.',
    9: 'Recipe variety can make fresh food easier to stick with while still keeping portions predictable.',
    10: 'Knowing today\'s food helps us tailor transition guidance and understand what McDuffy needs to beat.',
    11: 'Your contact details are already saved, so this step only exists as a fallback.'
  };

  /* Per-recipe feeding guides */
  var feedingGuides = {
    surf_turf: [
      {kg:2.3,g:[53,106]},{kg:4.5,g:[106,159]},{kg:9.1,g:[212,318]},
      {kg:13.6,g:[218,424]},{kg:18.1,g:[424,530]},{kg:27.2,g:[530,689]},
      {kg:36.3,g:[689,848]},{kg:45.4,g:[848,1007]},{kg:54.4,g:[1007,1166]}
    ],
    farmyard_feast: [
      {kg:2.3,g:[103,149]},{kg:4.5,g:[168,247]},{kg:9.1,g:[267,419]},
      {kg:13.6,g:[433,566]},{kg:18.1,g:[579,702]},{kg:27.2,g:[716,952]},
      {kg:36.3,g:[966,1183]},{kg:45.4,g:[1192,1399]},{kg:54.4,g:[1408,1602]}
    ],
    coastal_blend: [
      {kg:2.3,g:[88,127]},{kg:4.5,g:[143,210]},{kg:9.1,g:[228,357]},
      {kg:13.6,g:[369,482]},{kg:18.1,g:[493,598]},{kg:27.2,g:[610,811]},
      {kg:36.3,g:[822,1007]},{kg:45.4,g:[1015,1191]},{kg:54.4,g:[1199,1364]}
    ],
    chicken_rice: [
      {kg:2.3,g:[89,130]},{kg:4.5,g:[146,214]},{kg:9.1,g:[232,364]},
      {kg:13.6,g:[375,491]},{kg:18.1,g:[502,609]},{kg:27.2,g:[621,826]},
      {kg:36.3,g:[838,1026]},{kg:45.4,g:[1035,1214]},{kg:54.4,g:[1222,1390]}
    ],
    /* QLT-029: canonical beef/pork tables from backend feedingGuide.js — these keys
       previously fell through to the heavier surf_turf table, over-portioning. */
    beef_rice: [
      {kg:2.3,g:[98,142]},{kg:4.5,g:[160,235]},{kg:9.1,g:[254,398]},
      {kg:13.6,g:[411,539]},{kg:18.1,g:[550,667]},{kg:27.2,g:[681,906]},
      {kg:36.3,g:[918,1125]},{kg:45.4,g:[1134,1330]},{kg:54.4,g:[1339,1523]}
    ],
    pork_rice: [
      {kg:2.3,g:[74,108]},{kg:4.5,g:[122,179]},{kg:9.1,g:[194,303]},
      {kg:13.6,g:[313,410]},{kg:18.1,g:[419,508]},{kg:27.2,g:[518,689]},
      {kg:36.3,g:[699,856]},{kg:45.4,g:[863,1012]},{kg:54.4,g:[1019,1159]}
    ]
  };

  var recipeImages = {
    surf_turf: 'https://cdn.shopify.com/s/files/1/0568/2715/0395/files/4_59c63476-cd5c-433c-8a74-653f4112cea5.png?v=1761269227',
    farmyard_feast: 'https://cdn.shopify.com/s/files/1/0568/2715/0395/files/6_b5fdf0c2-0852-47e9-b7c1-5753a26749d8.png?v=1761269235',
    coastal_blend: 'https://cdn.shopify.com/s/files/1/0568/2715/0395/files/5_5653a34c-3c8a-45c3-8f5c-18b4e0704598.png?v=1761269232',
    chicken_rice: 'https://cdn.shopify.com/s/files/1/0568/2715/0395/files/gently_cooked_5.png?v=1774238664',
    beef_rice: 'https://cdn.shopify.com/s/files/1/0568/2715/0395/files/Beef_Rice_website.png?v=1784072674',
    pork_rice: 'https://cdn.shopify.com/s/files/1/0568/2715/0395/files/Pork_Rice_website.png?v=1784072674'
  };

  var recipeNames = {
    surf_turf: 'Surf n Turf',
    farmyard_feast: 'Farmyard Feast',
    coastal_blend: 'Coastal Blend',
    chicken_rice: 'Chicken It Up',
    beef_rice: 'Braised Beef Bowl',
    pork_rice: 'Hearty Pork Rice'
  };

  /* Breed fun facts */
  var breedFacts = {
    'Shih Tzu': 'Bred for Chinese royalty \u2014 they literally lived in palaces. \ud83d\udc51',
    'Aspin': 'Among the most resilient dogs in the world. True Filipino survivors! \ud83c\uddf5\ud83c\udded',
    'Golden Retriever': 'Such soft mouths they can carry a raw egg without breaking it. \ud83e\udd5a',
    'Poodle': '2nd smartest breed \u2014 originally water retrievers in Germany! \ud83e\udde0',
    'French Bulldog': 'Can\'t swim because of their front-heavy build. Natural couch surfers! \ud83d\udecb\ufe0f',
    'Labrador': 'Webbed toes! Bred to help fishermen haul nets in Newfoundland. \ud83d\udc1f',
    'Chihuahua': 'Biggest brain-to-body ratio of any breed. Tiny but mighty! \ud83e\udde0',
    'Pomeranian': 'Two Poms survived the Titanic. First class, obviously. \ud83d\udea2',
    'Corgi': 'Welsh legend says Corgis were steeds of fairy warriors. \ud83e\uddda'
  };

  /* ===== Name + Grammar Helpers ===== */
  /* Title-case any non-empty trimmed name. Single-char names ("h", "t") are
     allowed by product decision — we just normalize case so storage matches
     display ("luna" -> "Luna", "h" -> "H"). Returns null only for empty input. */
  function formatDogName(raw) {
    if (!raw) return null;
    var n = String(raw).trim();
    if (!n) return null;
    return n.charAt(0).toUpperCase() + n.slice(1);
  }
  function displayDogName(raw) {
    return formatDogName(raw) || 'your dog';
  }
  /* Possessive form: "Luna's", "Chris'" (apostrophe-only when ending in s).
     Names ending in s are handled grammatically; single chars get standard 's. */
  function possessiveDogName(raw) {
    var n = formatDogName(raw);
    if (!n) return "your dog's";
    return n.charAt(n.length - 1).toLowerCase() === 's' ? n + "'" : n + "'s";
  }
  /* Age as adjective: "2-year-old", "5-month-old" (always hyphenated, always singular) */
  function ageAdjective(age, unit) {
    var a = parseFloat(age) || 0;
    if (a <= 0) a = 2;
    var u = (unit === 'months') ? 'month' : 'year';
    /* Round to integer for adjective form: "2.5-year-old" reads worse than "2-year-old" */
    var n = (a % 1 === 0) ? a : Math.round(a);
    return n + '-' + u + '-old';
  }

  /* ===== Quiz State ===== */
  var quiz = {
    step: 1,
    totalSteps: 14,
    name: '',
    breed: '',
    age: 2,
    ageUnit: 'years',
    weight: 0,
    condition: 'ideal',
    activity: 'medium',
    healthIssues: [],
    allergyIngredients: [],
    treats: 'none',
    sex: '',
    neutered: '',
    eatingStyle: '',
    currentFoodType: '',
    currentFoodBrand: '',
    recipe: 'chicken_rice',
    recipes: ['chicken_rice', 'beef_rice', 'pork_rice', 'surf_turf', 'farmyard_feast', 'coastal_blend'],
    plan: 'full',
    preset: '',
    conviction: '',
    priority: '',
    parentName: '',
    parentEmail: '',
    parentPhone: '',
    parentEmailOptIn: true,
    parentViberOptIn: false
  };
  var parentLeadCaptured = false;

  function createQuizSessionId() {
    return 'quiz_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  function getQuizSessionId() {
    try {
      var key = 'mcduffy_quiz_session_id';
      var existing = window.localStorage && window.localStorage.getItem(key);
      if (existing) return existing;
      var next = createQuizSessionId();
      if (window.localStorage) window.localStorage.setItem(key, next);
      return next;
    } catch(e) {
      return createQuizSessionId();
    }
  }

  var quizSessionId = getQuizSessionId();
  var completedScreens = [];
  var lastProgressKey = '';
  var progressTimer = null;

  var quizPresetMap = {
    picky: {
      title: 'Build a fresh plan for a picky eater',
      sub: 'See recipes, portions, and first subscription order pricing before checkout.',
      proof: 'Built for dogs who sniff, walk away, or need real food in the bowl.',
      pills: ['Clean-bowl recipe ideas', 'Personalized portions', 'Freshly cooked']
    },
    delivery: {
      title: 'Fresh dog food delivered around Metro Manila',
      sub: 'Build your dog\'s plan, see the first box, and schedule delivery from your phone.',
      proof: 'Portioned packs arrive frozen and ready for your freezer.',
      pills: ['₱199 per delivery', 'Frozen for freshness', 'Change anytime']
    },
    personalized: {
      title: 'See your dog\'s personalized McDuffy plan',
      sub: 'Get recipe, portion, and pouch details based on your dog\'s profile.',
      proof: 'Your dog\'s name and feeding routine carry through the plan.',
      pills: ['Personalized pouch', 'Exact portions', 'First box review']
    },
    sensitive: {
      title: 'Build a gentle fresh food plan',
      sub: 'Tell us about your dog and we\'ll guide you toward a recipe that fits.',
      proof: 'Chicken It Up is fish-free and made for sensitive dogs.',
      pills: ['Fish-free option', 'Gentle transition', 'Recipe guidance']
    },
    price: {
      title: 'Check your dog\'s McDuffy plan before checkout',
      sub: 'See portions, recipes, first subscription order pricing, and one-time options first.',
      proof: 'No account or payment until your plan is ready to review.',
      pills: ['Plan first', 'Review before payment', 'Clear renewal price']
    },
    'shih-tzu': {
      title: 'Build a fresh plan for your Shih Tzu',
      sub: 'Get portions and recipes matched to small-dog appetites and picky mealtimes.',
      proof: 'Designed for pet parents who want a cleaner bowl routine.',
      pills: ['Small-dog portions', 'Picky eater friendly', 'Personalized pouch']
    }
  };

  function getQuizPreset() {
    try {
      var preset = new URLSearchParams(window.location.search).get('preset') || '';
      preset = preset.toLowerCase().trim();
      return quizPresetMap[preset] ? preset : '';
    } catch(e) {
      return '';
    }
  }

  function applyQuizPreset() {
    quiz.preset = getQuizPreset();
    if (!quiz.preset) return;
    var preset = quizPresetMap[quiz.preset];
    var titleEl = $('#quiz-entry-title');
    var subEl = $('#quiz-entry-sub');
    var proofEl = $('#quiz-entry-proof');
    if (titleEl) titleEl.textContent = preset.title;
    if (subEl) subEl.textContent = preset.sub;
    if (proofEl) proofEl.textContent = preset.proof;
    (preset.pills || []).forEach(function(label, idx) {
      var pill = $('#quiz-entry-pill-' + (idx + 1));
      if (pill) pill.textContent = label;
    });
    root.setAttribute('data-quiz-preset', quiz.preset);
  }

  /* ===== Mixed Recipe Helpers ===== */
  function splitBags(totalBags, recipeCount) {
    if (recipeCount <= 1) return [totalBags];
    var base = Math.floor(totalBags / recipeCount);
    var remainder = totalBags % recipeCount;
    var splits = [];
    for (var i = 0; i < recipeCount; i++) {
      splits.push(base + (i < remainder ? 1 : 0));
    }
    return splits;
  }

  function buildRecipeBags(recipes, totalBags) {
    var splits = splitBags(totalBags, recipes.length);
    var map = {};
    for (var i = 0; i < recipes.length; i++) {
      map[recipes[i]] = splits[i];
    }
    return map;
  }

  function calcMixedMonthly(recipeBags, priceFn) {
    var total = 0;
    var totalBags = sumRecipeBags(recipeBags);
    for (var r in recipeBags) {
      total += recipeBags[r] * priceFn(r, totalBags);
    }
    return roundMoney(total);
  }

  function sumRecipeBags(recipeBags) {
    var total = 0;
    if (!recipeBags) return total;
    for (var r in recipeBags) total += parseInt(recipeBags[r], 10) || 0;
    return total;
  }

  function aggregateRecipeBagsForDogs(dogList) {
    var aggregate = {};
    (dogList || []).forEach(function(d) {
      var recipeBags = d.recipeBags && typeof d.recipeBags === 'object'
        ? d.recipeBags
        : null;
      if (recipeBags) {
        for (var r in recipeBags) {
          aggregate[r] = (aggregate[r] || 0) + (parseInt(recipeBags[r], 10) || 0);
        }
      } else {
        var recipe = d.recipe || 'chicken_rice';
        aggregate[recipe] = (aggregate[recipe] || 0) + (parseInt(d.bagsPerMonth, 10) || 0);
      }
    });
    return aggregate;
  }

  function calcDogFoodWithHouseholdBags(d, priceFn, householdBags) {
    if (!d) return 0;
    var recipeBags = d.recipeBags && typeof d.recipeBags === 'object' ? d.recipeBags : null;
    if (recipeBags) {
      var mixedTotal = 0;
      for (var r in recipeBags) mixedTotal += (parseInt(recipeBags[r], 10) || 0) * priceFn(r, householdBags);
      return mixedTotal;
    }
    var bags = parseInt(d.bagsPerMonth, 10) || 0;
    return bags * priceFn(d.recipe, householdBags);
  }

  /* Health issue → recipe recommendation mapping */
  var DEFAULT_RECIPE_MIX = ['chicken_rice', 'beef_rice', 'pork_rice', 'surf_turf', 'farmyard_feast', 'coastal_blend'];
  var MAX_RECIPE_SELECTIONS = 6;
  var recipeSelectionTouched = false;
  var recipeEditReturnStep = 0;
  var recipeAllergens = {
    chicken_rice: ['chicken', 'pork'],
    beef_rice: ['beef'],
    pork_rice: ['pork'],
    surf_turf: ['beef', 'fish'],
    farmyard_feast: ['chicken', 'pork', 'fish'],
    coastal_blend: ['fish']
  };
  var allergenNames = {
    chicken: 'chicken',
    pork: 'pork',
    beef: 'beef',
    fish: 'fish'
  };
  var healthRecipeMap = {
    sensitive_stomach: 'chicken_rice',
    allergies: 'chicken_rice',
    obesity: 'farmyard_feast',
    skin_coat: 'coastal_blend',
    joint_problems: 'surf_turf',
    dental: 'farmyard_feast'
  };
  var healthPriority = ['allergies', 'sensitive_stomach', 'obesity', 'skin_coat', 'joint_problems', 'dental'];
  var healthReasons = {
    sensitive_stomach: 'sensitive stomach',
    allergies: 'allergies',
    obesity: 'weight management',
    skin_coat: 'skin & coat health',
    joint_problems: 'joint support',
    dental: 'dental health'
  };
  var healthRecipeReasons = {
    sensitive_stomach: 'Recommended for sensitive tummies',
    allergies: 'Allergy-filtered',
    obesity: 'Recommended for weight management',
    skin_coat: 'Recommended for skin & coat health',
    joint_problems: 'Recommended for joint support',
    dental: 'Recommended for dental health'
  };
  var healthRecipeMixMap = {
    sensitive_stomach: ['chicken_rice', 'farmyard_feast', 'surf_turf', 'coastal_blend'],
    obesity: ['farmyard_feast', 'chicken_rice', 'coastal_blend', 'surf_turf'],
    skin_coat: ['coastal_blend', 'surf_turf', 'chicken_rice', 'farmyard_feast'],
    joint_problems: ['surf_turf', 'coastal_blend', 'chicken_rice', 'farmyard_feast'],
    dental: ['farmyard_feast', 'chicken_rice', 'surf_turf', 'coastal_blend']
  };

  function uniqueRecipeList(list) {
    var out = [];
    var source = Array.isArray(list) ? list : [];
    for (var i = 0; i < source.length; i++) {
      if (source[i] && out.indexOf(source[i]) === -1) out.push(source[i]);
    }
    return out;
  }

  function isAllergyFilteringActive(source) {
    var issues = Array.isArray(source && source.healthIssues) ? source.healthIssues : quiz.healthIssues;
    var allergens = Array.isArray(source && source.allergyIngredients) ? source.allergyIngredients : quiz.allergyIngredients;
    return issues.indexOf('allergies') !== -1 && uniqueRecipeList(allergens).length > 0;
  }

  function blockedAllergensForRecipe(recipe, allergens) {
    var blocked = uniqueRecipeList(allergens);
    var recipeBlocked = recipeAllergens[recipe] || [];
    return blocked.filter(function(allergen) { return recipeBlocked.indexOf(allergen) !== -1; });
  }

  function allergySafeRecipeMix(allergens) {
    var blocked = uniqueRecipeList(allergens);
    if (!blocked.length) return DEFAULT_RECIPE_MIX.slice();
    return DEFAULT_RECIPE_MIX.filter(function(recipe) {
      return blockedAllergensForRecipe(recipe, blocked).length === 0;
    });
  }

  function allergyIngredientLabel(allergens) {
    var labels = uniqueRecipeList(allergens).map(function(a) { return allergenNames[a] || a; });
    if (!labels.length) return '';
    return labels.length === 1 ? labels[0] : labels.slice(0, -1).join(', ') + ' & ' + labels[labels.length - 1];
  }

  function recipeExclusionReason(recipe) {
    var ageMonths = quiz.ageUnit === 'months' ? Number(quiz.age || 0) : Number(quiz.age || 0) * 12;
    if ((recipe === 'beef_rice' || recipe === 'pork_rice') && ageMonths > 0 && ageMonths < 12) {
      return 'Available for adult dogs 1 year and older';
    }
    if (!isAllergyFilteringActive()) return '';
    var blocked = blockedAllergensForRecipe(recipe, quiz.allergyIngredients);
    if (!blocked.length) return '';
    return 'Contains ' + allergyIngredientLabel(blocked);
  }

  function recommendedRecipeMix() {
    if (quiz.healthIssues.indexOf('allergies') !== -1) return allergySafeRecipeMix(quiz.allergyIngredients);
    var mix = [];
    for (var i = 0; i < healthPriority.length; i++) {
      var issue = healthPriority[i];
      if (issue === 'allergies' || quiz.healthIssues.indexOf(issue) === -1) continue;
      mix = mix.concat(healthRecipeMixMap[issue] || (healthRecipeMap[issue] ? [healthRecipeMap[issue]] : []));
    }
    mix = uniqueRecipeList(mix.concat(DEFAULT_RECIPE_MIX));
    return mix.slice(0, MAX_RECIPE_SELECTIONS);
  }

  function starterRecipeMixFor(source) {
    var savedRecipes = uniqueRecipeList(source && source.recipes);
    var issues = Array.isArray(source && source.healthIssues) ? source.healthIssues : [];
    if (issues.indexOf('allergies') !== -1) {
      var safeMix = allergySafeRecipeMix(source && source.allergyIngredients);
      return safeMix.length ? safeMix : [];
    }
    /* Preserve ANY explicit saved selection — including a deliberate single
       recipe. Restoring used to rebuild a 4-recipe mix for customers who had
       narrowed down to exactly 1, silently changing their bag counts/total. */
    if (savedRecipes.length >= 1) return savedRecipes.slice(0, MAX_RECIPE_SELECTIONS);
    var mix = [];
    for (var i = 0; i < healthPriority.length; i++) {
      var issue = healthPriority[i];
      if (issue === 'allergies' || issues.indexOf(issue) === -1) continue;
      mix = mix.concat(healthRecipeMixMap[issue] || (healthRecipeMap[issue] ? [healthRecipeMap[issue]] : []));
    }
    var savedPrimary = source && source.recipe;
    if (savedPrimary) mix.push(savedPrimary);
    return uniqueRecipeList(mix.concat(DEFAULT_RECIPE_MIX)).slice(0, MAX_RECIPE_SELECTIONS);
  }

  function showRecipeNotice(message) {
    var maxMsg = $('#quiz-recipe-max-msg');
    if (!maxMsg) return;
    maxMsg.textContent = message;
    maxMsg.hidden = !message;
  }

  function updateRecipeCards(primaryRecommendation) {
    var recipeScreen = root.querySelector('[data-screen="9"]');
    if (!recipeScreen) return;
    recipeScreen.querySelectorAll('.quiz-app__recipe-rec-badge').forEach(function(b) { b.remove(); });
    recipeScreen.querySelectorAll('[data-recipe]').forEach(function(c) {
      var recipe = c.dataset.recipe;
      var exclusionReason = recipeExclusionReason(recipe);
      var isSelected = quiz.recipes.indexOf(recipe) !== -1;
      c.classList.toggle('is-on', isSelected);
      c.classList.toggle('is-excluded', !!exclusionReason);
      c.setAttribute('aria-disabled', exclusionReason ? 'true' : 'false');
      if (exclusionReason) c.dataset.exclusionReason = exclusionReason;
      else delete c.dataset.exclusionReason;
      if (primaryRecommendation && recipe === primaryRecommendation && !exclusionReason) {
        var badge = document.createElement('span');
        badge.className = 'quiz-app__recipe-rec-badge';
        var reasonIssue = quiz.healthIssues.indexOf('allergies') !== -1 ? 'allergies' : quiz.healthIssues[0];
        badge.textContent = healthRecipeReasons[reasonIssue] || 'Best match';
        c.insertBefore(badge, c.firstChild);
      }
    });
  }

  function applyRecipeSelection(recipes, primaryRecommendation) {
    var next = uniqueRecipeList(recipes).slice(0, MAX_RECIPE_SELECTIONS);
    if (!next.length && !isAllergyFilteringActive()) next = DEFAULT_RECIPE_MIX.slice(0, MAX_RECIPE_SELECTIONS);
    next = next.filter(function(recipe) { return !recipeExclusionReason(recipe); });
    quiz.recipes = next;
    quiz.recipe = primaryRecommendation && next.indexOf(primaryRecommendation) !== -1 ? primaryRecommendation : (next[0] || '');
    updateRecipeCards(primaryRecommendation);
    updateRecipeCount();
  }

  function applyAutoRecipeSelection() {
    if (recipeSelectionTouched) {
      applyRecipeSelection(quiz.recipes, quiz.recipe);
      return;
    }
    var autoMix = recommendedRecipeMix();
    applyRecipeSelection(autoMix, autoMix[0]);
    showRecipeNotice('');
  }

  /* Selected treats for upsell screen */
  var selectedTreats = [];
  var pendingCheckoutConfig = null;

  function ensureQuizAttributionFallback() {
    if (window.McDuffyAttribution && typeof window.McDuffyAttribution.context === 'function') {
      try {
        if (typeof window.McDuffyAttribution.refresh === 'function') {
          window.McDuffyAttribution.refresh();
        }
      } catch(e) {}
      return;
    }

    var storageKey = 'mcduffy_attribution';
    var cookieDays = 90;
    var paramKeys = [
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id',
      'campaign_id', 'adset_id', 'ad_id', 'placement', 'fbclid', 'gclid',
      'mcd_source', 'mcd_medium', 'mcd_campaign', 'mcd_content', 'mcd_term', 'mcd_campaign_id'
    ];

    function nowIso() {
      return new Date().toISOString();
    }

    function safeJsonParse(value, fallback) {
      try { return JSON.parse(value); } catch(e) { return fallback; }
    }

    function readStored() {
      try { return safeJsonParse(localStorage.getItem(storageKey) || '{}', {}); } catch(e) { return {}; }
    }

    function writeStored(value) {
      try { localStorage.setItem(storageKey, JSON.stringify(value)); } catch(e) {}
    }

    function getCookie(name) {
      try {
        var escaped = name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&');
        var match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : '';
      } catch(e) {
        return '';
      }
    }

    function setCookie(name, value) {
      try {
        var expires = new Date(Date.now() + cookieDays * 864e5).toUTCString();
        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
      } catch(e) {}
    }

    function collectParams() {
      var params;
      var out = {};
      try {
        params = new URLSearchParams(window.location.search || '');
      } catch(e) {
        return out;
      }
      paramKeys.forEach(function(key) {
        var value = params.get(key);
        if (value) out[key] = value;
      });
      return out;
    }

    function hasAdParams(params) {
      return Object.keys(params || {}).some(function(key) {
        return /^utm_/.test(key) || /^mcd_/.test(key) || key === 'fbclid' || key === 'gclid' || key === 'campaign_id' || key === 'adset_id' || key === 'ad_id';
      });
    }

    function ensureFbc(params) {
      var existing = getCookie('_fbc');
      if (existing) return existing;
      if (!params || !params.fbclid) return '';
      var fbc = 'fb.1.' + Date.now() + '.' + params.fbclid;
      setCookie('_fbc', fbc);
      return fbc;
    }

    function buildTouch(params) {
      return {
        captured_at: nowIso(),
        landing_page: window.location.href,
        path: window.location.pathname,
        referrer: document.referrer || '',
        utm_source: params.utm_source || params.mcd_source || '',
        utm_medium: params.utm_medium || params.mcd_medium || '',
        utm_campaign: params.utm_campaign || params.mcd_campaign || '',
        utm_content: params.utm_content || params.mcd_content || '',
        utm_term: params.utm_term || params.mcd_term || '',
        utm_id: params.utm_id || params.mcd_campaign_id || '',
        campaign_id: params.campaign_id || params.mcd_campaign_id || '',
        adset_id: params.adset_id || '',
        ad_id: params.ad_id || '',
        placement: params.placement || '',
        fbclid: params.fbclid || '',
        gclid: params.gclid || ''
      };
    }

    function refreshAttribution() {
      var stored = readStored();
      var params = collectParams();
      var fbp = getCookie('_fbp');
      var fbc = ensureFbc(params);

      if (hasAdParams(params)) {
        var touch = buildTouch(params);
        stored.first_touch = stored.first_touch || touch;
        stored.last_touch = touch;
      } else {
        stored.first_touch = stored.first_touch || {
          captured_at: nowIso(),
          landing_page: window.location.href,
          path: window.location.pathname,
          referrer: document.referrer || '',
          utm_source: '',
          utm_medium: '',
          utm_campaign: '',
          utm_content: '',
          utm_term: '',
          utm_id: '',
          campaign_id: '',
          adset_id: '',
          ad_id: '',
          placement: '',
          fbclid: '',
          gclid: ''
        };
      }

      stored.fbp = fbp || stored.fbp || '';
      stored.fbc = fbc || stored.fbc || '';
      stored.updated_at = nowIso();
      writeStored(stored);
      return stored;
    }

    function eventId(eventName) {
      var cleanName = String(eventName || 'event').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
      return 'mcduffy_' + cleanName + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
    }

    function flattened(stored) {
      stored = stored || readStored();
      var touch = stored.last_touch || stored.first_touch || {};
      return {
        attribution_source: touch.utm_source || '',
        attribution_medium: touch.utm_medium || '',
        attribution_campaign: touch.utm_campaign || '',
        attribution_content: touch.utm_content || '',
        attribution_term: touch.utm_term || '',
        attribution_campaign_id: touch.campaign_id || touch.utm_id || '',
        attribution_adset_id: touch.adset_id || '',
        attribution_ad_id: touch.ad_id || '',
        attribution_placement: touch.placement || '',
        landing_page: touch.landing_page || window.location.href,
        referrer: touch.referrer || document.referrer || ''
      };
    }

    function context(eventName) {
      var stored = refreshAttribution();
      return {
        event_id: eventId(eventName),
        attribution: stored,
        fbp: stored.fbp || getCookie('_fbp') || '',
        fbc: stored.fbc || getCookie('_fbc') || '',
        page_url: window.location.href,
        referrer: document.referrer || '',
        flat: flattened(stored)
      };
    }

    window.McDuffyAttribution = {
      refresh: refreshAttribution,
      get: function() { return refreshAttribution(); },
      context: context,
      eventId: eventId,
      flat: function() { return flattened(refreshAttribution()); },
      debug: function() {
        var data = refreshAttribution();
        try {
          console.log('[McDuffy Attribution]', data);
          if (console.table) console.table(flattened(data));
        } catch(e) {}
        return data;
      }
    };

    refreshAttribution();
    try {
      if (new URLSearchParams(window.location.search || '').get('mcdebug') === 'attribution') {
        window.McDuffyAttribution.debug();
      }
    } catch(e) {}
  }

  ensureQuizAttributionFallback();

  function normalizeTreatBilling(value) {
    var billing = String(value || '').toLowerCase().replace(/[\s-]+/g, '_');
    return billing === 'one_time' || billing === 'first_box_only' || billing === 'first_order_only'
      ? 'one_time'
      : 'subscription';
  }

  function isRecurringTreat(treat) {
    if (treat && treat.recurring === false) return false;
    return normalizeTreatBilling(treat && treat.billing) !== 'one_time';
  }

  function treatBillingLabel(treat) {
    return isRecurringTreat(treat) ? 'Monthly add-on' : 'First box only';
  }

  /* ===== Tracking Helpers (Meta Pixel + GA4) ===== */
  var quizCompleted = false; /* set true on results / checkout to suppress QuizDropoff */
  function trackingContext(eventName, eventId) {
    try {
      if (window.McDuffyAttribution && typeof window.McDuffyAttribution.context === 'function') {
        var ctx = window.McDuffyAttribution.context(eventName || 'QuizEvent');
        if (eventId) ctx.event_id = eventId;
        return ctx;
      }
    } catch(e) {}
    return {
      event_id: eventId || ('mcduffy_' + String(eventName || 'quiz').toLowerCase().replace(/[^a-z0-9]+/g, '_') + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10)),
      attribution: {},
      fbp: '',
      fbc: '',
      page_url: window.location.href,
      referrer: document.referrer || '',
      flat: {}
    };
  }

  function enrichTrackingPayload(eventName, data, eventId) {
    var ctx = trackingContext(eventName, eventId);
    var payload = Object.assign({}, data || {}, ctx.flat || {});
    payload.event_id = eventId || payload.event_id || ctx.event_id;
    payload.quiz_preset = quiz.preset || '';
    payload.page_url = window.location.href;
    payload.referrer = document.referrer || '';
    return { payload: payload, context: ctx };
  }

  function backendTrackingPayload(eventName, eventId) {
    var ctx = trackingContext(eventName, eventId);
    return {
      event_id: eventId || ctx.event_id,
      attribution: ctx.attribution || {},
      fbp: ctx.fbp || '',
      fbc: ctx.fbc || '',
      page_url: window.location.href,
      referrer: document.referrer || '',
      quiz_preset: quiz.preset || ''
    };
  }

  function trackFB(type, eventName, data) {
    var enriched = enrichTrackingPayload(eventName, data || {}, data && data.event_id);
    var payload = enriched.payload;
    var eventOptions = payload.event_id ? { eventID: payload.event_id } : undefined;
    if (typeof fbq === 'function') {
      if (type === 'custom') fbq('trackCustom', eventName, payload, eventOptions);
      else fbq('track', eventName, payload, eventOptions);
    }
    /* Mirror to GA4 as snake_case event */
    if (typeof gtag === 'function') {
      var gaName = eventName.replace(/([A-Z])/g, '_$1').toLowerCase().replace(/^_/, '');
      gtag('event', gaName, payload);
    }
    return payload.event_id;
  }

  function trackQuizEvent(eventName, data) {
    var enriched = enrichTrackingPayload(eventName, data || {}, data && data.event_id);
    var payload = enriched.payload;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    } catch(e) {}
    try {
      if (window.McDuffyCommerceTrack && typeof window.McDuffyCommerceTrack === 'function') {
        var commerceName = eventName.replace(/([a-z0-9])([A-Z])/g, '$1_$2').replace(/[\s-]+/g, '_').toLowerCase();
        window.McDuffyCommerceTrack(commerceName, payload, { pushPixels: false });
      }
    } catch(e) {}
    return trackFB('custom', eventName, payload);
  }

  var quizCommerceOnce = {};
  function trackQuizEventOnce(key, eventName, data) {
    if (quizCommerceOnce[key]) return '';
    quizCommerceOnce[key] = true;
    return trackQuizEvent(eventName, data || {});
  }

  /* ===== Multi-Dog State ===== */
  var dogCount = 1;        /* 1 to MAX_DOGS */
  var dogNames = [];       /* Names collected on screen 1 */
  var dogs = [];           /* Completed dog profiles with calculated results */
  var activeDogIndex = 0;  /* Which dog we're currently configuring (0 or 1) */
  var MAX_DOGS = 10;

  function applyHouseholdAnswersFromFirstDog() {
    var firstDog = dogs[0];
    if (!firstDog) return;
    quiz.currentFoodType = firstDog.currentFoodType || quiz.currentFoodType || '';
    quiz.currentFoodBrand = firstDog.currentFoodBrand || quiz.currentFoodBrand || '';
    var currentFoodType = $('#quiz-current-food-type');
    if (currentFoodType) currentFoodType.value = quiz.currentFoodType;
    var currentFoodBrand = $('#quiz-current-food-brand');
    if (currentFoodBrand) currentFoodBrand.value = quiz.currentFoodBrand;
  }

  /* Track if breed was pre-filled from URL */
  var breedFromUrl = false;
  try {
    var breedParam = new URLSearchParams(window.location.search).get('breed');
    if (breedParam) {
      quiz.breed = breedParam;
      breedFromUrl = true;
    }
  } catch(e) {}

  /* Cached results */
  var results = {
    dailyGrams: 0, dailyCals: 0, bagsPerMonth: 0,
    otMonthly: 0, subMonthly: 0, savings: 0
  };

  /* ===== Helpers ===== */
  function formatPeso(n) {
    var value = Math.round((Number(n) || 0) * 100) / 100;
    var hasCentavos = Math.abs(value - Math.round(value)) > 0.001;
    return '\u20B1' + value.toLocaleString('en-PH', {
      minimumFractionDigits: hasCentavos ? 2 : 0,
      maximumFractionDigits: hasCentavos ? 2 : 0
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function gramsPerDay(recipe, weightKg) {
    var t = feedingGuides[recipe] || feedingGuides.surf_turf;
    if (!weightKg || weightKg <= 0) return 0;
    if (weightKg <= t[0].kg) return t[0].g[1] * Math.pow(weightKg / t[0].kg, 0.75);
    for (var i = 0; i < t.length - 1; i++) {
      var a = t[i], b = t[i + 1];
      if (weightKg >= a.kg && weightKg <= b.kg) {
        var r = (weightKg - a.kg) / (b.kg - a.kg);
        return Math.round(a.g[1] + r * (b.g[1] - a.g[1]));
      }
    }
    return t[t.length - 1].g[1];
  }

  function adjustGrams(base, q) {
    var g = base;
    // Graduated puppy multiplier: young puppies need 2-2.5x adult amount,
    // decreasing as they mature toward adulthood
    var ageInMonths = q.ageUnit === 'months' ? q.age : q.age * 12;
    if (ageInMonths < 12) {
      if (ageInMonths <= 4) g *= 2.5;
      else if (ageInMonths <= 6) g *= 2.25;
      else if (ageInMonths <= 9) g *= 1.75;
      else g *= 1.5;
    }
    if (q.condition === 'underweight') g *= 1.15;
    if (q.condition === 'overweight') g *= 0.85;
    if (q.activity === 'low') g *= 0.9;
    if (q.activity === 'high') g *= 1.1;
    if (q.activity === 'athlete') g *= 1.1;
    if (q.neutered === 'yes' && ageInMonths >= 12) g *= 0.95;
    return Math.round(g);
  }

  function adjustedRecipeGrams(recipe, q) {
    return adjustGrams(gramsPerDay(recipe, q.weight), q);
  }

  function buildRecipePortionPlan(recipes, q, minQty) {
    var cleanRecipes = [];
    var source = recipes && recipes.length ? recipes : [q.recipe || 'chicken_rice'];
    for (var i = 0; i < source.length; i++) {
      if (source[i] && cleanRecipes.indexOf(source[i]) === -1) cleanRecipes.push(source[i]);
    }
    if (!cleanRecipes.length) cleanRecipes.push('chicken_rice');

    var daysPerRecipe = 30 / cleanRecipes.length;
    var recipeBags = {};
    var recipeGrams = {};
    var targetMonthlyGrams = 0;

    for (var ri = 0; ri < cleanRecipes.length; ri++) {
      var recipe = cleanRecipes[ri];
      var dailyForRecipe = adjustedRecipeGrams(recipe, q);
      recipeGrams[recipe] = dailyForRecipe;
      targetMonthlyGrams += dailyForRecipe * daysPerRecipe;
      recipeBags[recipe] = Math.max(1, Math.ceil((dailyForRecipe * daysPerRecipe) / BAG_GRAMS));
    }

    var bags = sumRecipeBags(recipeBags);
    var minimum = parseInt(minQty, 10) || 0;
    var addIndex = 0;
    while (bags < minimum) {
      recipeBags[cleanRecipes[addIndex % cleanRecipes.length]] += 1;
      bags += 1;
      addIndex += 1;
    }

    return {
      recipes: cleanRecipes,
      recipeBags: recipeBags,
      recipeGrams: recipeGrams,
      bags: bags,
      targetDailyGrams: Math.round(targetMonthlyGrams / 30),
      deliverableDailyGrams: Math.round((bags * BAG_GRAMS) / 30)
    };
  }

  /* ===== Pouch Mockup — SVG-overlay-on-baked-photo (FD architecture) =====
     Required reading: POUCH-RENDERER-SPEC.md (project root).
     Updates personalized label rendered by snippets/mcduffy-pouch-mockup.liquid.
     The snippet renders SVG <text data-overlay="..."> elements; this function
     swaps their textContent for the customer's dog. All instances on the page
     update in lockstep (e.g. main pouch + modal mini pouch). */
  var POUCH_INGREDIENTS = {
    chicken_rice:   'CHICKEN • SWEET POTATO • SPINACH',
    surf_turf:      'BEEF • SARDINE • SWEET POTATO',
    farmyard_feast: 'PORK • CHICKEN • SQUASH',
    coastal_blend:  'TILAPIA • CATFISH • CARROTS'
  };

  /* "1 Pack Per Day" / "0.5 Packs Per Day" / "1.5 Packs Per Day" — full line.
     packsPerDay must already be the daily count (output of pickPouchPlan). */
  function packsLabel(packsPerDay) {
    var v = parseFloat(packsPerDay);
    if (isNaN(v) || v <= 0) return '1 Pack Per Day';
    var rounded = Math.round(v * 2) / 2;
    if (rounded < 0.5) rounded = 0.5;
    var pretty = (rounded % 1 === 0) ? String(rounded) : rounded.toFixed(1);
    return pretty + (rounded === 1 ? ' Pack Per Day' : ' Packs Per Day');
  }

  /* Date helpers for label */
  function pouchTodayStr() {
    var d = new Date();
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[d.getMonth()] + ' ' + d.getDate() + ' ' + d.getFullYear();
  }
  function pouchDefaultBatch() {
    var d = new Date();
    var doy = Math.floor((d - new Date(d.getFullYear(), 0, 0)) / 86400000);
    return 'M-' + d.getFullYear() + '-' + String(doy).padStart(3, '0');
  }

  /* Find all [data-overlay="key"] elements within a root and set their text */
  function setOverlayIn(rootEl, key, value) {
    if (!rootEl) return;
    var nodes = rootEl.querySelectorAll('[data-overlay="' + key + '"]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = value;
  }

  function normalizeRecipeList(rawDog) {
    var dog = rawDog || {};
    var source = (dog.recipes && dog.recipes.length) ? dog.recipes : (dog.recipe ? [dog.recipe] : []);
    var clean = [];
    for (var i = 0; i < source.length; i++) {
      if (source[i] && clean.indexOf(source[i]) === -1) clean.push(source[i]);
    }
    if (!clean.length) clean.push('chicken_rice');
    return clean;
  }

  function paintPouchMockup(rootEl, opts) {
    if (!rootEl) return;
    opts = opts || {};

    var recipe = opts.recipe || 'chicken_rice';
    var dogName = displayDogName(opts.dogName);
    var dailyG = opts.dailyG || 0;
    var pouchSize = opts.pouchSize || 500;
    var packsPerDay = opts.packsPerDay;
    var date = opts.date || pouchTodayStr();
    var batch = opts.batch || pouchDefaultBatch();

    if (typeof packsPerDay === 'undefined' && dailyG && pouchSize) {
      packsPerDay = Math.max(0.5, Math.round((dailyG / pouchSize) * 2) / 2);
    }
    if (typeof packsPerDay === 'undefined' || packsPerDay === null) packsPerDay = 1;

    var recipeTitle = recipeNames[recipe] || 'Chicken It Up';
    var ingredients = POUCH_INGREDIENTS[recipe] || POUCH_INGREDIENTS.chicken_rice;
    var possessive = possessiveDogName(dogName);

    rootEl.setAttribute('data-recipe', recipe);
    rootEl.setAttribute('data-dog-name', dogName);
    var photo = rootEl.querySelector('[data-pouch-photo]');
    if (photo) photo.alt = 'McDuffy pouch personalized for ' + dogName;
    setOverlayIn(rootEl, 'name-poss', possessive);
    setOverlayIn(rootEl, 'recipe-line', recipeTitle + ' Recipe');
    setOverlayIn(rootEl, 'ingredients', ingredients);
    setOverlayIn(rootEl, 'feed-name', 'FEED ' + dogName.toUpperCase());
    setOverlayIn(rootEl, 'packs', packsLabel(packsPerDay));
    setOverlayIn(rootEl, 'date', date);
    setOverlayIn(rootEl, 'batch', batch);
    fitDogNameFont(rootEl, possessive);
  }

  function resetHeroPouchStage(stage) {
    if (!stage) return null;
    stage.classList.remove('quiz-r__pouch-stage--dogs');

    var wrapped = stage.querySelector('.mc-dog-pouch-grid, .mc-pouch-fan');
    if (wrapped) {
      var firstWrappedPouch = wrapped.querySelector('.mc-pouch');
      if (firstWrappedPouch) stage.appendChild(firstWrappedPouch);
      wrapped.remove();
    }

    var pouches = stage.querySelectorAll('.mc-pouch');
    var keeper = pouches[0] || null;
    if (keeper && keeper.parentNode !== stage) stage.appendChild(keeper);
    for (var i = 0; i < pouches.length; i++) {
      if (pouches[i] !== keeper) pouches[i].remove();
    }
    return keeper;
  }

  /* Long-name auto-shrink: if the dog's full possessive ("Bartholomew's")
     exceeds the label's available width, shrink the SVG text font-size. */
  function fitDogNameFont(rootEl, possessiveText) {
    var nameNodes = rootEl.querySelectorAll('[data-overlay="name-poss"]');
    for (var i = 0; i < nameNodes.length; i++) {
      var n = nameNodes[i];
      // Reset to default 80, then scale down if too long.
      // Empirically tuned — Inter 800 at 80px fits ~10 chars in 588px viewBox width.
      var len = (possessiveText || '').length;
      var size = 80;
      if (len > 10) size = Math.max(46, Math.floor(80 * 10 / len));
      n.setAttribute('font-size', String(size));
    }
  }

  /* updatePouchMockup — the single entry point for refreshing every pouch
     instance on the page (main + modal + 3-fan).
     Backward-compatible signature with the old impl. */
  function updatePouchMockup(opts) {
    opts = opts || {};
    var mockups = document.querySelectorAll('[data-pouch-mockup]');
    if (!mockups.length) return;

    var recipe   = opts.recipe   || quiz.recipe || 'chicken_rice';
    var dogName  = opts.dogName  || quiz.name   || 'Your dog';
    var weightKg = opts.weightKg || quiz.weight || '';
    var packsPerDay = opts.packsPerDay; // pickPouchPlan() output
    var dailyG   = opts.dailyG   || 0;
    var pouchSize = opts.pouchSize || 500;
    var date     = opts.date     || pouchTodayStr();
    var batch    = opts.batch    || pouchDefaultBatch();

    for (var i = 0; i < mockups.length; i++) {
      if (mockups[i].closest && mockups[i].closest('.mc-dog-pouch-grid, .mc-pouch-fan')) continue;
      paintPouchMockup(mockups[i], {
        recipe: recipe,
        dogName: dogName,
        weightKg: weightKg,
        dailyG: dailyG,
        pouchSize: pouchSize,
        packsPerDay: packsPerDay,
        date: date,
        batch: batch
      });
    }
  }

  /* Calibration mode toggle — add ?calibrate=1 to URL to see cover rect outlines */
  (function applyCalibrateMode() {
    try {
      if (new URLSearchParams(location.search).get('calibrate') === '1') {
        document.body.classList.add('calibrate');
      }
    } catch (e) { /* no URLSearchParams in old browsers — fine */ }
  })();

  /* ===== Pack-per-day + pouch-size decision algorithm =====
     Returns: { pouchSize, packsPerDay, packsPerWeek, variantSlug, rationale }
     Inputs:  dailyGrams = output of adjustGrams(gramsPerDay(...))
     Rules from user: minimum 0.5 pack/day, never 500g for tiny dogs.
     See POUCH-RENDERER-SPEC.md for the decision tree rationale. */
  function pickPouchPlan(dailyGrams) {
    if (!dailyGrams || dailyGrams <= 0) {
      return { pouchSize: 250, packsPerDay: 0.5, packsPerWeek: 4,
               variantSlug: '250g',
               rationale: 'Fallback: no weight provided' };
    }
    function snap(n) { return Math.max(0.5, Math.round(n * 2) / 2); }

    // Boundary 1: under 187g/day → 250g pouch only (small dog, less waste)
    if (dailyGrams < 187) {
      var p250 = snap(dailyGrams / 250);
      return { pouchSize: 250, packsPerDay: p250,
               packsPerWeek: Math.round(p250 * 7),
               variantSlug: '250g',
               rationale: 'Small dog ' + dailyGrams + 'g/day → 250g pouch' };
    }

    // Boundary 2: 187–375g/day → pick the size that snaps closer
    if (dailyGrams < 375) {
      var s250 = snap(dailyGrams / 250);
      var s500 = snap(dailyGrams / 500);
      var err250 = Math.abs(s250 * 250 - dailyGrams);
      var err500 = Math.abs(s500 * 500 - dailyGrams);
      var pick500 = (err500 < err250) || (err500 === err250 && dailyGrams >= 300);
      return pick500
        ? { pouchSize: 500, packsPerDay: s500,
            packsPerWeek: Math.round(s500 * 7),
            variantSlug: '500g',
            rationale: 'Mid range ' + dailyGrams + 'g/day → 500g (err ' + err500 + 'g)' }
        : { pouchSize: 250, packsPerDay: s250,
            packsPerWeek: Math.round(s250 * 7),
            variantSlug: '250g',
            rationale: 'Mid range ' + dailyGrams + 'g/day → 250g (err ' + err250 + 'g)' };
    }

    // Boundary 3: 375g+ → 500g pouches always
    var p500 = snap(dailyGrams / 500);
    return { pouchSize: 500, packsPerDay: p500,
             packsPerWeek: Math.round(p500 * 7),
             variantSlug: '500g',
             rationale: 'Larger dog ' + dailyGrams + 'g/day → 500g, ' + p500 + ' packs/day' };
  }

  /* ===== 3-fan view — when customer picks 2+ recipes =====
     Clones the hero pouch 2 more times and wraps them in .mc-pouch-fan,
     so each recipe gets its own personalized pouch in a fanned layout.
     Single-recipe customers see the original single pouch unchanged. */
  function renderPouchFan(recipes, opts) {
    var stage = document.getElementById('quiz-r-pouch-stage');
    if (!stage) return;
    opts = opts || {};
    var recipeGrams = opts.recipeGrams || {};
    resetHeroPouchStage(stage);

    if (!recipes || recipes.length < 2) {
      /* Single-recipe — no fan, just refresh the single pouch */
      var singleRecipe = (recipes && recipes[0]) || quiz.recipe;
      var singleDailyG = recipeGrams[singleRecipe] || opts.dailyG;
      var singlePouchPlan = pickPouchPlan(singleDailyG);
      updatePouchMockup({
        recipe: singleRecipe,
        dogName: opts.dogName,
        weightKg: opts.weightKg,
        dailyG: singleDailyG,
        pouchSize: singlePouchPlan.pouchSize || opts.pouchSize,
        packsPerDay: singlePouchPlan.packsPerDay || opts.packsPerDay
      });
      return;
    }

    /* Multi-recipe — build the fan (2 or 3 pouches, capped at 3) */
    var basePouch = stage.querySelector('.mc-pouch');
    if (!basePouch) return;
    var fanCount = Math.min(recipes.length, 3);
    var fan = document.createElement('div');
    fan.className = 'mc-pouch-fan mc-pouch-fan--' + fanCount;
    /* Move the base pouch into the fan, then clone for additional recipes */
    fan.appendChild(basePouch);
    for (var r = 1; r < fanCount; r++) {
      var clone = basePouch.cloneNode(true);
      clone.id = 'mc-pouch-fan-' + r;
      fan.appendChild(clone);
    }
    stage.appendChild(fan);

    /* Update each pouch with its recipe.
       Note: updatePouchMockup updates ALL pouches on page in lockstep, so we
       can't use it here. Instead, set each pouch's overlays directly. */
    var pouches = fan.querySelectorAll('.mc-pouch');
    for (var p = 0; p < pouches.length; p++) {
      var pRecipe = recipes[p] || recipes[0];
      var pDailyG = recipeGrams[pRecipe] || opts.dailyG;
      var pPlan = pickPouchPlan(pDailyG);
      paintPouchMockup(pouches[p], {
        recipe: pRecipe,
        dogName: opts.dogName,
        dailyG: pDailyG,
        pouchSize: pPlan.pouchSize || opts.pouchSize,
        packsPerDay: pPlan.packsPerDay || opts.packsPerDay,
        date: pouchTodayStr(),
        batch: pouchDefaultBatch()
      });
    }
  }

  /* Multi-dog plans need one personalized pouch per dog. This preserves the
     SVG-overlay renderer, but swaps the single/fan hero into a dog-by-dog grid. */
  function renderDogPouches(dogList) {
    var stage = document.getElementById('quiz-r-pouch-stage');
    if (!stage) return;
    var dogsToRender = dogList || [];

    if (dogsToRender.length < 2) {
      var onlyDog = dogsToRender[0] || dogs[0] || {};
      renderPouchFan(normalizeRecipeList(onlyDog), {
        dogName: onlyDog.name || quiz.name,
        weightKg: onlyDog.weight || quiz.weight,
        dailyG: onlyDog.dailyGrams,
        pouchSize: onlyDog.pouchSize || 500,
        packsPerDay: onlyDog.packsPerDay
      });
      return;
    }

    var basePouch = resetHeroPouchStage(stage);
    if (!basePouch) return;
    stage.classList.add('quiz-r__pouch-stage--dogs');

    var specs = [];
    for (var si = 0; si < dogsToRender.length; si++) {
      var specDog = dogsToRender[si] || {};
      var specRecipes = normalizeRecipeList(specDog);
      for (var sr = 0; sr < specRecipes.length; sr++) {
        specs.push({ dog: specDog, dogIndex: si, recipe: specRecipes[sr] });
      }
    }

    var grid = document.createElement('div');
    var countClass = Math.min(specs.length, 6);
    grid.className = 'mc-dog-pouch-grid mc-dog-pouch-grid--' + countClass;

    for (var i = 0; i < specs.length; i++) {
      var dog = specs[i].dog || {};
      var dogName = displayDogName(dog.name || dogNames[specs[i].dogIndex] || quiz.name);
      var dogRecipe = specs[i].recipe;
      var recipeDailyG = (dog.recipeGrams && dog.recipeGrams[dogRecipe]) || dog.dailyGrams || 0;
      var recipePouchPlan = pickPouchPlan(recipeDailyG);
      var pouch = i === 0 ? basePouch : basePouch.cloneNode(true);
      pouch.id = 'mc-pouch-dog-' + (specs[i].dogIndex + 1) + '-recipe-' + (i + 1);

      paintPouchMockup(pouch, {
        recipe: dogRecipe,
        dogName: dogName,
        weightKg: dog.weight,
        dailyG: recipeDailyG,
        pouchSize: recipePouchPlan.pouchSize || dog.pouchSize || 500,
        packsPerDay: recipePouchPlan.packsPerDay,
        date: pouchTodayStr(),
        batch: pouchDefaultBatch()
      });

      var card = document.createElement('div');
      card.className = 'mc-dog-pouch-card';
      card.appendChild(pouch);

      var caption = document.createElement('p');
      caption.className = 'mc-dog-pouch-card__caption';
      caption.textContent = dogName + ' · ' + (recipeNames[dogRecipe] || 'Chicken It Up') +
        (recipeDailyG ? ' · ' + recipeDailyG + 'g' : '');
      card.appendChild(caption);
      grid.appendChild(card);
    }

    stage.appendChild(grid);
  }

  /* ===== Portion details modal (bottom-sheet) =====
     Opens from "<dogname>'s portion details" link on Screen 13.
     Reuses the SVG pouch snippet for its mini visual. */
  var __portionPrevFocus = null;

  function getPortionModal() { return document.getElementById('quiz-r-portion-modal'); }
  function getPortionFocusables(modal) {
    return modal.querySelectorAll(
      'button, a[href], [tabindex]:not([tabindex="-1"]), input, select, textarea'
    );
  }

  function openPortionModal() {
    var modal = getPortionModal();
    if (!modal) return;

    var isMultiDogPlan = (typeof dogs !== 'undefined' && dogs.length > 1);
    var d = (typeof dogs !== 'undefined' && dogs[activeDogIndex]) ? dogs[activeDogIndex] : {};
    var packs = d.packsPerDay || (d.dailyGrams ? Math.max(0.5, Math.round((d.dailyGrams / (d.pouchSize || 500)) * 2) / 2) : 1);
    var packsText = packsLabel(packs).replace(/ Per Day$/i, '');
    var leadEl = document.getElementById('quiz-r-modal-lead');
    var captionEl = document.getElementById('quiz-r-modal-caption');

    if (isMultiDogPlan) {
      var allNames = dogs.map(function(md) { return displayDogName(md.name); }).join(' & ');
      var totalDailyG = dogs.reduce(function(sum, md) { return sum + (parseInt(md.dailyGrams, 10) || 0); }, 0);
      var totalBags = dogs.reduce(function(sum, md) { return sum + (parseInt(md.bagsPerMonth, 10) || 0); }, 0);
      var exactPacks = totalDailyG > 0 ? totalDailyG / BAG_GRAMS : 0;
      var exactPacksText = exactPacks ? ((Math.round(exactPacks * 10) / 10) + (Math.round(exactPacks * 10) / 10 === 1 ? ' pack' : ' packs')) : 'custom packs';
      var dogPortionText = dogs.map(function(md) {
        return escapeHtml(displayDogName(md.name)) + ': ' + (parseInt(md.dailyGrams, 10) || 0) + 'g/day';
      }).join(' · ');

      packsText = exactPacksText;
      if (leadEl) {
        leadEl.innerHTML = escapeHtml(allNames) + ' are portioned <strong>separately</strong>. Together, the plan averages <strong id="quiz-r-modal-packs">' +
          exactPacksText + '</strong> per day across <strong>' + totalBags + ' bags/month</strong>. ' + dogPortionText + '.';
      }
      if (captionEl) {
        captionEl.innerHTML = 'Feed separately<br><strong id="quiz-r-modal-packs-handwritten">' + exactPacksText + '</strong><br>total per day' +
          '<svg class="quiz-r-modal__arrow" viewBox="0 0 80 40" aria-hidden="true">' +
            '<path d="M 4 20 Q 40 4 70 22" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round" stroke-dasharray="3 5"/>' +
            '<path d="M 64 16 L 70 22 L 64 26" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>';
      }

      d = dogs[0] || {};
      var modalRecipes = normalizeRecipeList(d);
      var modalRecipe = modalRecipes[0];
      var modalDailyG = (d.recipeGrams && d.recipeGrams[modalRecipe]) || d.dailyGrams || 0;
      var modalPouchPlan = pickPouchPlan(modalDailyG);
      packs = modalPouchPlan.packsPerDay;
      updatePouchMockup({
        recipe: modalRecipe,
        dogName: d.name || quiz.name,
        weightKg: d.weight || quiz.weight,
        dailyG: modalDailyG,
        pouchSize: modalPouchPlan.pouchSize || d.pouchSize || 500,
        packsPerDay: packs
      });
    } else {
      if (leadEl) {
        leadEl.innerHTML = '<span class="quiz-dog-name">' + escapeHtml(displayDogName(d.name || quiz.name)) + '</span> should have ' +
          '<strong id="quiz-r-modal-packs">' + packsText + '</strong> per day. Your trial box will contain ' +
          '<strong id="quiz-r-modal-duration">1 month</strong> of food and a guide to help you transition.';
      }
      if (captionEl) {
        captionEl.innerHTML = 'Feed <span class="quiz-dog-name">' + escapeHtml(displayDogName(d.name || quiz.name)) + '</span><br>' +
          '<strong id="quiz-r-modal-packs-handwritten">' + packsText + '</strong><br>per day' +
          '<svg class="quiz-r-modal__arrow" viewBox="0 0 80 40" aria-hidden="true">' +
            '<path d="M 4 20 Q 40 4 70 22" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round" stroke-dasharray="3 5"/>' +
            '<path d="M 64 16 L 70 22 L 64 26" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>';
      }

      /* Refresh the mini pouch in the modal so it matches the current dog */
      updatePouchMockup({
        recipe: d.recipe || quiz.recipe,
        dogName: d.name || quiz.name,
        weightKg: d.weight || quiz.weight,
        dailyG: d.dailyGrams || 0,
        pouchSize: d.pouchSize || 500,
        packsPerDay: packs
      });
    }

    var packsEl = document.getElementById('quiz-r-modal-packs');
    if (packsEl) packsEl.textContent = packsText;
    var packsHwEl = document.getElementById('quiz-r-modal-packs-handwritten');
    if (packsHwEl) packsHwEl.textContent = packsText;

    var shipEl = document.getElementById('quiz-r-modal-ship-date');
    if (shipEl) shipEl.textContent = 'within 1-2 business days after confirmation';

    __portionPrevFocus = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    /* Focus the close button (first interactive after the title) */
    var sheet = modal.querySelector('.quiz-r-modal__sheet');
    if (sheet) sheet.focus();
  }

  function closePortionModal() {
    var modal = getPortionModal();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    if (__portionPrevFocus && typeof __portionPrevFocus.focus === 'function') {
      __portionPrevFocus.focus();
    }
  }

  /* Wire up event listeners — runs once on page load */
  function initPortionModal() {
    var openBtn = document.getElementById('quiz-r-portion-link');
    if (openBtn) openBtn.addEventListener('click', openPortionModal);

    var modal = getPortionModal();
    if (!modal) return;

    /* Click any [data-modal-close] inside modal to close */
    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', closePortionModal);
    });

    /* ESC + focus trap */
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closePortionModal();
        return;
      }
      if (e.key === 'Tab') {
        var nodes = getPortionFocusables(modal);
        if (!nodes.length) return;
        var first = nodes[0], last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    });
  }
  initPortionModal();

  /* ===== Navigation ===== */
  function normalizeQuizScreenOrder() {
    var screen2 = $('[data-screen="2"]');
    var screen3 = $('[data-screen="3"]');
    if (!screen2 || !screen3) return;

    var screen2Text = (screen2.textContent || '').toLowerCase();
    var screen3Text = (screen3.textContent || '').toLowerCase();
    var screen2LooksLikeContact = screen2Text.indexOf('where should we save') !== -1 || screen2Text.indexOf('your email') !== -1 || screen2Text.indexOf('mobile / viber') !== -1;
    var screen3LooksLikeProfile = screen3Text.indexOf('tell us about') !== -1 && screen3Text.indexOf('age') !== -1;

    if (screen2LooksLikeContact && screen3LooksLikeProfile) {
      screen2.setAttribute('data-screen', '3');
      screen3.setAttribute('data-screen', '2');
      if (screen2.classList.contains('is-active')) {
        screen2.classList.remove('is-active');
        screen3.classList.add('is-active');
      }
      console.info('[McDuffyQuiz] Corrected stale Shopify quiz screen order');
    }
  }

  normalizeQuizScreenOrder();
  var screens = $$('.quiz-app__screen');
  var progressBar = $('#quiz-progress');
  var phaseEls = $$('.quiz-app__phase');
  var nameDisplays = $$('.quiz-dog-name');
  var lastStep = 0; /* track direction for slide animation */
  var isPopState = false; /* flag to prevent pushState during popstate handling */
  var stickyObserver = null;
  var stickyScrollHandler = null;
  var stickyPrimaryCtaVisible = true;
  var scrollRevealObserver = null;
  var scrollRevealSelector = [
    '.quiz-hero-dog',
    '.quiz-app__entry-title',
    '.quiz-app__entry-sub',
    '.quiz-app__entry-pills span',
    '.quiz-app__dog-sentence',
    '.quiz-app__fresh-fact',
    '.quiz-app__heading',
    '.quiz-app__sub',
    '.quiz-app__option',
    '.quiz-app__recipe',
    '.quiz-body-card',
    '.quiz-app__chip',
    '.quiz-app__health-pill',
    '.quiz-priority-option',
    '.quiz-r__hero',
    '.quiz-r__pouch-stage',
    '.quiz-r__plan-reveal',
    '.quiz-r__plan-stat',
    '.quiz-r__mini-cadence > div',
    '.quiz-r__checkout-path-step',
    '.quiz-r__plan-brief',
    '.quiz-r__transition-note',
    '.quiz-r__portion',
    '.quiz-multi-summary',
    '.quiz-app__gift-tier',
    '.quiz-r-feeding',
    '.quiz-r-feeding__info',
    '.quiz-r-social',
    '.quiz-r-social__stars',
    '.quiz-r-social__card',
    '.quiz-r-recipe',
    '.quiz-r-recipe__card',
    '.quiz-r-creds',
    '.quiz-r-creds__item',
    '.quiz-r-cadence',
    '.quiz-r-cadence__step',
    '.quiz-r-cadence__arrow',
    '.quiz-r-guarantee',
    '.quiz-r-delivery',
    '.quiz-r-delivery__step',
    '.quiz-r-delivery__line',
    '.quiz-r-faq__item',
    '.quiz-treats-hero',
    '.quiz-treats-hero__chips span',
    '.quiz-treats__selector-intro',
    '.quiz-treats__gift-card',
    '.quiz-treats-section__head',
    '.quiz-treats__card',
    '.quiz-treats-edu__row',
    '.quiz-treats-reassure',
    '.quiz-treats__ctas'
  ].join(',');

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getScrollRevealObserver() {
    if (scrollRevealObserver || typeof IntersectionObserver === 'undefined') return scrollRevealObserver;
    scrollRevealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('q-scroll-reveal--visible');
        scrollRevealObserver.unobserve(entry.target);
      });
    }, {
      root: root,
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.12
    });
    return scrollRevealObserver;
  }

  function revealVariantFor(el) {
    if (el.matches('.quiz-app__heading, .quiz-app__sub, .quiz-app__entry-title, .quiz-app__entry-sub, .quiz-r__heading, .quiz-treats-section__head')) {
      return 'q-scroll-reveal--text';
    }
    if (el.matches('.quiz-hero-dog, .quiz-r__pouch-stage, .quiz-r-creds__item, .quiz-r-delivery__step, .quiz-r-cadence__step, .quiz-r-cadence__arrow, .quiz-treats-edu__row, .quiz-r-social__stars')) {
      return 'q-scroll-reveal--icon';
    }
    if (el.matches('.quiz-app__option, .quiz-app__recipe, .quiz-body-card, .quiz-app__chip, .quiz-app__health-pill, .quiz-priority-option, .quiz-r-social__card, .quiz-r-recipe__card, .quiz-treats__card, .quiz-treats__gift-card, .quiz-r-faq__item')) {
      return 'q-scroll-reveal--card';
    }
    if (el.matches('.quiz-r-delivery__line')) {
      return 'q-scroll-reveal--line';
    }
    return 'q-scroll-reveal--soft';
  }

  function setupScrollReveals(scope, replay) {
    if (!scope) return;
    var nodes = [];
    if (scope.matches && scope.matches(scrollRevealSelector)) nodes.push(scope);
    nodes = nodes.concat([].slice.call(scope.querySelectorAll(scrollRevealSelector)));
    if (!nodes.length) return;

    var reduce = prefersReducedMotion();
    var observer = getScrollRevealObserver();
    var seen = [];
    nodes.forEach(function(el) {
      if (seen.indexOf(el) !== -1) return;
      seen.push(el);
    });

    seen.forEach(function(el, index) {
      if (el.closest('.quiz-r__sticky, .quiz-ingredients-sheet, .quiz-checkout-review')) return;
      var variant = revealVariantFor(el);
      el.classList.add('q-scroll-reveal', variant);
      el.style.setProperty('--q-reveal-delay', Math.min((index % 7) * 42, 252) + 'ms');

      if (replay) el.classList.remove('q-scroll-reveal--visible');
      if (reduce || !observer) {
        el.classList.add('q-scroll-reveal--visible');
        return;
      }

      observer.unobserve(el);
      observer.observe(el);
    });
  }

  /* Seed initial history entry so step 1 has state */
  history.replaceState({ quizStep: 1 }, '', '');

  /* Browser back button → go back one quiz step */
  window.addEventListener('popstate', function(e) {
    if (e.state && typeof e.state.quizStep === 'number') {
      isPopState = true;
      goTo(e.state.quizStep);
      isPopState = false;
    }
  });

  function goTo(n) {
    if (n < 1) n = 1;
    if (n > quiz.totalSteps) return;

    var direction = n > quiz.step ? 'forward' : 'backward';
    lastStep = quiz.step;
    quiz.step = n;

    /* Push browser history so back button steps through quiz (skip loading screen) */
    if (!isPopState && n !== 12) {
      history.pushState({ quizStep: n }, '', '');
    }

    /* Show/hide screens with directional animation */
    screens.forEach(function(s) {
      s.classList.remove('is-active', 'quiz-slide-forward', 'quiz-slide-backward');
    });
    var target = $('[data-screen="' + n + '"]');
    if (target) {
      target.classList.add('is-active', direction === 'forward' ? 'quiz-slide-forward' : 'quiz-slide-backward');
    }

    /* Hide sticky CTA when leaving results screen */
    var stickyBar = $('#quiz-r-sticky');
    if (stickyBar && n !== 13) {
      stickyBar.classList.remove('is-visible');
      stickyBar.hidden = true;
      if (stickyScrollHandler) {
        root.removeEventListener('scroll', stickyScrollHandler);
        stickyScrollHandler = null;
      }
    }

    /* Phased progress bar: show for steps 1-11, hidden on loading/results/upsell */
    if (progressBar) {
      if (n >= 1 && n <= INPUT_STEPS) {
        progressBar.classList.remove('is-hidden');
        phaseEls.forEach(function(el) {
          var start = parseInt(el.getAttribute('data-phase-start'), 10);
          var end = parseInt(el.getAttribute('data-phase-end'), 10);
          var fill = el.querySelector('.quiz-app__phase-fill');
          el.classList.remove('is-active', 'is-complete');
          if (n > end) {
            el.classList.add('is-complete');
            if (fill) fill.style.width = '100%';
          } else if (n >= start && n <= end) {
            el.classList.add('is-active');
            var span = end - start + 1;
            var pct = ((n - start + 1) / span) * 100;
            if (fill) fill.style.width = pct + '%';
          } else {
            if (fill) fill.style.width = '0%';
          }
        });
      } else {
        progressBar.classList.add('is-hidden');
      }
    }

    /* Offer bar: hide on loading/results/treats */
    var offerBar = $('#quiz-offer-bar');
    if (offerBar) {
      offerBar.style.display = (n > INPUT_STEPS) ? 'none' : '';
    }

    /* Dog indicator pill (shows which dog when multi-dog) */
    var dogIndicator = $('#quiz-dog-indicator');
    if (dogIndicator) {
      if (dogCount >= 2 && n >= 2 && n <= 8 && n !== 3) {
        dogIndicator.textContent = dogNames[activeDogIndex] || ('Dog ' + (activeDogIndex + 1));
        dogIndicator.hidden = false;
      } else {
        dogIndicator.hidden = true;
      }
    }

    /* Update dog name displays — always Title-Cased, never single-char placeholder leaks */
    var displayName = displayDogName(quiz.name);
    nameDisplays = $$('.quiz-dog-name');
    nameDisplays.forEach(function(el) { el.textContent = displayName; });
    updateFreshFact(n);

    /* Background color shift */
    var bgColors = ['#FFFFFF','#FFFFFF','#FFFFFF','#FFFFFF','#FFFFFF','#FFFFFF','#FFFFFF','#FFFFFF','#FFFFFF','#FFFFFF','#FFFFFF','#DDF4FE','#FFFFFF','#FFFFFF'];
    root.style.transition = 'background-color 0.6s ease';
    root.style.backgroundColor = bgColors[n - 1] || '#FFFFFF';

    /* Scroll to top — quiz-app is the scroll container (position:fixed) */
    root.scrollTo(0, 0);
    window.scrollTo(0, 0);
    if (target) {
      requestAnimationFrame(function() {
        setupScrollReveals(target, true);
      });
    }

    /* Show toast at milestones \u2014 use possessive helper so "Chris" -> "Chris'", "Luna" -> "Luna's" */
    var possName = possessiveDogName(quiz.name);
    if (n === 4) showToast('Halfway there! \ud83d\udc3e ' + possName + ' plan is taking shape...');
    if (n === 9) {
      if (recipeEditReturnStep) {
        updateRecipeCards();
        updateRecipeCount();
      } else if (!recipeSelectionTouched) {
        var autoMix = recommendedRecipeMix();
        applyRecipeSelection(autoMix, autoMix[0]);
      } else {
        updateRecipeCards();
        updateRecipeCount();
      }
      var allergenStr = allergyIngredientLabel(quiz.allergyIngredients);
      showToast(quiz.healthIssues.indexOf('allergies') !== -1 && allergenStr
        ? 'Almost done! We filtered out recipes with ' + allergenStr + ' for ' + possName + ' first box.'
        : 'Almost done! We selected a variety starter for ' + possName + ' first box.');
    }
    /* Special screen logic */
    if (n === 12) runLoading();
    if (n === 13) showResults();
  }

  function updateFreshFact(step) {
    var text = freshFacts[step];
    if (!text) {
      var existing = $('#quiz-fresh-fact');
      if (existing) existing.hidden = true;
      return;
    }

    var screen = $('[data-screen="' + step + '"]');
    if (!screen) return;
    var inner = screen.querySelector('.quiz-app__inner');
    var nav = screen.querySelector('.quiz-app__nav');
    if (!inner || !nav) return;

    var fact = $('#quiz-fresh-fact');
    if (!fact) {
      fact = document.createElement('div');
      fact.className = 'quiz-app__fresh-fact';
      fact.id = 'quiz-fresh-fact';
      fact.innerHTML = '<p class="quiz-app__fresh-fact-label">Fresh Fact</p><p class="quiz-app__fresh-fact-text"></p>';
    }
    var body = fact.querySelector('.quiz-app__fresh-fact-text');
    if (body) body.textContent = text;
    fact.hidden = false;
    inner.insertBefore(fact, nav);
  }

  /* ===== Toast Messages ===== */
  var toastEl = document.createElement('div');
  toastEl.className = 'quiz-app__toast';
  toastEl.setAttribute('aria-live', 'polite');
  root.appendChild(toastEl);
  var toastTimer = null;

  function showToast(msg) {
    if (toastTimer) clearTimeout(toastTimer);
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    toastTimer = setTimeout(function() {
      toastEl.classList.remove('is-visible');
    }, 2800);
  }

  /* ===== Loading Screen — Kibble vs Fresh ===== */
  function updateLoadingComparison() {
    var title = $('#quiz-loading-current-title');
    var one = $('#quiz-loading-current-1');
    var two = $('#quiz-loading-current-2');
    var three = $('#quiz-loading-current-3');
    if (!title || !one || !two || !three) return;

    var map = {
      kibble: ['Current Kibble', 'Highly processed', 'Hard to portion', 'Long shelf life'],
      wet: ['Current Wet Food', 'Messier routine', 'Portions vary', 'Transition needed'],
      raw: ['Current Raw Food', 'Handling matters', 'Balance check', 'Transition needed'],
      home_cooked: ['Home-Cooked Meals', 'Prep-heavy', 'Balance check', 'Portions vary'],
      fresh: ['Current Fresh Food', 'Compare recipes', 'Compare portions', 'Compare delivery'],
      mixed: ['Mixed Routine', 'Many variables', 'Portions vary', 'Transition needed']
    };
    var data = map[quiz.currentFoodType] || ['Current Food', 'Transition needed', 'Portion check', 'Routine matters'];
    title.textContent = data[0];
    one.textContent = data[1];
    two.textContent = data[2];
    three.textContent = data[3];
  }

  function runLoading() {
    updateLoadingComparison();
    var labels = $$('.quiz-app__bowl-label');
    var freshBowl = $('.quiz-app__bowl--fresh');
    /* Reset state */
    labels.forEach(function(lbl) { lbl.classList.remove('is-visible'); });
    if (freshBowl) freshBowl.classList.add('quiz-app__bowl--hidden');

    /* Phase 1: Kibble labels appear (delays 0,1,2) */
    labels.forEach(function(lbl) {
      var delay = parseInt(lbl.dataset.delay, 10) || 0;
      if (delay <= 2) {
        setTimeout(function() { lbl.classList.add('is-visible'); }, 600 + delay * 700);
      }
    });

    /* Phase 2: After kibble labels done, reveal fresh bowl + its labels */
    var freshRevealTime = 600 + 3 * 700; /* after all 3 kibble labels */
    setTimeout(function() {
      if (freshBowl) freshBowl.classList.remove('quiz-app__bowl--hidden');
    }, freshRevealTime);

    labels.forEach(function(lbl) {
      var delay = parseInt(lbl.dataset.delay, 10) || 0;
      if (delay > 2) {
        setTimeout(function() { lbl.classList.add('is-visible'); }, freshRevealTime + 200 + (delay - 3) * 700);
      }
    });

    /* Checklist overlay — animate items done */
    var checkItems = $$('.quiz-app__check-item');
    checkItems.forEach(function(item) { item.classList.remove('is-done'); });
    if (checkItems.length > 0) setTimeout(function() { checkItems[0].classList.add('is-done'); }, 800);
    if (checkItems.length > 1) setTimeout(function() { checkItems[1].classList.add('is-done'); }, 1800);
    if (checkItems.length > 2) setTimeout(function() { checkItems[2].classList.add('is-done'); }, 2800);

    /* Auto-advance after all labels shown + pause */
    var totalTime = freshRevealTime + 200 + 3 * 700 + 800;
    setTimeout(function() { goTo(13); }, totalTime);
  }

  function getTransitionMessage(dog, allDogs) {
    if (allDogs && allDogs.length > 1) {
      var knownDogs = [];
      for (var i = 0; i < allDogs.length; i++) {
        if (allDogs[i].currentFoodType) knownDogs.push(allDogs[i].name || ('Dog ' + (i + 1)));
      }
      if (!knownDogs.length) return '';
      return 'We will transition ' + knownDogs.join(' and ') + ' gradually from their current food over 7-10 days, starting with 25% McDuffy and increasing every 2-3 days.';
    }

    if (!dog || !dog.currentFoodType) return '';
    var name = dog.name || quiz.name || 'your dog';
    var brand = dog.currentFoodBrand ? ' (' + dog.currentFoodBrand + ')' : '';

    var messages = {
      kibble: 'Since ' + name + ' is coming from kibble' + brand + ', start with 25% McDuffy and 75% current food, then increase every 2-3 days.',
      wet: 'Since ' + name + ' is coming from wet or canned food' + brand + ', keep the same mealtime rhythm while gradually replacing each bowl with McDuffy.',
      raw: 'Since ' + name + ' is coming from raw food' + brand + ', use a gradual switch so digestion can adjust to gently cooked, complete meals.',
      home_cooked: 'Since ' + name + ' is coming from home-cooked meals' + brand + ', McDuffy keeps the real-food routine while making portions and delivery easier.',
      fresh: 'Since ' + name + ' is already eating fresh food' + brand + ', compare portion size, recipe fit, and delivery rhythm during the first box.',
      mixed: 'Since ' + name + ' has a mixed routine' + brand + ', start with McDuffy as 25% of the bowl and increase gradually over 7-10 days.'
    };
    return messages[dog.currentFoodType] || 'We will transition ' + name + ' gradually from the current food over 7-10 days.';
  }

  function updateTransitionNote(dog, allDogs) {
    var note = $('#quiz-r-transition-note');
    var copy = $('#quiz-r-transition-copy');
    if (!note || !copy) return;
    var message = getTransitionMessage(dog, allDogs);
    if (!message) {
      note.hidden = true;
      copy.textContent = '';
      return;
    }
    copy.textContent = message;
    note.hidden = false;
  }

  function eatingStyleText(style, name) {
    var n = name || 'your dog';
    var map = {
      enthusiastic: n + ' usually eats eagerly, so the plan focuses on steady portions and simple routine.',
      picky: n + ' can be selective, so the first box leans on aroma, real texture, and a gradual switch.',
      varies: n + ' can be inconsistent at mealtime, so variety and transition pacing matter.'
    };
    return map[style] || '';
  }

  function priorityText(priority, name) {
    var n = name || 'your dog';
    var map = {
      longevity: 'Built around long-term health, daily routine, and consistent nutrition for ' + n + '.',
      digestion: 'Built to support digestion with predictable portions and a gradual transition.',
      coat_energy: 'Built to support coat, skin, and steady energy from real ingredients.',
      ingredients: 'Built for ingredient clarity: real meat, vegetables, and no mystery fillers.',
      convenience: 'Built for an easier routine: portioned packs, monthly delivery, and simple adjustments.'
    };
    return map[priority] || '';
  }

  function updatePlanBrief(dog, allDogs) {
    var wrap = $('#quiz-r-plan-brief');
    var list = $('#quiz-r-plan-brief-list');
    if (!wrap || !list) return;

    var items = [];
    if (allDogs && allDogs.length > 1) {
      var totalBags = allDogs.reduce(function(sum, d) { return sum + (d.bagsPerMonth || 0); }, 0);
      items.push(allDogs.length + ' dogs, ' + totalBags + ' bags/month, portioned separately.');
      var pickyNames = allDogs.filter(function(d) { return d.eatingStyle === 'picky'; }).map(function(d) { return d.name; });
      if (pickyNames.length) items.push('Selective eaters noted: ' + pickyNames.join(' and ') + '. We will keep transition guidance slower.');
      var currentFoodNames = allDogs.filter(function(d) { return d.currentFoodType; }).map(function(d) { return d.name; });
      if (currentFoodNames.length) items.push('Transition guidance is based on what ' + currentFoodNames.join(' and ') + ' eat today.');
    } else if (dog) {
      var name = dog.name || quiz.name || 'your dog';
      var ageLabel = ageAdjective(dog.age, dog.ageUnit);
      var bodyLabel = dog.condition === 'ideal' ? 'ideal body condition' : dog.condition;
      items.push(ageLabel + ', ' + dog.weight + 'kg' + (dog.breed ? ' ' + dog.breed : ' dog') + ' with ' + bodyLabel + '.');
      if (dog.neutered === 'yes') items.push('Spayed/neutered calorie adjustment included in the portion.');
      if (dog.activity) items.push('Activity level factored in: ' + dog.activity.replace('_', ' ') + '.');
      var appetiteText = eatingStyleText(dog.eatingStyle, name);
      if (appetiteText) items.push(appetiteText);
      var goalText = priorityText(quiz.priority, name);
      if (goalText) items.push(goalText);
    }

    if (!items.length) {
      wrap.hidden = true;
      list.innerHTML = '';
      return;
    }

    list.innerHTML = '';
    items.forEach(function(item) {
      var li = document.createElement('li');
      li.textContent = item;
      list.appendChild(li);
    });
    wrap.hidden = false;
  }

  function updatePlanOffer(data) {
    data = data || {};
    var el;
    el = $('#quiz-r-first-monthly');
    if (el) el.textContent = data.introMonthly ? formatPeso(data.introMonthly + SUBSCRIPTION_DELIVERY_PHP) : 'Included';
    el = $('#quiz-r-first-box-total');
    if (el) el.textContent = data.introMonthly ? formatPeso(data.introMonthly + SUBSCRIPTION_DELIVERY_PHP) + ' today' : '40% off food today';
    el = $('#quiz-r-second-box-total');
    if (el) el.textContent = data.secondMonthly ? formatPeso(data.secondMonthly + SUBSCRIPTION_DELIVERY_PHP) + ' in box 2' : '20% off food in box 2';
    el = $('#quiz-r-recurring-monthly');
    if (el) el.textContent = data.subMonthly ? formatPeso(data.subMonthly + SUBSCRIPTION_DELIVERY_PHP) + '/box from box 3' : 'Full food price from box 3';
    el = $('#quiz-r-plan-stat-bags');
    if (el) el.textContent = data.bags ? String(data.bags) : 'Custom';
    el = $('#quiz-r-plan-stat-grams');
    if (el) el.textContent = data.dailyGrams ? data.dailyGrams + 'g' : (data.dogCount ? 'Separate' : 'Tailored');
    el = $('#quiz-r-pouch-caption');
    if (el) {
      var name = data.name || quiz.name || 'your dog';
      var recipeLabel = data.recipeLabel || 'fresh recipes';
      var portion = data.dailyGrams ? data.dailyGrams + 'g/day' : 'separate daily portions';
      if (data.dogCount && data.dogCount > 1) {
        el.textContent = 'Separate personalized label previews for ' + name + ': each pouch uses the right name, recipe, and daily portion.';
        return;
      }
      el.textContent = 'Personalized label preview for ' + name + ': ' + recipeLabel + ', ' + portion + '.';
    }
  }

  /* ===== Results Calculation ===== */
  function showResults() {
    /* Save current dog to array */
    saveDogToArray();
    for (var rp = 0; rp < dogs.length; rp++) {
      dogs[rp] = refreshDogPlan(dogs[rp]);
    }

    /* ── Multi-dog auto-advance ──
       If more named dogs remain, auto-loop back to Screen 2 for the next dog.
       Only show results when ALL dogs are done. */
    if (dogs.length < dogNames.length) {
      var nextIdx = dogs.length;
      activeDogIndex = nextIdx;
      quiz.name = dogNames[nextIdx];
      quiz.breed = ''; quiz.age = 2; quiz.ageUnit = 'years';
      quiz.weight = 0; quiz.condition = 'ideal'; quiz.activity = 'medium';
      quiz.recipe = DEFAULT_RECIPE_MIX[0]; quiz.recipes = DEFAULT_RECIPE_MIX.slice(); quiz.plan = 'full';
      recipeSelectionTouched = false;
      quiz.sex = ''; quiz.neutered = ''; quiz.eatingStyle = '';
      quiz.healthIssues = [];
      quiz.allergyIngredients = [];
      clearDetailInputs();
      applyHouseholdAnswersFromFirstDog();
      showDogTransition(dogNames[nextIdx], function() { goTo(2); });
      return; /* Don't render results yet */
    }

    /* ── All dogs complete — render results ── */
    var isMultiDog = dogs.length >= 2;

    if (isMultiDog) {
      renderMultiDogSummary();
      syncQuickEditsForResults(true);
      var allDogNamesStr = dogNames.slice(0, dogs.length).join(' & ');

      /* Update title — just dog names (eyebrow is separate) */
      var titleEl = $('.quiz-r__hero-name .quiz-dog-name');
      if (titleEl) titleEl.textContent = allDogNamesStr;

      /* Update subtitle */
      var subtitleEl = $('#quiz-r-profile');
      if (subtitleEl) subtitleEl.innerHTML = '<span id="quiz-r-recipe-count">Fresh recipes</span> and <strong>tailored portions</strong> for ' + allDogNamesStr + '.';
      var dogDetailEl = $('#quiz-r-dog-detail');
      if (dogDetailEl) dogDetailEl.textContent = dogs.length + ' dogs';

      /* Daily grams callout for multi-dog */
      var dailyGramsEl = $('#quiz-r-daily-grams');
      if (dailyGramsEl) {
        var gramsText = dogs.map(function(dd) { return dd.name + ': ' + dd.dailyGrams + 'g/day avg'; }).join(' · ');
        dailyGramsEl.textContent = gramsText;
      }

      /* Combined pricing */
      var totalIntro = 0; var totalSecond = 0; var totalSub = 0; var totalOt = 0; var totalBags = 0;
      var aggregateRecipeBags = aggregateRecipeBagsForDogs(dogs);
      for (var mi = 0; mi < dogs.length; mi++) {
        var dd = dogs[mi];
        totalOt += dd.otMonthly;
        totalBags += dd.bagsPerMonth;
      }
      totalSub = calcMixedMonthly(aggregateRecipeBags, getSubPricePerBag);
      totalIntro = calcMixedMonthly(aggregateRecipeBags, getIntroPricePerBag);
      totalSecond = calcMixedMonthly(aggregateRecipeBags, getSecondBoxPricePerBag);
      var perDayIntro = (totalIntro + SUBSCRIPTION_DELIVERY_PHP) / 30;
      var perDayFull = (totalSub + SUBSCRIPTION_DELIVERY_PHP) / 30;

      var el;
      el = $('#quiz-r-per-day-intro'); if (el) el.textContent = formatPeso(perDayIntro);
      el = $('#quiz-r-per-day-full'); if (el) el.textContent = formatPeso(perDayFull) + '/day';
      el = $('#quiz-r-contains'); if (el) el.textContent = 'First box contains 1 month of food \u00b7 ' + totalBags + ' bags/month';
      el = $('#quiz-r-sticky-price'); if (el) el.textContent = formatPeso(perDayIntro) + '/day';
      el = $('#quiz-cta-subscribe'); if (el) el.textContent = 'Start with 40% off';
      /* All recipes across all dogs */
      var allRecipeNames = [];
      for (var ri = 0; ri < dogs.length; ri++) {
        var dRecipes = dogs[ri].recipes || [dogs[ri].recipe];
        for (var rj = 0; rj < dRecipes.length; rj++) {
          var rName = recipeNames[dRecipes[rj]] || dRecipes[rj];
          if (allRecipeNames.indexOf(rName) === -1) allRecipeNames.push(rName);
        }
      }
      el = $('#quiz-r-recipes-label'); if (el) el.textContent = allRecipeNames.join(', ');
      renderDogPouches(dogs);
      updatePlanOffer({
        name: allDogNamesStr,
        introMonthly: totalIntro,
        secondMonthly: totalSecond,
        subMonthly: totalSub,
        bags: totalBags,
        dogCount: dogs.length,
        recipeLabel: allRecipeNames.join(', ')
      });
      updatePlanBrief(null, dogs);
      updateTransitionNote(null, dogs);

      /* Populate feeding guide for multi-dog */
      var guideEl = $('#quiz-r-feeding-guide');
      if (guideEl) {
        var gHtml = '';
        for (var fi = 0; fi < dogs.length; fi++) {
          var fd = dogs[fi];
          var fRecipes = fd.recipes || [fd.recipe];
          var fRecipeBags = fd.recipeBags || {};
          gHtml += '<div style="margin-bottom:8px;font-weight:600;font-size:0.85rem;color:#1A1A1A">' + fd.name + '</div>';
          for (var fj = 0; fj < fRecipes.length; fj++) {
            var fr = fRecipes[fj];
            var fBags = fRecipeBags[fr] || fd.bagsPerMonth;
            var fGrams = (fd.recipeGrams && fd.recipeGrams[fr]) ? fd.recipeGrams[fr] : Math.round((fBags * 500) / 30);
            gHtml += '<div class="quiz-r-feeding__recipe-row">' +
              '<img src="' + (recipeImages[fr] || recipeImages.chicken_rice) + '" alt="' + (recipeNames[fr] || fr) + '" width="40" height="40">' +
              '<div><strong>' + (recipeNames[fr] || fr) + '</strong><span>' + fGrams + 'g on ' + (recipeNames[fr] || 'recipe') + ' days · ' + fBags + ' bag' + (fBags === 1 ? '' : 's') + '/month</span></div>' +
            '</div>';
          }
        }
        guideEl.innerHTML = gHtml;
      }

      /* Feeding detail text */
      el = $('#quiz-r-feeding-detail');
      if (el) {
        var detailParts = dogs.map(function(d) {
          var label = d.name + ' (' + d.weight + 'kg, ' + d.dailyGrams + 'g/day avg)';
          var am = d.ageUnit === 'months' ? d.age : d.age * 12;
          if (am < 12) label += ' \ud83d\udc3e puppy';
          return label;
        });
        el.textContent = 'Portioned for ' + detailParts.join(', ');
      }

      /* Recipe quality section — show all recipes across all dogs */
      el = $('#quiz-r-recipe-label'); if (el) el.textContent = allRecipeNames.join(' + ');
      var recipeCardsEl = $('#quiz-r-recipe-cards');
      if (recipeCardsEl) {
        var recipeBenefits = {
          surf_turf: 'Beef & sardine — rich in omega-3 for coat health',
          farmyard_feast: 'Pork, chicken & sardine — balanced nutrition with lean proteins',
          coastal_blend: 'Fish recipe — omega-rich for skin, brain & joint support',
          chicken_rice: 'Chicken It Up — gentle on sensitive stomachs, no fish'
        };
        var allRecipeKeys = [];
        for (var rci = 0; rci < dogs.length; rci++) {
          var dRecipes2 = dogs[rci].recipes || [dogs[rci].recipe];
          for (var rcj = 0; rcj < dRecipes2.length; rcj++) {
            if (allRecipeKeys.indexOf(dRecipes2[rcj]) === -1) allRecipeKeys.push(dRecipes2[rcj]);
          }
        }
        var cardsHtml = '';
        for (var ci = 0; ci < allRecipeKeys.length; ci++) {
          var cr = allRecipeKeys[ci];
          cardsHtml += '<div class="quiz-r-recipe__card" style="display:flex;align-items:center;gap:12px;padding:12px;background:#FFFFFF;border-radius:12px">' +
            '<img src="' + (recipeImages[cr] || recipeImages.chicken_rice) + '" alt="' + (recipeNames[cr] || cr) + '" width="80" height="80" style="border-radius:8px;object-fit:cover;flex-shrink:0">' +
            '<div>' +
              '<strong style="font-size:0.9rem;color:#1A1A1A;display:block;margin-bottom:2px">' + (recipeNames[cr] || cr) + '</strong>' +
              '<span style="font-size:0.8rem;color:#1A1A1A;line-height:1.3">' + (recipeBenefits[cr] || 'Real & human-grade proteins') + '</span>' +
            '</div>' +
          '</div>';
        }
        recipeCardsEl.innerHTML = cardsHtml;
      }

      /* Hide single-dog trial path, show multi summary */
      el = $('#quiz-r-trial-path'); if (el) el.hidden = true;
      el = $('#quiz-cta-edit'); if (el) el.hidden = true;

      try {
        localStorage.setItem('mcduffy_dog_profiles', JSON.stringify(dogs.map(function(dog) { return withParentFields(dog); })));
        localStorage.setItem('mcduffy_dog_profile', JSON.stringify(withParentFields(dogs[0])));
        localStorage.setItem('mcduffy_popup_protein', dogs[0].recipe);
      } catch(e) {}

      saveDogProfile();
      launchConfetti();

      if (typeof fbq === 'function') fbq('trackCustom', 'QuizComplete', { dogs: dogs.length, monthly_value: totalSub });
      trackFB('standard', 'ViewContent', { content_name: 'Quiz Results', content_type: 'product', value: totalSub, currency: 'PHP' });
      if (typeof gtag === 'function') gtag('event', 'quiz_complete', { dogs: dogs.length, monthly_value: totalSub });
      quizCompleted = true;

      requestAnimationFrame(function() {
        setupScrollReveals($('[data-screen="13"]'), true);
      });

      /* Show sticky bar */
      setupStickyBar();
      return;
    }

    /* ===== Single-dog results ===== */
    var d = dogs[0];
    var planDailyG = d.dailyGrams;
    var bagsPerMonth = d.bagsPerMonth;
    var otMonthly = d.otMonthly;
    var subMonthly = d.subMonthly;
    var savings = otMonthly - subMonthly;
    var subPerBag = d.subPerBag;

    results.dailyGrams = planDailyG;
    results.dailyCals = Math.round(planDailyG * 1.5);
    results.bagsPerMonth = bagsPerMonth;
    results.otMonthly = otMonthly;
    results.subMonthly = subMonthly;
    results.savings = savings;
    results.planDailyG = planDailyG;
    results.subPerBag = subPerBag;

    var multiSummary = $('#quiz-multi-dog-summary');
    if (multiSummary) multiSummary.hidden = true;
    syncQuickEditsForResults(false);
    var trialPath = $('#quiz-r-trial-path');
    if (trialPath) trialPath.hidden = false;
    var editBtn = $('#quiz-cta-edit');
    if (editBtn) editBtn.hidden = false;

    var el;
    /* Recipe display */
    var recipes = d.recipes || [d.recipe];
    var recipeBags = d.recipeBags || {};
    var mixedNames = recipes.map(function(r) { return recipeNames[r] || r; });

    /* Hero title — just the dog name (eyebrow is separate) */
    var titleEl = $('.quiz-r__hero-name .quiz-dog-name');
    if (titleEl) titleEl.textContent = quiz.name || 'your dog';

    /* Subtitle: dog detail — hyphenated age adjective, breed when known */
    /* Bad:  "2 years old, 16kg dog"     Good: "2-year-old, 16kg Golden Retriever" */
    el = $('#quiz-r-dog-detail');
    if (el) {
      var ageAdj = ageAdjective(quiz.age, quiz.ageUnit);
      var breedOrFallback = quiz.breed ? quiz.breed : 'dog';
      el.textContent = ageAdj + ', ' + quiz.weight + 'kg ' + breedOrFallback;
    }

    /* Daily grams callout */
    el = $('#quiz-r-daily-grams');
    if (el) el.textContent = planDailyG + 'g of fresh food per day';

    /* Recipe count badge */
    el = $('#quiz-r-recipe-count');
    if (el) el.textContent = recipes.length + ' ' + (recipes.length === 1 ? 'recipe' : 'recipes');

    /* Recipe names label */
    el = $('#quiz-r-recipes-label');
    if (el) el.textContent = mixedNames.join(', ');

    /* Pouch mockup — personalized label (FD-style SVG overlays).
       Single recipe → 1 pouch. Multi-recipe → 3-fan layout. */
    renderPouchFan(recipes, {
      dogName:     quiz.name,
      weightKg:    quiz.weight,
      dailyG:      planDailyG,
      recipeGrams: d.recipeGrams || {},
      pouchSize:   d.pouchSize   || 500,
      packsPerDay: d.packsPerDay || (planDailyG / 500)
    });

    /* Intro pricing */
    var introMonthly = calcMixedMonthly(recipeBags, getIntroPricePerBag);
    if (recipes.length === 1) introMonthly = getIntroPricePerBag(recipes[0], bagsPerMonth) * bagsPerMonth;
    var secondMonthly = calcMixedMonthly(recipeBags, getSecondBoxPricePerBag);
    if (recipes.length === 1) secondMonthly = getSecondBoxPricePerBag(recipes[0], bagsPerMonth) * bagsPerMonth;

    var perDayIntro = (introMonthly + SUBSCRIPTION_DELIVERY_PHP) / 30;
    var perDayFull = (subMonthly + SUBSCRIPTION_DELIVERY_PHP) / 30;

    el = $('#quiz-r-per-day-intro'); if (el) el.textContent = formatPeso(perDayIntro);
    el = $('#quiz-r-per-day-full'); if (el) el.textContent = formatPeso(perDayFull) + '/day';
    el = $('#quiz-r-contains'); if (el) el.textContent = 'First box contains 1 month of food \u00b7 ' + bagsPerMonth + ' bags/month';
    updatePlanOffer({
      name: quiz.name,
      introMonthly: introMonthly,
      secondMonthly: secondMonthly,
      subMonthly: subMonthly,
      bags: bagsPerMonth,
      dailyGrams: planDailyG,
      recipeLabel: mixedNames.join(', ')
    });
    updatePlanBrief(d);
    updateTransitionNote(d);

    /* CTA button */
    el = $('#quiz-cta-subscribe');
    if (el) el.textContent = 'Start with 40% off';

    /* Quiz -> concierge handoff: only offer once we can attach a conversation */
    el = $('#quiz-cta-concierge');
    if (el) el.hidden = !quiz.parentEmail;

    el = $('#quiz-cta-onetime');
    if (el) el.href = '/products/mcduffys-gently-home-cooked-complete-dog-food?view=one-time-shop-v8#recipe=' + quiz.recipe + '&qty=' + bagsPerMonth + '&trial=onetime';
    el = $('#quiz-r-onetime-copy');
    if (el) el.textContent = 'Order the recommended ' + bagsPerMonth + (bagsPerMonth === 1 ? ' bag' : ' bags') + ' once for about ' + formatPeso(otMonthly) + '. No recurring charge.';
    el = $('#quiz-cta-sampler');
    if (el) {
      var samplerType = quiz.recipe === 'chicken_rice' ? 'essentials' : 'signature';
      el.href = '/products/mcduffys-gently-home-cooked-complete-dog-food?view=one-time-shop-v8#recipe=' + quiz.recipe + '&trial=sampler&sampler=' + samplerType;
    }

    try {
      localStorage.setItem('mcduffy_dog_profile', JSON.stringify(withParentFields({
        name: quiz.name, breed: quiz.breed || '', age: quiz.age, ageUnit: quiz.ageUnit,
        sex: quiz.sex || '', neutered: quiz.neutered || '',
        weight: quiz.weight, condition: quiz.condition, activity: quiz.activity,
        healthIssues: quiz.healthIssues.slice(),
        allergyIngredients: quiz.allergyIngredients.slice(),
        eatingStyle: quiz.eatingStyle || '',
        currentFoodType: quiz.currentFoodType || '', currentFoodBrand: quiz.currentFoodBrand || ''
      })));
      localStorage.setItem('mcduffy_dog_profiles', JSON.stringify(dogs.map(function(dog) { return withParentFields(dog); })));
      localStorage.setItem('mcduffy_popup_protein', quiz.recipe);
    } catch(e) {}

    saveDogProfile();

    el = $('#quiz-email-note');
    if (el) {
      el.value = 'Quiz: ' + (quiz.name || 'Dog') + ', ' + (quiz.breed || 'Unknown breed') + ', ' + quiz.weight + 'kg, ' +
        quiz.age + ' ' + quiz.ageUnit + ', ' + quiz.activity + ' activity, ' +
        mixedNames.join(' + ') + ', ' + bagsPerMonth + ' bags/mo, ' +
        'Full McDuffy' +
        (quiz.sex ? ', sex: ' + quiz.sex : '') +
        (quiz.neutered ? ', spay/neuter: ' + quiz.neutered : '') +
        (quiz.eatingStyle ? ', eating style: ' + quiz.eatingStyle : '') +
        (quiz.currentFoodType ? ', current food: ' + quiz.currentFoodType : '') +
        (quiz.currentFoodBrand ? ' (' + quiz.currentFoodBrand + ')' : '') +
        (quiz.conviction ? ', conviction: ' + quiz.conviction : '') +
        (quiz.priority ? ', priority: ' + quiz.priority : '');
    }

    /* Gift tier display */
    updateGiftTier(bagsPerMonth);

    /* Show "Add Dog" button */
    var addDogBtn = $('#quiz-add-dog');
    if (addDogBtn) {
      addDogBtn.textContent = '+ Add another dog\u2019s plan';
      addDogBtn.hidden = false;
    }

    /* Below-the-fold sections */
    var recipeName = mixedNames.join(' + ');
    var recipeImg = recipeImages[recipes[0]] || recipeImages.surf_turf;

    /* 1. Feeding routine — per-recipe daily grams */
    el = $('#quiz-r-feeding-detail');
    if (el) {
      var feedText = 'Portioned for ' + quiz.weight + 'kg ' + (quiz.breed || 'dog');
      var ageMonths = quiz.ageUnit === 'months' ? quiz.age : quiz.age * 12;
      if (ageMonths < 12) feedText += ' \u00b7 \ud83d\udc3e Puppy portions (' + Math.round((ageMonths <= 4 ? 2.5 : ageMonths <= 6 ? 2.25 : ageMonths <= 9 ? 1.75 : 1.5) * 100) + '% of adult amount)';
      el.textContent = feedText;
    }
    var guideEl = $('#quiz-r-feeding-guide');
    if (guideEl) {
      var guideHtml = '';
      for (var gi = 0; gi < recipes.length; gi++) {
        var gr = recipes[gi];
        var gDailyG = (d.recipeGrams && d.recipeGrams[gr]) ? d.recipeGrams[gr] : (recipeBags[gr] ? Math.round((recipeBags[gr] * BAG_GRAMS) / 30) : Math.round(planDailyG / recipes.length));
        guideHtml += '<div class="quiz-r-feeding__recipe-row">' +
          '<img src="' + (recipeImages[gr] || recipeImages.chicken_rice) + '" alt="' + (recipeNames[gr] || gr) + '" width="40" height="40">' +
          '<div>' +
            '<strong>' + (recipeNames[gr] || gr) + '</strong>' +
            '<span>' + gDailyG + 'g on ' + (recipeNames[gr] || 'recipe') + ' days · ' + (recipeBags[gr] || 0) + ' bag' + ((recipeBags[gr] || 0) === 1 ? '' : 's') + '/month</span>' +
          '</div>' +
        '</div>';
      }
      guideEl.innerHTML = guideHtml;
    }

    /* 3. Recipe quality — show all selected recipes with images + key benefits */
    el = $('#quiz-r-recipe-label'); if (el) el.textContent = recipeName;
    var recipeCardsEl = $('#quiz-r-recipe-cards');
    if (recipeCardsEl) {
      var recipeBenefits = {
        surf_turf: 'Beef & sardine — rich in omega-3 for coat health',
        farmyard_feast: 'Pork, chicken & sardine — balanced nutrition with lean proteins',
        coastal_blend: 'Fish recipe — omega-rich for skin, brain & joint support',
        chicken_rice: 'Chicken It Up — gentle on sensitive stomachs, no fish'
      };
      var cardsHtml = '';
      for (var ci = 0; ci < recipes.length; ci++) {
        var cr = recipes[ci];
        cardsHtml += '<div class="quiz-r-recipe__card" style="display:flex;align-items:center;gap:12px;padding:12px;background:#FFFFFF;border-radius:12px">' +
          '<img src="' + (recipeImages[cr] || recipeImages.chicken_rice) + '" alt="' + (recipeNames[cr] || cr) + '" width="80" height="80" style="border-radius:8px;object-fit:cover;flex-shrink:0">' +
          '<div>' +
            '<strong style="font-size:0.9rem;color:#1A1A1A;display:block;margin-bottom:2px">' + (recipeNames[cr] || cr) + '</strong>' +
            '<span style="font-size:0.8rem;color:#1A1A1A;line-height:1.3">' + (recipeBenefits[cr] || 'Real & human-grade proteins') + '</span>' +
          '</div>' +
        '</div>';
      }
      recipeCardsEl.innerHTML = cardsHtml;
    }

    /* Sticky CTA */
    el = $('#quiz-r-sticky-price'); if (el) el.textContent = formatPeso(perDayIntro) + '/day';

    /* Show sticky bar */
    setupStickyBar();

    requestAnimationFrame(function() {
      setupScrollReveals($('[data-screen="13"]'), true);
    });

    /* Confetti burst */
    launchConfetti();

    trackQuizEventOnce('results_viewed_' + activeDogIndex, 'QuizResultsViewed', {
      dog_index: activeDogIndex,
      recipe: quiz.recipe,
      recipes: quiz.recipes.join(','),
      mixed: quiz.recipes.length > 1,
      bags: bagsPerMonth,
      monthly_value: subMonthly,
      intro_value: introMonthly,
      daily_grams: planDailyG,
      plan: 'full'
    });
    if (typeof fbq === 'function') fbq('trackCustom', 'QuizComplete', { recipe: quiz.recipe, bags: bagsPerMonth, monthly_value: subMonthly, plan: 'full' });
    trackFB('standard', 'ViewContent', { content_name: 'Quiz Results', content_type: 'product', value: subMonthly, currency: 'PHP' });
    if (typeof gtag === 'function') gtag('event', 'quiz_complete', { recipe: quiz.recipe, bags_per_month: bagsPerMonth, plan: 'full' });
    quizCompleted = true;
  }

  /* Sticky bar — show when primary CTA scrolls out of view */
  function setupStickyBar() {
    var stickyBar = $('#quiz-r-sticky');
    var primaryCta = $('#quiz-cta-subscribe');
    if (!stickyBar || !primaryCta) return;

    /* Use quiz-app as root since it's the scroll container (position:fixed) */
    var quizRoot = document.querySelector('.quiz-app');
    function syncStickyBar() {
      if (quiz.step !== 13) {
        stickyBar.classList.remove('is-visible');
        stickyBar.hidden = true;
        return;
      }

      var scrollTop = quizRoot ? quizRoot.scrollTop : (window.pageYOffset || document.documentElement.scrollTop || 0);
      var shouldShow = scrollTop > 72 || !stickyPrimaryCtaVisible;
      stickyBar.hidden = !shouldShow;
      stickyBar.classList.toggle('is-visible', shouldShow);
    }

    if (stickyObserver) stickyObserver.disconnect();
    if (typeof IntersectionObserver !== 'undefined') {
      stickyObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          stickyPrimaryCtaVisible = entry.isIntersecting;
          syncStickyBar();
        });
      }, { root: quizRoot, threshold: 0 });
      stickyObserver.observe(primaryCta);
    } else {
      stickyPrimaryCtaVisible = false;
    }

    if (stickyScrollHandler) root.removeEventListener('scroll', stickyScrollHandler);
    stickyScrollHandler = syncStickyBar;
    root.addEventListener('scroll', stickyScrollHandler, { passive: true });
    requestAnimationFrame(syncStickyBar);

    /* Sticky bar button clicks same as primary CTA */
    var stickyBtn = $('#quiz-r-sticky-btn');
    if (stickyBtn) {
      stickyBtn.onclick = function() { primaryCta.click(); };
    }
  }

  /* Animated number counter */
  function animateCounter(selector, target) {
    var el = $(selector);
    if (!el) return;
    var duration = 1200;
    var start = null;
    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      el.textContent = Math.round(easeOut(progress) * target);
      if (progress < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  /* CSS-only confetti burst */
  function launchConfetti() {
    var container = document.createElement('div');
    container.className = 'quiz-confetti';
    container.setAttribute('aria-hidden', 'true');
    var colors = ['#1A1A1A', '#1A1A1A', '#1A1A1A', '#1A1A1A', '#1A1A1A', '#1A1A1A'];
    for (var i = 0; i < 24; i++) {
      var piece = document.createElement('span');
      piece.className = 'quiz-confetti__piece';
      piece.style.setProperty('--x', (Math.random() * 200 - 100) + 'px');
      piece.style.setProperty('--y', (Math.random() * -300 - 50) + 'px');
      piece.style.setProperty('--r', (Math.random() * 720 - 360) + 'deg');
      piece.style.setProperty('--delay', (Math.random() * 0.3) + 's');
      piece.style.backgroundColor = colors[i % colors.length];
      container.appendChild(piece);
    }
    var resultsScreen = $('[data-screen="13"]');
    if (resultsScreen) {
      resultsScreen.appendChild(container);
      setTimeout(function() { container.remove(); }, 2000);
    }
  }

  /* ===== Gift Tier Display ===== */
  function updateGiftTier(bags) {
    var giftEl = $('#quiz-gift-content');
    if (!giftEl) return;
    var name = quiz.name || 'your dog';

    if (bags >= 28) {
      giftEl.innerHTML = '<span class="quiz-app__gift-icon">\ud83c\udf81</span> <strong>You\'ve unlocked 2 free gifts!</strong><br>A custom ' + name + ' dog tag + lick mat included with your first order.';
      giftEl.className = 'quiz-app__gift-tier-inner quiz-app__gift-tier--unlocked';
    } else if (bags >= 21) {
      giftEl.innerHTML = '<span class="quiz-app__gift-icon">\ud83c\udf81</span> <strong>You\'ve unlocked a free custom dog tag!</strong><br>Personalized with ' + name + '\'s name — included with your first order.';
      giftEl.className = 'quiz-app__gift-tier-inner quiz-app__gift-tier--unlocked';
    } else {
      var needed = 21 - bags;
      giftEl.innerHTML = '<span class="quiz-app__gift-icon">\ud83c\udf81</span> Add <strong>' + needed + ' more ' + (needed === 1 ? 'bag' : 'bags') + '</strong> to unlock a free custom dog tag with ' + name + '\'s name on it!';
      giftEl.className = 'quiz-app__gift-tier-inner quiz-app__gift-tier--upsell';
    }
  }

  function parentFieldSnapshot() {
    var nameInput = $('#quiz-parent-name');
    var emailInput = $('#quiz-parent-email');
    var phoneInput = $('#quiz-parent-phone');
    var optinInput = $('#quiz-email-optin');
    var viberOptinInput = $('#quiz-viber-optin');
    var optIn = optinInput ? optinInput.checked : quiz.parentEmailOptIn === true;
    var viberOptIn = viberOptinInput ? viberOptinInput.checked : quiz.parentViberOptIn === true;
    var rawPhone = ((phoneInput ? phoneInput.value.trim() : '') || quiz.parentPhone || '').trim();
    return {
      name: ((nameInput ? nameInput.value.trim() : '') || quiz.parentName || '').trim(),
      email: ((emailInput ? emailInput.value.trim() : '') || quiz.parentEmail || '').trim(),
      phone: viberOptIn ? rawPhone : '',
      optIn: optIn,
      viberOptIn: viberOptIn && !!rawPhone
    };
  }

  function withParentFields(profile) {
    return Object.assign({}, profile || {}, {
      parentName: quiz.parentName || '',
      parentEmail: quiz.parentEmail || '',
      parentPhone: quiz.parentPhone || '',
      parentEmailOptIn: quiz.parentEmailOptIn === true,
      parentViberOptIn: quiz.parentViberOptIn === true
    });
  }

  function persistQuizState() {
    try {
      sessionStorage.setItem('mcduffy_quiz_state', JSON.stringify({
        quiz: quiz,
        dogs: dogs,
        dogCount: dogCount,
        dogNames: dogNames,
        activeDogIndex: activeDogIndex
      }));
    } catch(e) {}
  }

  function persistParentSnapshot() {
    try {
      localStorage.setItem('mcduffy_quiz_parent', JSON.stringify({
        parentName: quiz.parentName || '',
        parentEmail: quiz.parentEmail || '',
        parentPhone: quiz.parentPhone || '',
        parentEmailOptIn: quiz.parentEmailOptIn === true,
        parentViberOptIn: quiz.parentViberOptIn === true,
        dogNames: dogNames.slice(),
        sessionId: quizSessionId,
        updatedAt: new Date().toISOString()
      }));
    } catch(e) {}
  }

  function captureParentLead(options) {
    options = options || {};
    var nameInput = $('#quiz-parent-name');
    var emailInput = $('#quiz-parent-email');
    var phoneInput = $('#quiz-parent-phone');
    var optinInput = $('#quiz-email-optin');
    var viberOptinInput = $('#quiz-viber-optin');
    var errorEl = $('#quiz-email-error');
    var parentName = (nameInput ? nameInput.value.trim() : '');
    var parentEmail = (emailInput ? emailInput.value.trim() : '');
    var rawParentPhone = (phoneInput ? phoneInput.value.trim() : '');
    var parentWantsViber = viberOptinInput ? viberOptinInput.checked : false;
    var parentPhone = parentWantsViber ? rawParentPhone : '';
    var hasViberPhone = !!parentPhone;

    if (nameInput) nameInput.classList.remove('has-error');
    if (emailInput) emailInput.classList.remove('has-error');
    if (errorEl) errorEl.hidden = true;

    if (parentName.length < 2) {
      if (nameInput) nameInput.classList.add('has-error');
      if (errorEl) { errorEl.textContent = 'Please enter your name'; errorEl.hidden = false; }
      if (nameInput) nameInput.focus();
      return false;
    }

    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(parentEmail)) {
      if (emailInput) emailInput.classList.add('has-error');
      if (errorEl) { errorEl.textContent = 'Please enter a valid email address'; errorEl.hidden = false; }
      if (emailInput) emailInput.focus();
      return false;
    }

    quiz.parentName = parentName;
    quiz.parentEmail = parentEmail;
    quiz.parentPhone = parentPhone;
    quiz.parentEmailOptIn = optinInput ? optinInput.checked : true;
    quiz.parentViberOptIn = parentWantsViber && hasViberPhone;
    persistParentSnapshot();
    persistQuizState();

    var dogSummary = dogNames.join(', ') || quiz.name || 'N/A';
    var leadStatus = parentLeadCaptured ? 'quiz_contact_updated' : 'quiz_email_captured';
    var leadEventId = '';

    if (!parentLeadCaptured) {
      leadEventId = trackFB('standard', 'CompleteRegistration', { content_name: 'Quiz Early Contact', dogs: dogNames.length || 1 });
      trackFB('custom', 'QuizEmailCaptured', {
        parent_name: parentName,
        has_phone: hasViberPhone,
        viber_opt_in: quiz.parentViberOptIn === true,
        dogs: dogNames.length || 1,
        captured_at_screen: quiz.step
      });
    } else {
      trackFB('custom', 'QuizContactUpdated', {
        parent_name: parentName,
        has_phone: hasViberPhone,
        viber_opt_in: quiz.parentViberOptIn === true,
        dogs: dogNames.length || 1,
        captured_at_screen: quiz.step
      });
    }

    saveQuizProgress(leadStatus, leadEventId, {
      screen: quiz.step,
      last_screen: quiz.step,
      contact_collected_early: true
    });
    saveDogProfile(leadStatus, leadEventId);

    if (typeof window.mcduffyCaptureLead === 'function') {
      window.mcduffyCaptureLead({
        email: parentEmail,
        first_name: parentName,
        phone: parentPhone,
        source: 'quiz_contact_gate',
        lead_status: leadStatus,
        event_id: leadEventId,
        marketing_opt_in: quiz.parentEmailOptIn === true,
        viber_opt_in: quiz.parentViberOptIn === true,
        tags: ['quiz', 'feeding-plan', 'prospect'],
        dog_name: dogSummary,
        monthly_value: results.subMonthly || 0,
        note: 'Quiz lead: ' + parentName + (parentPhone ? ' | Mobile/Viber: ' + parentPhone : '') + ' | Dogs: ' + dogSummary
      });
    }

    parentLeadCaptured = true;
    return true;
  }

  function buildQuizDataPayload(leadStatus, eventId, extra) {
    var tracking = backendTrackingPayload(leadStatus || 'quiz_results_viewed', eventId);
    var activeDog = dogs[activeDogIndex] || dogs[0] || {};
    var resultDog = activeDog.name ? activeDog : null;
    var selectedRecipes = quiz.recipes || (resultDog && resultDog.recipes) || [quiz.recipe];
    var bagsPerMonth = (resultDog && resultDog.bagsPerMonth) || results.bagsPerMonth || 0;
    var monthlyValue = (resultDog && resultDog.subMonthly) || results.subMonthly || 0;
    var parent = parentFieldSnapshot();
    var introValue = 0;
    try {
      var recipeBags = (resultDog && resultDog.recipeBags) || buildRecipeBags(selectedRecipes, bagsPerMonth);
      introValue = calcMixedMonthly(recipeBags, getIntroPricePerBag);
    } catch(e) {}
    return Object.assign({
      session_id: quizSessionId,
      screen: quiz.step,
      last_screen: quiz.step,
      completed_screens: completedScreens.slice(),
      email: parent.email,
      parent_name: parent.name,
      parent_phone: parent.phone,
      marketing_opt_in: parent.optIn === true,
      parent_viber_opt_in: parent.viberOptIn === true,
      source: 'quiz',
      lead_status: leadStatus || 'quiz_results_viewed',
      event_id: tracking.event_id,
      attribution: tracking.attribution,
      fbp: tracking.fbp,
      fbc: tracking.fbc,
      page_url: tracking.page_url,
      referrer: tracking.referrer,
      quiz_preset: tracking.quiz_preset,
      checkout_started_at: leadStatus === 'subscription_checkout_started' ? new Date().toISOString() : null,
      dog_name: quiz.name,
      dog_names: dogNames.slice(),
      dog_breed: quiz.breed || '',
      dog_sex: quiz.sex || '',
      spayed_neutered: quiz.neutered || '',
      dog_weight_kg: quiz.weight,
      dog_age: quiz.age,
      dog_age_unit: quiz.ageUnit,
      body_condition: quiz.condition,
      activity_level: quiz.activity,
      allergies: quiz.healthIssues,
      allergy_ingredients: quiz.allergyIngredients.slice(),
      eating_style: quiz.eatingStyle || '',
      current_food_type: quiz.currentFoodType || '',
      current_food_brand: quiz.currentFoodBrand || '',
      /* Quiz V2 / Moat Activation fields — feed segmentation + the PH COD-first-box
         purchase path + city proof tagging. Default '' until a surface collects them. */
      city: quiz.city || '',
      feeding_handler: quiz.feedingHandler || '',
      payment_preference: quiz.paymentPreference || '',
      subscription_readiness: quiz.subscriptionReadiness || '',
      preferred_protein: quiz.recipe,
      preferred_plan: 'full',
      recipes: selectedRecipes,
      bags_per_month: bagsPerMonth,
      daily_grams: (resultDog && resultDog.dailyGrams) || results.dailyGrams || 0,
      monthly_value: monthlyValue,
      intro_value: introValue,
      conviction: quiz.conviction || '',
      priority: quiz.priority || ''
    }, extra || {});
  }

  /* ===== Save Dog Profile to Backend ===== */
  function saveDogProfile(leadStatus, eventId) {
    if (!quiz.parentEmail) return;
    var payload = buildQuizDataPayload(leadStatus, eventId);
    try {
      fetch(BACKEND_URL + '/api/dog-profiles', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'omit',
        mode: 'cors',
        keepalive: true
      }).catch(function() {});
    } catch(e) {}
  }

  function saveQuizProgress(leadStatus, eventId, extra) {
    var payload = buildQuizDataPayload(leadStatus || ('quiz_screen_' + quiz.step), eventId, extra);
    var dedupeKey = [
      payload.session_id,
      payload.screen,
      payload.lead_status,
      payload.parent_name,
      payload.email,
      payload.parent_phone,
      payload.dog_name,
      payload.dog_breed,
      payload.dog_weight_kg,
      payload.preferred_protein,
      payload.conviction,
      payload.priority
    ].join('|');
    if (dedupeKey === lastProgressKey) return;
    lastProgressKey = dedupeKey;

    try {
      fetch(BACKEND_URL + '/api/quiz-progress', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'omit',
        mode: 'cors',
        keepalive: true
      }).catch(function() {});
    } catch(e) {}
  }

  function queueQuizProgress(leadStatus, delay) {
    if (progressTimer) clearTimeout(progressTimer);
    progressTimer = setTimeout(function() {
      saveQuizProgress(leadStatus);
    }, typeof delay === 'number' ? delay : 250);
  }

  function markScreenCompleted(screenNumber) {
    var n = parseInt(screenNumber, 10);
    if (!n) return;
    if (completedScreens.indexOf(n) === -1) completedScreens.push(n);
    completedScreens.sort(function(a, b) { return a - b; });
  }

  function treatRecommendationMode() {
    var health = Array.isArray(quiz.healthIssues) ? quiz.healthIssues : [];
    if (health.indexOf('allergies') === -1) return 'chicken';
    var allergens = uniqueRecipeList(quiz.allergyIngredients);
    if (!allergens.length || allergens.indexOf('chicken') !== -1) return 'plant';
    return 'chicken';
  }

  function applyTreatRecommendations() {
    var mode = treatRecommendationMode();
    var usePlantOnly = mode === 'plant';
    $$('.quiz-treats__card[data-treat-recommendation]').forEach(function(card) {
      var group = card.dataset.treatRecommendation || '';
      var shouldShow = group === 'always' || (usePlantOnly ? group === 'plant' : group === 'chicken');
      card.hidden = !shouldShow;
      if (!shouldShow) {
        var qtyEl = card.querySelector('.quiz-treats__qty-value');
        if (qtyEl) qtyEl.textContent = '0';
        card.classList.remove('is-added');
      }
    });
    var note = $('#quiz-treats-recommendation-note');
    if (note) {
      note.textContent = usePlantOnly
        ? 'Because chicken allergy was selected, we are showing plant-based first-box treats.'
        : (quiz.healthIssues.indexOf('allergies') !== -1
          ? 'Allergy noted. We are keeping the first-box treat simple and avoiding the ingredient you selected.'
          : 'A simple first-box reward, selected to keep checkout clear.');
    }
  }

  /* ===== Subscribe CTA — goes to treats upsell first ===== */
  function handleSubscribe() {
    /* Ensure dogs array is populated */
    if (dogs.length === 0) saveDogToArray();
    /* Track subscribe intent */
    var totalSubForTracking = dogs.reduce(function(s,d) { return s + d.subMonthly; }, 0);
    var totalBagsForTracking = dogs.reduce(function(s,d) { return s + d.bagsPerMonth; }, 0);
    trackFB('custom', 'QuizClickSubscribe', { monthly_value: totalSubForTracking, bags: totalBagsForTracking, plan: 'full', dogs: dogs.length });
    trackQuizEvent('QuizSubscribeIntent', {
      monthly_value: totalSubForTracking,
      bags: totalBagsForTracking,
      plan: 'full',
      dogs: dogs.length,
      recipe: quiz.recipe,
      recipes: quiz.recipes.join(','),
      screen: quiz.step
    });
    saveDogProfile('quiz_subscribe_intent');
    selectedTreats = [];
    /* Reset treat qty states */
    $$('.quiz-treats__card').forEach(function(c) { c.classList.remove('is-added'); });
    $$('.quiz-treats__qty-value').forEach(function(el) { el.textContent = '0'; });
    $$('.quiz-treats__card').forEach(function(c) {
      var defaultBilling = c.dataset.treatBillingDefault || c.dataset.treatBillingLock || 'one_time';
      setTreatCardBilling(c, defaultBilling, true);
    });
    /* Reset dropdowns to first option */
    $$('.quiz-treats__select').forEach(function(sel) { sel.selectedIndex = 0; sel.dispatchEvent(new Event('change')); });
    applyTreatRecommendations();
    rebuildSelectedTreats();
    /* Personalize treats upsell subtitle without adding subscription complexity. */
    var treatsSubEl = root.querySelector('[data-screen="14"] .quiz-treats-hero__sub');
    if (treatsSubEl) {
      var name = quiz.name || 'your dog';
      if (quiz.treats === 'lots') {
        treatsSubEl.innerHTML = 'Since ' + name + ' loves treats, choose a simple first-box reward or continue with food only.';
      } else {
        treatsSubEl.innerHTML = 'Optional first-box treats only. No monthly treat charge is added from this screen.';
      }
    }
    goTo(14);
  }

  function dogFoodOngoing(d) {
    if (!d) return 0;
    var recipeBags = d.recipeBags || null;
    if (recipeBags && typeof recipeBags === 'object') {
      var mixedTotal = 0;
      var mixedBags = sumRecipeBags(recipeBags);
      for (var r in recipeBags) mixedTotal += (parseInt(recipeBags[r], 10) || 0) * getSubPricePerBag(r, mixedBags);
      if (mixedTotal > 0) return roundMoney(mixedTotal);
    }
    var bags = parseInt(d.bagsPerMonth, 10) || 0;
    return bags * getSubPricePerBag(d.recipe, bags);
  }

  function dogFoodIntro(d) {
    if (!d) return 0;
    var recipeBags = d.recipeBags || null;
    if (recipeBags && typeof recipeBags === 'object') {
      var mixedTotal = 0;
      var mixedBags = sumRecipeBags(recipeBags);
      for (var r in recipeBags) mixedTotal += (parseInt(recipeBags[r], 10) || 0) * getIntroPricePerBag(r, mixedBags);
      if (mixedTotal > 0) return mixedTotal;
    }
    var bags = parseInt(d.bagsPerMonth, 10) || 0;
    return bags * getIntroPricePerBag(d.recipe, bags);
  }

  function dogFoodSecond(d) {
    if (!d) return 0;
    var recipeBags = d.recipeBags || null;
    if (recipeBags && typeof recipeBags === 'object') {
      var mixedTotal = 0;
      var mixedBags = sumRecipeBags(recipeBags);
      for (var r in recipeBags) mixedTotal += (parseInt(recipeBags[r], 10) || 0) * getSecondBoxPricePerBag(r, mixedBags);
      if (mixedTotal > 0) return mixedTotal;
    }
    var bags = parseInt(d.bagsPerMonth, 10) || 0;
    return roundMoney(bags * getSecondBoxPricePerBag(d.recipe, bags));
  }

  function treatsFullTotal(treats, opts) {
    var recurringOnly = opts && opts.recurringOnly;
    return (treats || []).reduce(function(sum, t) {
      if (recurringOnly && !isRecurringTreat(t)) return sum;
      return sum + ((parseInt(t.price, 10) || 0) * (parseInt(t.qty || t.quantity, 10) || 1));
    }, 0);
  }

  function reviewNode(id) {
    return document.getElementById(id);
  }

  function ensureCheckoutReviewPortal() {
    var modal = reviewNode('quiz-checkout-review');
    if (modal && document.body && modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function buildSubscribeConfig() {
    if (dogs.length === 0) saveDogToArray();
    var tracking = backendTrackingPayload('SubscribeConfig');
    var totalQty = dogs.reduce(function(s,d) { return s + d.bagsPerMonth; }, 0);
    var totalSub = dogs.reduce(function(s,d) { return s + dogFoodOngoing(d); }, 0);
    var foodIntroTotal = dogs.reduce(function(s,d) { return s + dogFoodIntro(d); }, 0);
    var foodSecondTotal = dogs.reduce(function(s,d) { return s + dogFoodSecond(d); }, 0);
    var treatsTotal = treatsFullTotal(selectedTreats);
    var recurringTreatsTotal = treatsFullTotal(selectedTreats, { recurringOnly: true });
    /* Food-only launch discounts never reduce treats. First-box treats are
       one-time add-ons at their full displayed price. */
    var treatsIntroTotal = treatsTotal;

    var config = {
      dogs: dogs.map(function(d) {
        return {
          name: d.name,
          dogProfile: { name: d.name, breed: d.breed, age: d.age, ageUnit: d.ageUnit,
                         sex: d.sex || '', neutered: d.neutered || '',
                         weight: d.weight, condition: d.condition, activity: d.activity,
                         eatingStyle: d.eatingStyle || '',
                         currentFoodType: d.currentFoodType || '', currentFoodBrand: d.currentFoodBrand || '',
                         healthIssues: d.healthIssues || [],
                         allergyIngredients: d.allergyIngredients || [] },
          recipe: d.recipe, recipes: d.recipes || [d.recipe],
          recipeBags: d.recipeBags || null,
          recipeGrams: d.recipeGrams || null,
          qty: d.bagsPerMonth, perBag: d.subPerBag, total: d.subMonthly,
          /* Pouch plan fields — used by webhook to build personalized label print URLs */
          weight: d.weight,
          dailyGrams: d.dailyGrams,
          pouchSize: d.pouchSize || 500,
          packsPerDay: d.packsPerDay || 1
        };
      }),
      recipe: dogs[0].recipe,
      qty: totalQty,
      plan: 'full',
      dogProfile: {
        name: dogs[0].name,
        age: dogs[0].age,
        ageUnit: dogs[0].ageUnit,
        sex: dogs[0].sex || '',
        neutered: dogs[0].neutered || '',
        weight: dogs[0].weight,
        breed: dogs[0].breed || '',
        condition: dogs[0].condition,
        activity: dogs[0].activity,
        eatingStyle: dogs[0].eatingStyle || '',
        currentFoodType: dogs[0].currentFoodType || '',
        currentFoodBrand: dogs[0].currentFoodBrand || '',
        healthIssues: dogs[0].healthIssues || [],
        allergyIngredients: dogs[0].allergyIngredients || []
      },
      perBag: dogs[0].subPerBag,
      total: totalSub,
      frequency: 'monthly',
      treats: selectedTreats,
      source: 'quiz',
      subscriptionCatalogVersion: 'unified_259_v3',
      shippingPolicyVersion: 'flat_199_per_delivery_2026_09_01_v1',
      shippingPerDeliveryCentavos: SUBSCRIPTION_DELIVERY_PHP * 100,
      firstShippingAmountCentavos: SUBSCRIPTION_DELIVERY_PHP * 100,
      recurringShippingAmountCentavos: SUBSCRIPTION_DELIVERY_PHP * 100,
      session_id: quizSessionId,
      sessionId: quizSessionId,
      conviction: quiz.conviction || '',
      priority: quiz.priority || '',
      allergyIngredients: dogs[0].allergyIngredients || [],
      allergy_ingredients: dogs[0].allergyIngredients || [],
      parentName: quiz.parentName || '',
      parentEmail: quiz.parentEmail || '',
      parentPhone: quiz.parentPhone || '',
      parentEmailOptIn: quiz.parentEmailOptIn === true,
      parentViberOptIn: quiz.parentViberOptIn === true,
      quizPreset: quiz.preset || '',
      attribution: tracking.attribution,
      fbp: tracking.fbp,
      fbc: tracking.fbc,
      pageUrl: tracking.page_url,
      referrer: tracking.referrer,
      eventIds: {}
    };
    config.dogProfile.parentName = quiz.parentName || '';
    config.dogProfile.parentEmail = quiz.parentEmail || '';
    config.dogProfile.parentPhone = quiz.parentPhone || '';
    config.dogProfile.parentEmailOptIn = quiz.parentEmailOptIn === true;
    config.dogProfile.parentViberOptIn = quiz.parentViberOptIn === true;
    config.estimatedFoodIntro = foodIntroTotal;
    config.estimatedTreatsIntro = treatsIntroTotal;
    config.estimatedFirstDelivery = SUBSCRIPTION_DELIVERY_PHP;
    config.estimatedRecurringDelivery = SUBSCRIPTION_DELIVERY_PHP;
    config.estimatedFirstOrder = foodIntroTotal + treatsIntroTotal + SUBSCRIPTION_DELIVERY_PHP;
    config.estimatedSecondOrder = roundMoney(foodSecondTotal + recurringTreatsTotal + SUBSCRIPTION_DELIVERY_PHP);
    config.estimatedRecurring = totalSub + recurringTreatsTotal + SUBSCRIPTION_DELIVERY_PHP;
    config.estimatedTreatsRecurring = recurringTreatsTotal;
    config.estimatedTreatsOneTime = treatsTotal - recurringTreatsTotal;
    return config;
  }

  function renderCheckoutDogRows(config) {
    var dogsEl = reviewNode('quiz-review-dogs');
    if (!dogsEl) return;
    dogsEl.innerHTML = '';
    (config.dogs || []).forEach(function(d) {
      var recipes = d.recipes || [d.recipe];
      var recipeLabel = recipes.map(function(r) { return recipeNames[r] || r; }).join(' + ');
      var row = document.createElement('div');
      row.className = 'quiz-checkout-review__dog';
      row.innerHTML =
        '<div class="quiz-checkout-review__dog-mark" aria-hidden="true">' + escapeHtml((d.name || 'D').charAt(0).toUpperCase()) + '</div>' +
        '<div class="quiz-checkout-review__dog-copy">' +
          '<strong>' + escapeHtml(d.name || 'Your dog') + '</strong>' +
          '<span>' + escapeHtml(recipeLabel) + ' · ' + escapeHtml(d.qty || 0) + ' bags/month · ' + escapeHtml(d.dailyGrams || 0) + 'g/day</span>' +
        '</div>';
      dogsEl.appendChild(row);
    });
  }

  function showCheckoutReview(config) {
    var modal = ensureCheckoutReviewPortal();
    if (!modal) {
      finishCheckout(config);
      return;
    }
    pendingCheckoutConfig = config;

    var dogNamesText = (config.dogs || []).map(function(d) { return d.name; }).join(' & ') || 'your dog';
    var titleEl = reviewNode('quiz-review-title');
    if (titleEl) {
      titleEl.textContent = (config.dogs && config.dogs.length > 1)
        ? 'Review ' + dogNamesText + "'s first box"
        : 'Review ' + possessiveDogName(dogNamesText) + ' first box';
    }
    var eyebrowEl = reviewNode('quiz-review-eyebrow');
    if (eyebrowEl) eyebrowEl.textContent = (config.dogs && config.dogs.length > 1) ? config.dogs.length + ' dogs · monthly plan' : 'First box review';
    var todayEl = reviewNode('quiz-review-today');
    if (todayEl) todayEl.textContent = formatPeso(config.estimatedFirstOrder || config.total || 0);
    var secondEl = reviewNode('quiz-review-second');
    if (secondEl) secondEl.textContent = formatPeso(config.estimatedSecondOrder || config.total || 0) + '/mo';
    var recurringEl = reviewNode('quiz-review-recurring');
    if (recurringEl) recurringEl.textContent = formatPeso(config.estimatedRecurring || config.total || 0) + '/mo';

    renderCheckoutDogRows(config);

    var treatsEl = reviewNode('quiz-review-treats');
    if (treatsEl) {
      if (config.treats && config.treats.length) {
        var recurringTreats = config.treats.filter(isRecurringTreat);
        var oneTimeTreats = config.treats.filter(function(t) { return !isRecurringTreat(t); });
        function labelTreats(list) {
          return list.map(function(t) {
            return (parseInt(t.qty, 10) || 1) + 'x ' + (t.name || 'Treat').replace(/_/g, ' ');
          }).join(', ');
        }
        var treatLines = [];
        if (oneTimeTreats.length) treatLines.push('First box only: ' + labelTreats(oneTimeTreats) + '.');
        if (recurringTreats.length) treatLines.push('Monthly add-ons: ' + labelTreats(recurringTreats) + '.');
        treatLines.push('First-box treats stay at regular price; food discounts do not apply to treats.');
        treatsEl.textContent = treatLines.join(' ');
        treatsEl.hidden = false;
      } else {
        treatsEl.textContent = '';
        treatsEl.hidden = true;
      }
    }

    modal.hidden = false;
    modal.dataset.reviewClosing = 'false';
    root.classList.add('has-checkout-review-open');
    document.body.classList.add('mcduffy-quiz-review-open');
    requestAnimationFrame(function() {
      if (!modal.hidden && modal.dataset.reviewClosing !== 'true') {
        modal.classList.add('is-open');
      }
    });
    var confirmBtn = reviewNode('quiz-review-confirm');
    if (confirmBtn) setTimeout(function() { confirmBtn.focus(); }, 80);

    trackQuizEvent('QuizCheckoutReviewShown', {
      dogs: (config.dogs || []).length,
      bags: config.qty,
      treats_count: (config.treats || []).length,
      first_order_value: config.estimatedFirstOrder || config.total || 0,
      recurring_value: config.estimatedRecurring || config.total || 0
    });
    saveDogProfile('checkout_review_viewed');
  }

  function hideCheckoutReview(reason) {
    var modal = reviewNode('quiz-checkout-review');
    if (!modal || modal.hidden) return;
    modal.dataset.reviewClosing = 'true';
    modal.classList.remove('is-open');
    root.classList.remove('has-checkout-review-open');
    document.body.classList.remove('mcduffy-quiz-review-open');
    if (reason) trackQuizEvent('QuizCheckoutReviewClosed', { reason: reason });
    setTimeout(function() {
      if (modal.dataset.reviewClosing === 'true') {
        modal.hidden = true;
        delete modal.dataset.reviewClosing;
      }
    }, 180);
  }

  function finishCheckout(config) {
    config = config || pendingCheckoutConfig || buildSubscribeConfig();
    pendingCheckoutConfig = config;
    quizCompleted = true; /* suppress dropoff tracking after confirmed checkout intent */

    config.quizPreset = quiz.preset || config.quizPreset || '';
    config.attribution = config.attribution || backendTrackingPayload('SubscribeConfig').attribution;
    config.eventIds = config.eventIds || {};
    persistQuizState();

    var reviewEventId = trackQuizEvent('QuizCheckoutReviewConfirmed', {
      dogs: (config.dogs || []).length,
      bags: config.qty,
      treats_count: (config.treats || []).length,
      first_order_value: config.estimatedFirstOrder || config.total || 0,
      recurring_value: config.estimatedRecurring || config.total || 0
    });
    localStorage.setItem('mcduffy_subscribe_config', JSON.stringify(config));
    saveQuizProgress('subscription_checkout_started', reviewEventId, { checkout_started_at: new Date().toISOString() });
    saveDogProfile('subscription_checkout_started', reviewEventId);

    window.location.href = '/pages/mcduffy-subscription';
  }

  /* Final checkout — called from treats screen. Shows review before PayMongo. */
  function proceedToCheckout() {
    rebuildSelectedTreats();
    var config = buildSubscribeConfig();
    var treatsValue = treatsFullTotal(selectedTreats);
    trackQuizEvent('QuizTreatsDecision', {
      treats_added: selectedTreats.length > 0,
      treats_count: selectedTreats.length,
      treats_value: treatsValue,
      first_order_value: config.estimatedFirstOrder || config.total || 0,
      recurring_value: config.estimatedRecurring || config.total || 0
    });
    showCheckoutReview(config);
  }

  /* ===== Breed Fun Fact ===== */
  function showBreedFact(breed) {
    var factEl = $('#quiz-breed-fact');
    var factText = $('#quiz-breed-fact-text');
    if (!factEl || !factText) return;

    var name = quiz.name || 'your dog';
    var fact = breedFacts[breed] || 'Every dog deserves real food. Let\'s build ' + name + '\'s plan! \ud83d\udc3e';
    factText.textContent = fact;
    factEl.hidden = false;
    factEl.classList.add('is-visible');
  }

  /* ===== Multi-Dog Functions ===== */

  function saveDogToArray() {
    var recipes = (quiz.recipes && quiz.recipes.length ? quiz.recipes : [quiz.recipe || 'chicken_rice']).slice();
    var primaryRecipe = recipes[0] || quiz.recipe;
    quiz.plan = 'full';
    var SUB_MIN_QTY = 7;

    /* Each selected recipe has its own feeding guide. For mixed plans, calculate
       the grams and monthly bags per recipe across an equal monthly rotation
       instead of splitting one primary recipe's bags across every recipe. */
    var portionPlan = buildRecipePortionPlan(recipes, quiz, SUB_MIN_QTY);
    recipes = portionPlan.recipes;
    primaryRecipe = recipes[0] || primaryRecipe;
    var recipeBags = portionPlan.recipeBags;
    var recipeGrams = portionPlan.recipeGrams;
    var planDailyG = portionPlan.targetDailyGrams;
    var bags = portionPlan.bags;
    var fullDailyG = portionPlan.targetDailyGrams;
    var fullBags = bags;
    var fullRecipeBags = recipeBags;

    /* Mixed pricing */
    var subMonthly = calcMixedMonthly(recipeBags, getSubPricePerBag);
    var otMonthly = calcMixedMonthly(recipeBags, getPricePerBag);
    var subPerBag = bags > 0 ? Math.round(subMonthly / bags) : getSubPricePerBag(primaryRecipe, bags);

    /* Pouch plan — recommends 250g vs 500g pouch + packs/day for the dog.
       This is purely cosmetic for now (label preview / portion modal); the
       cart still uses 500g variants because the live product only has 500g. */
    var pouchPlan = pickPouchPlan(planDailyG);

    dogs[activeDogIndex] = {
      name: quiz.name, breed: quiz.breed, age: quiz.age, ageUnit: quiz.ageUnit,
      sex: quiz.sex || '', neutered: quiz.neutered || '',
      weight: quiz.weight, condition: quiz.condition, activity: quiz.activity,
      eatingStyle: quiz.eatingStyle || '',
      currentFoodType: quiz.currentFoodType || '', currentFoodBrand: quiz.currentFoodBrand || '',
      healthIssues: quiz.healthIssues.slice(),
      allergyIngredients: quiz.allergyIngredients.slice(),
      recipe: primaryRecipe, recipes: recipes, recipeBags: recipeBags, recipeGrams: recipeGrams,
      treats: quiz.treats, plan: quiz.plan,
      dailyGrams: planDailyG, bagsPerMonth: bags,
      deliverableDailyGrams: portionPlan.deliverableDailyGrams,
      fullDailyGrams: fullDailyG, fullBagsPerMonth: fullBags, fullRecipeBags: fullRecipeBags,
      otMonthly: otMonthly,
      subMonthly: subMonthly, subPerBag: subPerBag,
      /* Recommended pouch sizing for label preview & portion modal */
      pouchSize: pouchPlan.pouchSize,
      packsPerDay: pouchPlan.packsPerDay,
      packsPerWeek: pouchPlan.packsPerWeek,
      pouchPlanRationale: pouchPlan.rationale
    };
  }

  function refreshDogPlan(d) {
    if (!d || !d.weight) return d;
    var recipes = (d.recipes && d.recipes.length) ? d.recipes.slice() : [d.recipe || 'chicken_rice'];
    var SUB_MIN_QTY = 7;
    var plan = buildRecipePortionPlan(recipes, d, SUB_MIN_QTY);
    var primaryRecipe = plan.recipes[0] || d.recipe || 'chicken_rice';
    var subMonthly = calcMixedMonthly(plan.recipeBags, getSubPricePerBag);
    var otMonthly = calcMixedMonthly(plan.recipeBags, getPricePerBag);
    var subPerBag = plan.bags > 0 ? Math.round(subMonthly / plan.bags) : getSubPricePerBag(primaryRecipe, plan.bags);
    var pouchPlan = pickPouchPlan(plan.targetDailyGrams);

    d.recipe = primaryRecipe;
    d.recipes = plan.recipes;
    d.recipeBags = plan.recipeBags;
    d.recipeGrams = plan.recipeGrams;
    d.dailyGrams = plan.targetDailyGrams;
    d.deliverableDailyGrams = plan.deliverableDailyGrams;
    d.bagsPerMonth = plan.bags;
    d.fullDailyGrams = plan.targetDailyGrams;
    d.fullBagsPerMonth = plan.bags;
    d.fullRecipeBags = plan.recipeBags;
    d.otMonthly = otMonthly;
    d.subMonthly = subMonthly;
    d.subPerBag = subPerBag;
    d.pouchSize = pouchPlan.pouchSize;
    d.packsPerDay = pouchPlan.packsPerDay;
    d.packsPerWeek = pouchPlan.packsPerWeek;
    d.pouchPlanRationale = pouchPlan.rationale;
    return d;
  }

  function clearDetailInputs() {
    var breedInput = $('#quiz-breed');
    if (breedInput) breedInput.value = '';
    var ageInput = $('#quiz-age');
    if (ageInput) ageInput.value = '2';
    var weightInput = $('#quiz-weight');
    if (weightInput) weightInput.value = '';
    var weightSlider = $('#quiz-weight-slider');
    if (weightSlider) weightSlider.value = 10;
    $$('.quiz-weight-size').forEach(function(el) { el.classList.remove('is-active'); });
    $$('[data-breed]').forEach(function(c) { c.classList.remove('is-on'); });
    $$('[data-condition]').forEach(function(c) { c.classList.remove('is-on'); });
    $$('[data-activity]').forEach(function(c) { c.classList.remove('is-on'); });
    $$('[data-recipe]').forEach(function(c) { c.classList.remove('is-on'); });
    $$('[data-health]').forEach(function(c) { c.classList.remove('is-on'); });
    $$('[data-sex]').forEach(function(c) { c.classList.remove('is-on'); });
    $$('[data-neutered]').forEach(function(c) { c.classList.remove('is-on'); });
    $$('[data-eating-style]').forEach(function(c) { c.classList.remove('is-on'); });
    $$('[data-allergen]').forEach(function(c) { c.classList.remove('is-on'); });
    $$('[data-health-toggle]').forEach(function(b) { b.classList.remove('is-on'); });
    var noneToggle = root.querySelector('[data-health-toggle="none"]');
    if (noneToggle) noneToggle.classList.add('is-on');
    var healthGrid = $('#quiz-health-grid');
    if (healthGrid) healthGrid.hidden = true;
    var healthRec = $('#quiz-health-rec');
    if (healthRec) healthRec.hidden = true;
    var allergyPanel = $('#quiz-allergy-panel');
    if (allergyPanel) allergyPanel.hidden = true;
    quiz.healthIssues = [];
    quiz.allergyIngredients = [];
    quiz.treats = 'none';
    quiz.sex = '';
    quiz.neutered = '';
    quiz.eatingStyle = '';
    quiz.currentFoodType = '';
    quiz.currentFoodBrand = '';
    var currentFoodType = $('#quiz-current-food-type');
    if (currentFoodType) currentFoodType.value = '';
    var currentFoodBrand = $('#quiz-current-food-brand');
    if (currentFoodBrand) currentFoodBrand.value = '';
    /* Clear treats question selection */
    $$('[data-treats-q]').forEach(function(o) { o.classList.remove('is-on'); });
    var treatsLabelCard = $('#quiz-treats-q-label-card');
    if (treatsLabelCard) treatsLabelCard.hidden = true;
    /* Re-select defaults */
    var dc = root.querySelector('[data-condition="ideal"]');
    if (dc) dc.classList.add('is-on');
    var da = root.querySelector('[data-activity="medium"]');
    if (da) da.classList.add('is-on');
    applyRecipeSelection(DEFAULT_RECIPE_MIX, DEFAULT_RECIPE_MIX[0]);
    recipeSelectionTouched = false;
    var maxMsg = $('#quiz-recipe-max-msg');
    if (maxMsg) maxMsg.hidden = true;
    /* Reset breed fact */
    var factEl = $('#quiz-breed-fact');
    if (factEl) { factEl.hidden = true; factEl.classList.remove('is-visible'); }
    /* Reset age unit to years */
    $$('[data-age-unit]').forEach(function(b) { b.classList.remove('is-on'); });
    var yearsBtn = root.querySelector('[data-age-unit="years"]');
    if (yearsBtn) yearsBtn.classList.add('is-on');
    quiz.ageUnit = 'years';
  }

  function collectProfileFields() {
    var breedInput = $('#quiz-breed');
    if (breedInput && breedInput.value.trim()) {
      quiz.breed = breedInput.value.trim();
    }

    var ageInput = $('#quiz-age');
    var a = ageInput ? parseFloat(ageInput.value) : 0;
    quiz.age = (a > 0) ? a : 2;
  }

  function collectRoutineFields() {
    var currentFoodType = $('#quiz-current-food-type');
    var currentFoodBrand = $('#quiz-current-food-brand');
    quiz.currentFoodType = currentFoodType ? currentFoodType.value : '';
    quiz.currentFoodBrand = currentFoodBrand ? currentFoodBrand.value.trim() : '';
  }

  function showDogTransition(name, callback) {
    var transEl = $('#quiz-transition');
    var nameEl = $('#quiz-transition-name');
    if (!transEl || !nameEl) { callback(); return; }
    nameEl.textContent = name;
    transEl.hidden = false;
    setTimeout(function() {
      transEl.hidden = true;
      callback();
    }, 1800);
  }

  function renderMultiDogSummary() {
    var container = $('#quiz-multi-dog-summary');
    if (!container) return;

    var html = '';
    var totalSub = 0;
    var totalOt = 0;
    var householdRecipeBags = aggregateRecipeBagsForDogs(dogs);
    var householdBags = sumRecipeBags(householdRecipeBags);

    for (var i = 0; i < dogs.length; i++) {
      var d = dogs[i];
      var displaySub = calcDogFoodWithHouseholdBags(d, getSubPricePerBag, householdBags);
      totalSub += displaySub;
      totalOt += d.otMonthly;
      var dRecipes = d.recipes || [d.recipe];
      var dRecipeLabel = dRecipes.map(function(r) { return recipeNames[r] || r; }).join(' + ');
      var dRecipeBreakdown = dRecipes.map(function(r) {
        var bags = d.recipeBags && d.recipeBags[r] ? d.recipeBags[r] : d.bagsPerMonth;
        return (recipeNames[r] || r) + ': ' + bags + (bags === 1 ? ' bag' : ' bags');
      }).join(' · ');
      var safeDogName = escapeHtml(d.name || 'Dog');
      var safeRecipeLabel = escapeHtml(dRecipeLabel);
      var safeRecipeBreakdown = escapeHtml(dRecipeBreakdown);
      html += '<div class="quiz-multi-summary__dog">' +
        '<img class="quiz-multi-summary__dog-img" src="' + (recipeImages[dRecipes[0]] || recipeImages.chicken_rice) + '" alt="' + safeRecipeLabel + '" width="48" height="48">' +
        '<div class="quiz-multi-summary__dog-info">' +
          '<div class="quiz-multi-summary__dog-name">' + safeDogName + ' \u00b7 ' + safeRecipeLabel + '</div>' +
          '<div class="quiz-multi-summary__dog-recipe">' + safeRecipeBreakdown + ' · ' + d.dailyGrams + 'g/day avg</div>' +
        '</div>' +
        '<div class="quiz-multi-summary__dog-price">' + formatPeso(displaySub) + '/mo food</div>' +
        '<div class="quiz-multi-summary__dog-actions">' +
          '<button type="button" onclick="(function(){document.dispatchEvent(new CustomEvent(\'quiz:editDog\',{detail:' + i + '}))})()">Edit ' + safeDogName + '</button>' +
        '</div>' +
      '</div>';
    }

    var totalIntro = calcMixedMonthly(householdRecipeBags, getIntroPricePerBag);
    var totalSecond = calcMixedMonthly(householdRecipeBags, getSecondBoxPricePerBag);
    var totalFirstWithDelivery = totalIntro + SUBSCRIPTION_DELIVERY_PHP;
    var totalSecondWithDelivery = totalSecond + SUBSCRIPTION_DELIVERY_PHP;
    var totalFullWithDelivery = totalSub + SUBSCRIPTION_DELIVERY_PHP;
    var introSavingsMulti = totalSub - totalIntro;
    html += '<div class="quiz-multi-summary__total">' +
      '<span>Box 1 total</span>' +
      '<span>' + formatPeso(totalFirstWithDelivery) + '</span>' +
      '<span>Box 2 total</span>' +
      '<span>' + formatPeso(totalSecondWithDelivery) + '</span>' +
      '<span>Box 3+ monthly total</span>' +
      '<span>' + formatPeso(totalFullWithDelivery) + '/mo</span>' +
    '</div>';
    html += '<p class="quiz-multi-summary__savings">Save ' + formatPeso(introSavingsMulti) + ' on box 1 food · box 2 food is 20% off · full food price from box 3 · each total includes &#8369;199 delivery</p>';

    container.innerHTML = html;
    container.hidden = false;

    /* Hide single-dog elements */
    var singleCard = $('.quiz-app__result-card');
    if (singleCard) singleCard.hidden = true;
    var trustEl = $('.quiz-app__trust');
    if (trustEl) trustEl.hidden = true;

    /* Update subscribe CTA */
    var subBtn = $('#quiz-cta-subscribe');
    if (subBtn) subBtn.textContent = 'Subscribe \u2014 ' + formatPeso(totalFirstWithDelivery) + ' today';

    /* Hide single-dog trial path for multi-dog plans */
    var trialPath = $('#quiz-r-trial-path');
    if (trialPath) trialPath.hidden = true;

    /* Show "Add another dog" if under max */
    var addBtn = $('#quiz-add-dog');
    if (addBtn) {
      if (dogs.length < MAX_DOGS) {
        var nextIdx = dogs.length;
        if (nextIdx < dogNames.length) {
          addBtn.textContent = 'Now build ' + dogNames[nextIdx] + '\u2019s plan \u2192';
        } else {
          addBtn.textContent = '+ Add another dog\u2019s plan';
        }
        addBtn.hidden = false;
      } else {
        addBtn.hidden = true;
      }
    }

    /* Hide edit answers (use per-dog edit instead) */
    var editBtn = $('#quiz-cta-edit');
    if (editBtn) editBtn.hidden = true;

    /* Update dog name displays for multi-dog */
    var allNames = dogs.map(function(d) { return d.name; }).join(' & ');
    $$('.quiz-dog-name').forEach(function(el) { el.textContent = allNames; });
  }

  function syncQuickEditsForResults(isMultiDog) {
    var wrap = $('#quiz-r-quick-edits');
    if (!wrap) return;
    if (!wrap.dataset.defaultHtml) wrap.dataset.defaultHtml = wrap.innerHTML;

    if (!isMultiDog) {
      wrap.classList.remove('quiz-r__quick-edits--dogs');
      wrap.innerHTML = wrap.dataset.defaultHtml;
      return;
    }

    var html = '<span class="quiz-r__quick-edits-label">Edit one dog:</span>';
    for (var i = 0; i < dogs.length; i++) {
      var d = dogs[i] || {};
      var safeName = escapeHtml(displayDogName(d.name));
      html += '<button class="quiz-r__quick-edit quiz-r__quick-edit--dog" data-edit-dog-index="' + i + '" data-edit-target="4" type="button">' +
        safeName + '\'s weight</button>';
      html += '<button class="quiz-r__quick-edit quiz-r__quick-edit--dog" data-edit-dog-index="' + i + '" data-edit-target="9" type="button">' +
        safeName + '\'s recipes</button>';
    }
    wrap.innerHTML = html;
    wrap.classList.add('quiz-r__quick-edits--dogs');
  }

  function editDog(index, targetStep) {
    activeDogIndex = index;
    var d = dogs[index];
    quiz.name = d.name; quiz.breed = d.breed; quiz.age = d.age;
    quiz.ageUnit = d.ageUnit; quiz.weight = d.weight;
    quiz.sex = d.sex || ''; quiz.neutered = d.neutered || '';
    quiz.condition = d.condition; quiz.activity = d.activity;
    quiz.eatingStyle = d.eatingStyle || '';
    quiz.healthIssues = d.healthIssues ? d.healthIssues.slice() : [];
    quiz.allergyIngredients = d.allergyIngredients ? d.allergyIngredients.slice() : [];
    quiz.currentFoodType = d.currentFoodType || '';
    quiz.currentFoodBrand = d.currentFoodBrand || '';
    quiz.recipes = starterRecipeMixFor(d);
    quiz.recipe = (d.recipe && quiz.recipes.indexOf(d.recipe) !== -1) ? d.recipe : (quiz.recipes[0] || '');
    quiz.plan = 'full';
    /* Pre-fill inputs */
    var breedInput = $('#quiz-breed');
    if (breedInput) breedInput.value = d.breed || '';
    var ageInput = $('#quiz-age');
    if (ageInput) ageInput.value = d.age;
    var weightInput = $('#quiz-weight');
    if (weightInput) weightInput.value = d.weight;
    var currentFoodType = $('#quiz-current-food-type');
    if (currentFoodType) currentFoodType.value = quiz.currentFoodType;
    var currentFoodBrand = $('#quiz-current-food-brand');
    if (currentFoodBrand) currentFoodBrand.value = quiz.currentFoodBrand;
    /* Highlight matching selections */
    $$('[data-breed]').forEach(function(c) { c.classList.toggle('is-on', c.dataset.breed === d.breed); });
    $$('[data-condition]').forEach(function(c) { c.classList.toggle('is-on', c.dataset.condition === d.condition); });
    $$('[data-activity]').forEach(function(c) { c.classList.toggle('is-on', c.dataset.activity === d.activity); });
    var recipeScreen = root.querySelector('[data-screen="9"]');
    (recipeScreen || root).querySelectorAll('[data-recipe]').forEach(function(c) {
      c.classList.toggle('is-on', quiz.recipes.indexOf(c.dataset.recipe) !== -1);
    });
    $$('[data-age-unit]').forEach(function(b) { b.classList.toggle('is-on', b.dataset.ageUnit === d.ageUnit); });
    $$('[data-sex]').forEach(function(c) { c.classList.toggle('is-on', c.dataset.sex === quiz.sex); });
    $$('[data-neutered]').forEach(function(c) { c.classList.toggle('is-on', c.dataset.neutered === quiz.neutered); });
    $$('[data-eating-style]').forEach(function(c) { c.classList.toggle('is-on', c.dataset.eatingStyle === quiz.eatingStyle); });
    $$('[data-allergen]').forEach(function(c) { c.classList.toggle('is-on', quiz.allergyIngredients.indexOf(c.dataset.allergen) !== -1); });
    syncAllergyPanel();
    if (d.breed) showBreedFact(d.breed);
    updateRecipeCount();
    /* Default to screen 2 (Profile) — screen 3 is the email-capture screen;
       jumping there sent "Edit {dog}" users to the contact form. */
    goTo(targetStep || 2);
  }

  /* Listen for edit dog events from multi-dog summary buttons */
  document.addEventListener('quiz:editDog', function(e) {
    editDog(e.detail);
  });

  /* ===== Event Listeners ===== */

  /* Next buttons */
  $$('[data-next]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var step = quiz.step;

      /* Collect & validate data per step */
      if (step === 1) {
        /* Collect all names from dynamic inputs. Any non-empty trimmed value
           is accepted (single-char names allowed per product decision). */
        dogNames = [];
        var allNameInputs = namesContainer ? namesContainer.querySelectorAll('.quiz-app__name-input') : [];
        var firstEmpty = null;
        allNameInputs.forEach(function(inp) {
          var v = inp.value.trim();
          if (v) { dogNames.push(v); }
          else if (!firstEmpty) { firstEmpty = inp; }
        });
        /* Need at least 1 name */
        if (dogNames.length === 0) { if (firstEmpty || allNameInputs[0]) (firstEmpty || allNameInputs[0]).focus(); return; }
        /* Title-case all names so storage matches display: ["luna","rex"] -> ["Luna","Rex"] */
        dogNames = dogNames.map(function(n) { return formatDogName(n) || n; });
        /* Trim dogCount to actual filled names (ignore trailing empty rows) */
        dogCount = dogNames.length;
        if (countDisplay) countDisplay.value = dogCount;
        if (dogWordEl) dogWordEl.textContent = dogCount === 1 ? 'dog named' : 'dogs named';
        /* Set quiz.name for Dog 1 (already Title-Cased above) */
        quiz.name = dogNames[0];
        /* Sync hidden #quiz-name for legacy reads */
        var hiddenName = $('#quiz-name');
        if (hiddenName) hiddenName.value = quiz.name;
        /* Preserve completed dogs whose names haven't changed, reset new/changed ones */
        var preservedDogs = [];
        for (var di = 0; di < dogNames.length; di++) {
          if (dogs[di] && dogs[di].name === dogNames[di]) {
            preservedDogs.push(dogs[di]);
          } else {
            break; /* Stop preserving at first mismatch — quiz new dogs from here */
          }
        }
        dogs = preservedDogs;
        activeDogIndex = dogs.length; /* Start quiz from first unfinished dog */
        if (activeDogIndex >= dogNames.length) activeDogIndex = 0; /* All done, restart from first */
        quiz.name = dogNames[activeDogIndex];
      }
      if (step === 2) {
        // QLT-026: validate age instead of silently coercing blank/0/negative to 2 years
        // (which mis-fed puppies as adults, missing the 2.5x puppy multiplier).
        var ageInput2 = $('#quiz-age');
        var ageError = $('#quiz-age-error');
        var ageVal = ageInput2 ? parseFloat(ageInput2.value) : NaN;
        var ageUnitBtn = $('.quiz-app__toggle-btn.is-on[data-age-unit]');
        var ageUnit = ageUnitBtn ? ageUnitBtn.dataset.ageUnit : 'years';
        var ageMax = ageUnit === 'months' ? 360 : 30;
        if (ageInput2) ageInput2.classList.remove('has-error');
        if (ageError) ageError.hidden = true;
        if (ageInput2 && (isNaN(ageVal) || ageVal <= 0 || ageVal > ageMax)) {
          ageInput2.classList.add('has-error');
          if (ageError) {
            ageError.textContent = 'Please enter your dog’s age in ' + ageUnit + '.';
            ageError.hidden = false;
          }
          ageInput2.focus();
          return;
        }
        collectProfileFields();
        goTo(3);
        return;
      }
      if (step === 3) {
        if (!captureParentLead({ source: 'contact_step' })) return;
        goTo(4);
        return;
      }
      if (step === 4) {
        var weightInput = $('#quiz-weight');
        var weightError = $('#quiz-weight-error');
        var w = weightInput ? parseFloat(weightInput.value) : 0;
        if (weightInput) weightInput.classList.remove('has-error');
        if (weightError) weightError.hidden = true;
        if (!w || w <= 0 || w > 120) { // QLT-027: reject implausible weights (no upper bound before → 500kg extrapolated nonsense portions)
          if (weightInput) weightInput.classList.add('has-error');
          if (weightError) {
            weightError.textContent = (w > 120)
              ? 'Please enter a weight in kilograms (up to 120 kg).'
              : 'Please enter your dog’s weight in kg.';
            weightError.hidden = false;
          }
          if (weightInput) weightInput.focus();
          return;
        }
        quiz.weight = w;
      }
      if (step === 7 && quiz.healthIssues.indexOf('allergies') !== -1) {
        var recEl = $('#quiz-health-rec');
        var recText = $('#quiz-health-rec-text');
        if (!quiz.allergyIngredients.length) {
          if (recText) recText.textContent = 'Please select the ingredient your dog is allergic to so we can filter recipes correctly.';
          if (recEl) recEl.hidden = false;
          return;
        }
        if (!allergySafeRecipeMix(quiz.allergyIngredients).length) {
          if (recText) recText.textContent = 'No current McDuffy recipe fully avoids that allergy combination. Please message us before ordering so we do not recommend the wrong food.';
          if (recEl) recEl.hidden = false;
          return;
        }
      }
      if (step === 9 && !quiz.recipes.length) {
        showRecipeNotice('Please select at least one recipe before continuing.');
        return;
      }
      /* Steps 5, 6, 8, 9 collect via option/recipe/health/treats click handlers */

      /* Step 10: legacy fallback; routine/current food now lives on Step 8 */
      if (step === 10) {
        var convictionSelect = $('#quiz-conviction');
        if (convictionSelect && convictionSelect.value) {
          quiz.conviction = convictionSelect.value;
        }
        collectRoutineFields();
        /* priority is collected via click handler below */
      }

      if (step === 8) {
        collectRoutineFields();
        applyAutoRecipeSelection();
        goTo(12);
        return;
      }

      if (step === 9 && recipeEditReturnStep) {
        var returnStep = recipeEditReturnStep;
        recipeEditReturnStep = 0;
        saveDogToArray();
        goTo(returnStep);
        return;
      }

      goTo(step + 1);
    });
  });

  /* Back buttons */
  $$('[data-back]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (quiz.step === 13) {
        goTo(8); /* From results, back to routine; screen 10 is skipped */
      } else if (quiz.step === 14) {
        goTo(13); /* From treats upsell, back to results */
      } else if (quiz.step === 11) {
        goTo(8); /* Email back returns to routine; screen 10 is skipped */
      } else if (quiz.step === 10) {
        goTo(8); /* Legacy screen 10 returns to routine */
      } else if (quiz.step === 9 && recipeEditReturnStep) {
        var returnStep = recipeEditReturnStep;
        recipeEditReturnStep = 0;
        goTo(returnStep);
      } else if (quiz.step === 4) {
        goTo(3); /* Contact lives on screen 3; profile lives on screen 2 */
      } else if (quiz.step > 1) {
        goTo(quiz.step - 1);
      }
    });
  });

  /* Enter key to advance — use delegation so dynamically created inputs work */
  var quizContainer = document.querySelector('.quiz-app');
  if (quizContainer) {
    quizContainer.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && (e.target.matches('.quiz-app__input, .quiz-app__name-input, .quiz-app__count-input'))) {
        e.preventDefault();
        var screen = e.target.closest('.quiz-app__screen');
        if (screen) {
          var nextBtn = screen.querySelector('[data-next]');
          if (nextBtn) nextBtn.click();
        }
      }
    });
  }

  /* ===== Dog Count + Name Inputs (Screen 1) ===== */
  var countDisplay = $('#quiz-count-display');
  var dogWordEl = $('#quiz-dog-word');
  var namesContainer = $('#quiz-names-container');

  var visibleNameRows = 1; /* How many name rows are currently shown */

  function updateDogCountUI() {
    if (countDisplay) countDisplay.value = dogCount;
    if (dogWordEl) dogWordEl.textContent = dogCount === 1 ? 'dog named' : 'dogs named';
    /* When count changes, reset visible rows to 1 and rebuild */
    visibleNameRows = 1;
    rebuildNameRows();
  }

  function rebuildNameRows() {
    if (!namesContainer) return;
    /* Clear all and rebuild to match visibleNameRows */
    var existingInputs = namesContainer.querySelectorAll('.quiz-app__name-input');
    var savedValues = [];
    existingInputs.forEach(function(inp) { savedValues.push(inp.value); });

    namesContainer.innerHTML = '';
    for (var i = 0; i < visibleNameRows; i++) {
      var row = document.createElement('div');
      row.className = 'quiz-app__name-row' + (i > 0 ? ' quiz-app__name-row--extra' : '');
      var html = '';
      if (i > 0) html += '<span class="quiz-app__sentence-amp">&amp;</span>';
      html += '<input type="text" class="quiz-app__name-input" id="quiz-name-' + (i + 1) + '" placeholder="enter pet\u2019s name" autocomplete="off">';
      row.innerHTML = html;
      namesContainer.appendChild(row);

      var inp = row.querySelector('.quiz-app__name-input');
      if (savedValues[i]) inp.value = savedValues[i];
      else if (dogNames[i]) inp.value = dogNames[i];

      /* Attach reveal-next listener: first char typed reveals next row */
      (function(idx, inputEl) {
        var revealed = false;
        inputEl.addEventListener('input', function() {
          if (!revealed && inputEl.value.trim() && idx === visibleNameRows - 1 && visibleNameRows < dogCount) {
            revealed = true;
            visibleNameRows++;
            addNameRow(visibleNameRows - 1);
          }
        });
      })(i, inp);
    }
  }

  function addNameRow(index) {
    if (!namesContainer) return;
    var row = document.createElement('div');
    row.className = 'quiz-app__name-row quiz-app__name-row--extra';
    row.innerHTML = '<span class="quiz-app__sentence-amp">&amp;</span>' +
      '<input type="text" class="quiz-app__name-input" id="quiz-name-' + (index + 1) + '" placeholder="enter pet\u2019s name" autocomplete="off">';
    namesContainer.appendChild(row);

    var inp = row.querySelector('.quiz-app__name-input');
    /* Attach reveal-next listener */
    (function(idx, inputEl) {
      var revealed = false;
      inputEl.addEventListener('input', function() {
        if (!revealed && inputEl.value.trim() && idx === visibleNameRows - 1 && visibleNameRows < dogCount) {
          revealed = true;
          visibleNameRows++;
          addNameRow(visibleNameRows - 1);
        }
      });
    })(index, inp);
  }

  /* Count input — user types how many dogs */
  if (countDisplay) {
    var lastCountVal = 1;
    countDisplay.addEventListener('input', function() {
      var val = parseInt(countDisplay.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      if (val > MAX_DOGS) val = MAX_DOGS;
      if (val === lastCountVal) return;
      lastCountVal = val;
      dogCount = val;
      if (dogWordEl) dogWordEl.textContent = dogCount === 1 ? 'dog named' : 'dogs named';
      // Show all name rows immediately when count increases — don't wait for
      // the user to type in the first field (that was the "second dog missing" bug).
      visibleNameRows = dogCount;
      rebuildNameRows();
    });
    countDisplay.addEventListener('blur', function() {
      var val = parseInt(countDisplay.value, 10);
      if (isNaN(val) || val < 1) { val = 1; }
      if (val > MAX_DOGS) { val = MAX_DOGS; }
      countDisplay.value = val;
      if (val !== dogCount) {
        dogCount = val;
        if (dogWordEl) dogWordEl.textContent = dogCount === 1 ? 'dog named' : 'dogs named';
        visibleNameRows = dogCount;
        rebuildNameRows();
      }
    });
  }

  /* "Add Dog" button on results screen */
  var addDogBtn = $('#quiz-add-dog');
  if (addDogBtn) {
    addDogBtn.addEventListener('click', function() {
      var nextDogIndex = dogs.length;
      if (nextDogIndex < dogNames.length) {
        /* Next dog was already named on screen 1 — go straight to quiz for them */
        activeDogIndex = nextDogIndex;
        quiz.name = dogNames[nextDogIndex];
        quiz.breed = ''; quiz.age = 2; quiz.ageUnit = 'years';
        quiz.weight = 0; quiz.condition = 'ideal'; quiz.activity = 'medium';
        quiz.recipe = 'chicken_rice'; quiz.plan = 'full';
        clearDetailInputs();
        applyHouseholdAnswersFromFirstDog();
        showDogTransition(dogNames[nextDogIndex], function() { goTo(2); });
      } else {
        /* All named dogs are done — go to screen 1 with count bumped to add more */
        dogCount = dogNames.length + 1;
        if (dogCount > MAX_DOGS) dogCount = MAX_DOGS;
        if (countDisplay) countDisplay.value = dogCount;
        if (dogWordEl) dogWordEl.textContent = 'dogs named';
        /* Show all existing names + one empty row */
        visibleNameRows = dogNames.length + 1;
        if (visibleNameRows > dogCount) visibleNameRows = dogCount;
        rebuildNameRows();
        goTo(1);
      }
    });
  }

  /* Breed chip click handlers */
  $$('[data-breed]').forEach(function(chip) {
    chip.addEventListener('click', function() {
      $$('[data-breed]').forEach(function(c) { c.classList.remove('is-on'); });
      chip.classList.add('is-on');
      quiz.breed = chip.dataset.breed;
      var breedInput = $('#quiz-breed');
      if (breedInput) breedInput.value = chip.dataset.breed;
      showBreedFact(chip.dataset.breed);
    });
  });

  /* Breed text input — clear chip on manual type */
  var breedTextInput = $('#quiz-breed');
  if (breedTextInput) {
    breedTextInput.addEventListener('input', function() {
      var val = breedTextInput.value.trim();
      $$('[data-breed]').forEach(function(c) { c.classList.remove('is-on'); });
      if (val) {
        /* Check if typed value matches a chip */
        var matchChip = root.querySelector('[data-breed="' + val + '"]');
        if (matchChip) matchChip.classList.add('is-on');
        quiz.breed = val;
        showBreedFact(val);
      }
    });
  }

  /* Pre-fill breed chip if URL param matches */
  if (breedFromUrl && quiz.breed) {
    var matchChip = root.querySelector('[data-breed="' + quiz.breed + '"]');
    if (matchChip) matchChip.classList.add('is-on');
    if (breedTextInput) breedTextInput.value = quiz.breed;
  }

  /* Age unit toggle */
  $$('[data-age-unit]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      $$('[data-age-unit]').forEach(function(b) { b.classList.remove('is-on'); });
      btn.classList.add('is-on');
      quiz.ageUnit = btn.dataset.ageUnit;
    });
  });

  $$('[data-sex]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      $$('[data-sex]').forEach(function(b) { b.classList.remove('is-on'); });
      btn.classList.add('is-on');
      quiz.sex = btn.dataset.sex;
    });
  });

  $$('[data-neutered]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      $$('[data-neutered]').forEach(function(b) { b.classList.remove('is-on'); });
      btn.classList.add('is-on');
      quiz.neutered = btn.dataset.neutered;
    });
  });

  /* Body condition cards — with auto-advance */
  $$('[data-condition]').forEach(function(card) {
    card.addEventListener('click', function() {
      $$('[data-condition]').forEach(function(c) { c.classList.remove('is-on'); });
      card.classList.add('is-on');
      quiz.condition = card.dataset.condition;
      /* Auto-advance after 600ms */
      setTimeout(function() { goTo(quiz.step + 1); }, 600);
    });
  });

  /* Activity cards — Butternut style with label card + auto-advance */
  var activityLabelData = {
    low:     { title: 'Couch Potato', desc: 'Mostly naps, short toilet breaks' },
    medium:  { title: 'Casual Walker', desc: 'Daily walks, some play time' },
    high:    { title: 'Active Player', desc: '1-2hr walks, lots of running' },
    athlete: { title: 'Athlete', desc: 'Working dog, high-energy breeds' }
  };
  function updateActivityLabel(val) {
    var lc = $('#quiz-activity-label-card');
    var lt = $('#quiz-activity-label-title');
    var ld = $('#quiz-activity-label-desc');
    if (!lc || !lt || !ld) return;
    var d = activityLabelData[val];
    if (d) { lt.textContent = d.title; ld.textContent = d.desc; }
    /* Move arrow to point at selected option */
    var row = root.querySelector('.quiz-activity-row');
    var sel = root.querySelector('.quiz-activity-option.is-on');
    if (row && sel) {
      var rowRect = row.getBoundingClientRect();
      var selRect = sel.getBoundingClientRect();
      var pct = ((selRect.left + selRect.width/2) - rowRect.left) / rowRect.width * 100;
      var arrow = lc.querySelector('.quiz-activity-label-card__arrow');
      if (arrow) arrow.style.left = pct + '%';
    }
  }
  $$('[data-activity]').forEach(function(card) {
    card.addEventListener('click', function() {
      $$('[data-activity]').forEach(function(c) { c.classList.remove('is-on'); });
      card.classList.add('is-on');
      quiz.activity = card.dataset.activity;
      updateActivityLabel(card.dataset.activity);
      /* No auto-advance — let users see the illustrations and tap Continue manually */
    });
  });

  /* Priority cards — single-select on conviction screen (no auto-advance) */
  $$('[data-priority]').forEach(function(card) {
    card.addEventListener('click', function() {
      $$('[data-priority]').forEach(function(c) { c.classList.remove('is-on'); });
      card.classList.add('is-on');
      quiz.priority = card.dataset.priority;
    });
  });

  $$('[data-eating-style]').forEach(function(card) {
    card.addEventListener('click', function() {
      $$('[data-eating-style]').forEach(function(c) { c.classList.remove('is-on'); });
      card.classList.add('is-on');
      quiz.eatingStyle = card.dataset.eatingStyle;
    });
  });

  /* ===== Treats/Snacks Question (Screen 8) — manual advance ===== */
  var treatsQData = {
    none:  { title: 'No treats', desc: 'We\'ll calculate a full portion' },
    some:  { title: 'A few treats', desc: '1\u20133 times a day' },
    lots:  { title: 'Treat lover!', desc: 'We\'ll account for the extra calories' }
  };

  $$('[data-treats-q]').forEach(function(opt) {
    opt.addEventListener('click', function() {
      $$('[data-treats-q]').forEach(function(o) { o.classList.remove('is-on'); });
      opt.classList.add('is-on');
      quiz.treats = opt.dataset.treatsQ;
      /* Update label card */
      var labelCard = $('#quiz-treats-q-label-card');
      var labelTitle = $('#quiz-treats-q-label-title');
      var labelDesc = $('#quiz-treats-q-label-desc');
      var data = treatsQData[quiz.treats];
      if (labelCard && data) {
        labelTitle.textContent = data.title;
        labelDesc.textContent = data.desc;
        labelCard.hidden = false;
      }
      /* No auto-advance — let users see illustrations and tap Continue manually */
    });
  });

  /* ===== Weight Slider (Screen 4) — bidirectional sync ===== */
  (function() {
    var slider = $('#quiz-weight-slider');
    var weightInput = $('#quiz-weight');
    if (!slider || !weightInput) return;

    function updateSizeHighlight(w) {
      $$('.quiz-weight-size').forEach(function(el) {
        var size = el.dataset.size;
        var active = false;
        if (size === 'small' && w >= 1 && w <= 10) active = true;
        if (size === 'medium' && w > 10 && w <= 30) active = true;
        if (size === 'large' && w > 30) active = true;
        el.classList.toggle('is-active', active);
      });
    }

    slider.addEventListener('input', function() {
      var val = parseInt(slider.value, 10);
      weightInput.value = val;
      quiz.weight = val;
      var weightError = $('#quiz-weight-error');
      if (weightError) weightError.hidden = true;
      weightInput.classList.remove('has-error');
      updateSizeHighlight(val);
    });

    weightInput.addEventListener('input', function() {
      var val = parseFloat(weightInput.value) || 0;
      if (val >= 1 && val <= 60) slider.value = Math.round(val);
      quiz.weight = val;
      var weightError = $('#quiz-weight-error');
      if (weightError && val > 0) weightError.hidden = true;
      weightInput.classList.remove('has-error');
      updateSizeHighlight(val);
    });

    /* Initialize highlight on load */
    updateSizeHighlight(parseFloat(weightInput.value) || 10);
  })();

  /* ===== Legacy contact fallback listener (Screen 11 is skipped by the default path) ===== */
  (function() {
    var emailContinueBtn = $('#quiz-email-continue');
    if (emailContinueBtn) {
      emailContinueBtn.addEventListener('click', function() {
        if (!captureParentLead({ source: 'legacy_email_gate' })) return;
        goTo(12);
      });
    }

    [$('#quiz-parent-name'), $('#quiz-parent-email'), $('#quiz-parent-phone'), $('#quiz-viber-optin')].forEach(function(input) {
      if (!input) return;
      input.addEventListener('change', function() {
        queueQuizProgress('quiz_contact_field_updated', 150);
      });
      input.addEventListener('blur', function() {
        queueQuizProgress('quiz_contact_field_updated', 150);
      });
    });
  })();

  /* Recipe cards — multi-select, scoped to screen 9 so pouch mockups with
     data-recipe never behave like selectable cards. Allergy-excluded recipes
     are visible for transparency but cannot be added to the plan. */
  var recipeSelectionScreen = root.querySelector('[data-screen="9"]');
  (recipeSelectionScreen ? recipeSelectionScreen.querySelectorAll('[data-recipe]') : []).forEach(function(card) {
    card.addEventListener('click', function(e) {
      /* Don't toggle if they tapped "View recipe" */
      if (e.target.classList.contains('quiz-app__recipe-view')) return;

      recipeSelectionTouched = true;
      var r = card.dataset.recipe;
      var idx = quiz.recipes.indexOf(r);
      var exclusionReason = recipeExclusionReason(r);
      if (exclusionReason) {
        showRecipeNotice(exclusionReason + '. This recipe is unavailable for the profile provided.');
        updateRecipeCards();
        return;
      }

      if (idx !== -1) {
        /* Deselect — but keep at least 1 */
        if (quiz.recipes.length <= 1) return;
        quiz.recipes.splice(idx, 1);
        showRecipeNotice('');
      } else {
        /* Select — enforce max */
        if (quiz.recipes.length >= MAX_RECIPE_SELECTIONS) {
          showRecipeNotice('You have all ' + MAX_RECIPE_SELECTIONS + ' recipes selected. Please deselect a recipe before choosing another.');
          return;
        }
        quiz.recipes.push(r);
        showRecipeNotice('');
      }
      quiz.recipe = quiz.recipes[0] || '';
      updateRecipeCards();
      updateRecipeCount();
    });
  });

  function updateRecipeCount() {
    var el = $('#quiz-recipe-count');
    var sub = $('#quiz-recipe-sub');
    if (!el) return;
    var allergyActive = isAllergyFilteringActive();
    var safeCount = DEFAULT_RECIPE_MIX.filter(function(recipe) { return !recipeExclusionReason(recipe); }).length;
    if (allergyActive) {
      el.textContent = quiz.recipes.length + ' of ' + safeCount + ' allergy-safe selected';
      if (sub) sub.textContent = 'We filtered out recipes that contain ' + allergyIngredientLabel(quiz.allergyIngredients) + '. Excluded recipes stay visible so you can see why they were removed.';
      return;
    }
    if (safeCount < MAX_RECIPE_SELECTIONS) {
      el.textContent = quiz.recipes.length + ' of ' + safeCount + ' age-appropriate selected';
      if (sub) sub.textContent = 'Braised Beef Bowl and Hearty Pork Rice are shown for menu transparency but are available only for adult dogs 1 year and older.';
      return;
    }
    el.textContent = quiz.recipes.length + ' of ' + MAX_RECIPE_SELECTIONS + ' selected';
    if (sub) sub.textContent = 'We recommend a full recipe starter mix so your dog can try every flavor before you settle into favorites. If allergies are selected, we filter out recipes with the ingredient you told us to avoid.';
  }

  /* ===== Bottom Sheet — Recipe Ingredients ===== */
  var sheetRecipeData = {
    chicken_rice: {
      subtitle: 'Chicken & Pork — No Fish',
      list: 'Chicken, Pork, Rice, Spinach, Sweet Potato, Moringa, Canola Oil, vitamins & minerals',
      macros: { Protein: '9.5%', Fat: '9.8%', Fiber: '1.7%', Moisture: '70.3%', Kcal: '1372/kg (lab-derived)' },
      items: [
        { name: 'Chicken', desc: 'Lean protein rich in B3 for energy and healthy skin.' },
        { name: 'Pork', desc: 'High-quality protein with B1 for metabolism.' },
        { name: 'Rice', desc: 'Easily digestible carbs for sustained energy.' },
        { name: 'Spinach', desc: 'Iron-rich leafy green for blood health and immunity.' },
        { name: 'Sweet Potato', desc: 'Complex carbs plus beta-carotene.' },
        { name: 'Moringa', desc: 'Superfood with antioxidants, vitamins A & C.' }
      ]
    },
    beef_rice: {
      subtitle: 'Single-Protein Beef — Adult Dogs 1+',
      list: 'Beef tripe, Sweet Potato, Squash, Rice, vitamins & minerals',
      macros: { Kcal: '1252/kg' },
      items: [
        { name: 'Beef Tripe', desc: 'Single animal-protein base with a rich flavor.' },
        { name: 'Sweet Potato', desc: 'Complex carbohydrates and beta-carotene.' },
        { name: 'Squash', desc: 'Fiber and beta-carotene for digestive support.' },
        { name: 'Rice', desc: 'A familiar, digestible carbohydrate source.' }
      ]
    },
    pork_rice: {
      subtitle: 'Single-Protein Pork — Adult Dogs 1+',
      list: 'Pork, Sweet Potato, Squash, Rice, vitamins & minerals',
      macros: { Kcal: '1645/kg' },
      items: [
        { name: 'Pork', desc: 'Single animal-protein base with a mild flavor.' },
        { name: 'Sweet Potato', desc: 'Complex carbohydrates and beta-carotene.' },
        { name: 'Squash', desc: 'Fiber and beta-carotene for digestive support.' },
        { name: 'Rice', desc: 'A familiar, digestible carbohydrate source.' }
      ]
    },
    surf_turf: {
      subtitle: 'Beef & Sardines',
      list: 'Beef, Sardine, Squash, Moringa, Okra, Canola Oil, Sweet Potato, vitamins & minerals (A, B-complex, E, Calcium, Zinc, Iron, Magnesium)',
      macros: { Protein: '16.5%', Fat: '10%', Fiber: '1%', Moisture: '70%', Kcal: '1678/kg (formula est.)' },
      items: [
        { name: 'Beef', desc: 'Rich in protein, iron, zinc, and B12 for muscle.' },
        { name: 'Sardine', desc: 'Omega-3 for healthy skin, coat, and joints.' },
        { name: 'Squash', desc: 'Beta-carotene for eye health and fiber.' },
        { name: 'Moringa', desc: 'Superfood with antioxidants, vitamins A & C.' },
        { name: 'Okra', desc: 'Fiber and vitamin C for digestion and immunity.' },
        { name: 'Sweet Potato', desc: 'Complex carbs plus beta-carotene.' }
      ]
    },
    farmyard_feast: {
      subtitle: 'Pork, Chicken & Sardines',
      list: 'Pork, Sardine, Chicken, Squash, Water Spinach, Carrots, Canola Oil, Broccoli, vitamins & minerals (A, B-complex, E, Calcium, Iron, Zinc)',
      macros: { Protein: '17%', Fat: '6%', Fiber: '1%', Moisture: '75%', Kcal: '1188/kg' },
      items: [
        { name: 'Pork', desc: 'High-quality protein with B1 for metabolism.' },
        { name: 'Chicken', desc: 'Lean protein rich in B3 for energy.' },
        { name: 'Sardine', desc: 'Omega-3 for healthy skin, coat, and joints.' },
        { name: 'Squash', desc: 'Beta-carotene for eye health and fiber.' },
        { name: 'Carrots', desc: 'Beta-carotene and fiber for vision and skin.' },
        { name: 'Broccoli', desc: 'Vitamins C and K, fiber for cellular health.' }
      ]
    },
    coastal_blend: {
      subtitle: 'Fish Recipe (Sardine, Tilapia & Catfish)',
      list: 'Sardine, Tilapia, Squash, Rice, Sweet Potato, Catfish, Carrots, Moringa, Canola Oil, vitamins & minerals',
      macros: { Protein: '14%', Fat: '5%', Fiber: '1%', Moisture: '68%', Kcal: '1395/kg' },
      items: [
        { name: 'Sardine', desc: 'Omega-3 for healthy skin, coat, and joints.' },
        { name: 'Tilapia', desc: 'Lean white fish, rich in B12 and selenium.' },
        { name: 'Catfish', desc: 'Mild white fish with quality protein.' },
        { name: 'Squash', desc: 'Beta-carotene for eye health and fiber.' },
        { name: 'Sweet Potato', desc: 'Complex carbs plus beta-carotene.' },
        { name: 'Moringa', desc: 'Superfood with antioxidants, vitamins A & C.' }
      ]
    }
  };

  var sheet = $('#quiz-ingredients-sheet');
  var sheetPanel = sheet ? sheet.querySelector('.quiz-ingredients-sheet__panel') : null;
  var sheetTouchStartY = 0;

  function populateSheetContent(recipe) {
    var data = sheetRecipeData[recipe];
    if (!data) return;

    $('#sheet-subtitle').textContent = data.subtitle;
    $('#sheet-ingredients').textContent = data.list;

    var macrosEl = $('#sheet-macros');
    macrosEl.innerHTML = Object.keys(data.macros).map(function(key) {
      return '<div class="quiz-ingredients-sheet__macro"><span class="quiz-ingredients-sheet__macro-val">' + data.macros[key] + '</span><span class="quiz-ingredients-sheet__macro-label">' + key + '</span></div>';
    }).join('');

    var gridEl = $('#sheet-grid');
    gridEl.innerHTML = data.items.map(function(item) {
      return '<div class="quiz-ingredients-sheet__card"><div class="quiz-ingredients-sheet__card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg></div><span class="quiz-ingredients-sheet__card-name">' + item.name + '</span><span class="quiz-ingredients-sheet__card-desc">' + item.desc + '</span></div>';
    }).join('');
  }

  function openSheet(recipe) {
    if (!sheet) return;

    /* Build tabs for all 6 recipes */
    var tabsEl = $('#quiz-nf-tabs');
    if (tabsEl) {
      var allKeys = ['chicken_rice', 'beef_rice', 'pork_rice', 'surf_turf', 'farmyard_feast', 'coastal_blend'];
      var tabsHtml = '';
      for (var ti = 0; ti < allKeys.length; ti++) {
        var rk = allKeys[ti];
        var rData = sheetRecipeData[rk];
        if (!rData) continue;
        var isActive = rk === recipe ? ' is-on' : '';
        tabsHtml += '<button type="button" class="quiz-nf-tab' + isActive + '" data-nf-tab="' + rk + '">' + (recipeNames[rk] || rk) + '</button>';
      }
      tabsEl.innerHTML = tabsHtml;

      /* Tab click handlers */
      tabsEl.querySelectorAll('[data-nf-tab]').forEach(function(tab) {
        tab.addEventListener('click', function() {
          tabsEl.querySelectorAll('[data-nf-tab]').forEach(function(t) { t.classList.remove('is-on'); });
          tab.classList.add('is-on');
          populateSheetContent(tab.dataset.nfTab);
        });
      });
    }

    populateSheetContent(recipe || 'chicken_rice');
    sheet.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* "View recipe" links */
  $$('[data-view]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      openSheet(link.dataset.view);
    });
  });

  /* Close: scrim click */
  if (sheet) {
    sheet.querySelector('.quiz-ingredients-sheet__scrim').addEventListener('click', closeSheet);
    sheet.querySelector('.quiz-ingredients-sheet__close').addEventListener('click', closeSheet);
  }

  /* Close: swipe down */
  if (sheetPanel) {
    sheetPanel.addEventListener('touchstart', function(e) {
      sheetTouchStartY = e.touches[0].clientY;
    }, { passive: true });
    sheetPanel.addEventListener('touchmove', function(e) {
      var dy = e.touches[0].clientY - sheetTouchStartY;
      if (dy > 80) closeSheet();
    }, { passive: true });
  }

  /* Subscribe CTA */
  var subBtn = $('#quiz-cta-subscribe');
  if (subBtn) subBtn.addEventListener('click', handleSubscribe);

  var oneTimeBtn = $('#quiz-cta-onetime');
  if (oneTimeBtn) oneTimeBtn.addEventListener('click', function() {
    quizCompleted = true;
    trackQuizEvent('quiz_one_time_intent', {
      recipe: quiz.recipe,
      bags: results.bagsPerMonth || 0,
      value: results.otMonthly || 0
    });
    saveDogProfile('quiz_one_time_intent');
  });

  var samplerBtn = $('#quiz-cta-sampler');
  if (samplerBtn) samplerBtn.addEventListener('click', function() {
    quizCompleted = true;
    trackQuizEvent('QuizSamplerIntent', {
      recipe: quiz.recipe,
      sampler: quiz.recipe === 'chicken_rice' ? 'essentials' : 'signature'
    });
    saveDogProfile('quiz_sampler_intent');
  });

  /* Quiz -> chat handoff: connects the quiz to the Suki Concierge. Only shown
     once we have an email to attach the conversation to. Creates an operator
     follow-up task AND opens Viber so the customer can reach McDuffy Care now. */
  var conciergeBtn = $('#quiz-cta-concierge');
  if (conciergeBtn) {
    conciergeBtn.addEventListener('click', function() {
      var email = quiz.parentEmail || '';
      if (!email) return;
      conciergeBtn.disabled = true;
      saveDogProfile('quiz_concierge_handoff');
      trackQuizEvent('quiz_concierge_handoff', { recipe: quiz.recipe });
      fetch(BACKEND_URL + '/api/quiz-handoff', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, dog_name: quiz.name || '', reason: 'requested' })
      }).then(function(r) { return r.ok ? r.json() : null; }).then(function(d) {
        if (d && d.viber_href) window.location.href = d.viber_href;
      }).catch(function() {}).then(function() { conciergeBtn.disabled = false; });
    });
  }

  /* Edit answers button on results — full restart from screen 1 */
  var editBtn = $('#quiz-cta-edit');
  if (editBtn) editBtn.addEventListener('click', function() { goTo(1); });

  /* Per-section quick-edit links on results page (FD-style non-destructive editing).
     Each button has a data-jump="<screenNumber>" attribute. Clicking jumps to
     that specific screen with quiz state preserved — user can change one
     value and continue forward through the flow back to results. The loading
     and results screens will re-render with updated calculations. */
  var quickEditsWrap = $('#quiz-r-quick-edits');
  if (quickEditsWrap) {
    quickEditsWrap.addEventListener('click', function(e) {
      var btn = e.target.closest && e.target.closest('.quiz-r__quick-edit');
      if (!btn || !quickEditsWrap.contains(btn)) return;
      if (btn.dataset.editDogIndex) {
        var dogIndex = parseInt(btn.dataset.editDogIndex, 10);
        var dogTarget = parseInt(btn.dataset.editTarget, 10) || 3;
        if (dogTarget === 9) recipeEditReturnStep = 13;
        if (!isNaN(dogIndex)) editDog(dogIndex, dogTarget);
        return;
      }
      var target = parseInt(btn.dataset.jump, 10);
      if (!target || target < 1 || target > 14) return;
      if (target === 9) recipeEditReturnStep = 13;
      /* Track which section was edited (useful for funnel analytics) */
      try {
        if (typeof fbq === 'function') {
          fbq('trackCustom', 'QuizQuickEdit', { section: btn.textContent || target });
        }
        if (typeof gtag === 'function') {
          gtag('event', 'quiz_quick_edit', { section: btn.textContent || target });
        }
      } catch (e) { /* analytics non-fatal */ }
      goTo(target);
    });
  }

  /* "Change recipe recommendations" link — go back to recipe screen (9) */
  var changeRecipeLink = $('#quiz-r-change-recipes');
  if (changeRecipeLink) changeRecipeLink.addEventListener('click', function(e) {
    e.preventDefault();
    recipeEditReturnStep = 13;
    goTo(9);
  });

  root.addEventListener('change', function(e) {
    if (e.target && e.target.matches('input, select, textarea')) {
      queueQuizProgress('quiz_field_updated', 300);
    }
  });

  root.addEventListener('input', function(e) {
    if (e.target && e.target.matches('.quiz-app__name-input, .quiz-app__count-input, #quiz-parent-name, #quiz-parent-email, #quiz-parent-phone, #quiz-viber-optin')) {
      queueQuizProgress('quiz_field_updated', 700);
    }
  });

  root.addEventListener('click', function(e) {
    if (e.target && e.target.closest('.quiz-app__option, .quiz-app__recipe, .quiz-body-card, .quiz-app__chip, .quiz-app__segment, .quiz-app__health-pill, .quiz-app__allergy-pill')) {
      queueQuizProgress('quiz_option_selected', 350);
    }
  });

  /* Email form submission */
  var emailForm = $('#quiz-email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var emailInput = $('#quiz-email');
      if (!emailInput || !emailInput.value) return;

      var submitBtn = emailForm.querySelector('.quiz-app__email-submit');
      if (submitBtn) { submitBtn.textContent = 'Sending...'; submitBtn.disabled = true; }

      var email = String(emailInput.value || '').trim();
      var secondaryLeadEventId = trackingContext('CompleteRegistration').event_id;
      if (typeof window.mcduffyCaptureLead === 'function') {
        window.mcduffyCaptureLead({
          email: email,
          source: 'quiz_secondary_email',
          lead_status: 'quiz_email_captured',
          event_id: secondaryLeadEventId,
          marketing_opt_in: true,
          tags: ['quiz', 'prospect']
        });
      } else {
        try {
          fetch('https://mcduffy-backend-production.up.railway.app/api/leads/capture', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: email,
              source: 'quiz_secondary_email',
              lead_status: 'quiz_email_captured',
              event_id: secondaryLeadEventId,
              attribution: backendTrackingPayload('quiz_email_captured', secondaryLeadEventId).attribution,
              marketing_opt_in: true,
              tags: ['quiz', 'prospect'],
              page_url: window.location.href,
              referrer: document.referrer || ''
            }),
            credentials: 'omit',
            mode: 'cors',
            keepalive: true
          }).catch(function() {});
        } catch (err) {}
      }

      if (submitBtn) submitBtn.textContent = 'Sent!';
      trackFB('standard', 'CompleteRegistration', { content_name: 'Quiz Email', event_id: secondaryLeadEventId });
      if (typeof gtag === 'function') gtag('event', 'sign_up', { method: 'quiz', event_id: secondaryLeadEventId });
    });
  }

  /* ===== Initialize ===== */
  /* Build initial name row with reveal-next listener */
  applyQuizPreset();
  rebuildNameRows();

  var savedState = null;
  try { savedState = JSON.parse(sessionStorage.getItem('mcduffy_quiz_state') || 'null'); } catch(e) {}
  if (savedState && savedState.quiz && savedState.quiz.weight > 0) {
    var sq = savedState.quiz;
    quiz.name = sq.name || '';
    quiz.breed = sq.breed || '';
    quiz.age = sq.age || 2;
    quiz.ageUnit = sq.ageUnit || 'years';
    quiz.weight = sq.weight;
    quiz.condition = sq.condition || 'ideal';
    quiz.activity = sq.activity || 'medium';
    quiz.healthIssues = sq.healthIssues || [];
    quiz.allergyIngredients = sq.allergyIngredients || [];
    quiz.sex = sq.sex || '';
    quiz.neutered = sq.neutered || '';
    quiz.eatingStyle = sq.eatingStyle || '';
    quiz.currentFoodType = sq.currentFoodType || '';
    quiz.currentFoodBrand = sq.currentFoodBrand || '';
    quiz.recipes = starterRecipeMixFor(sq);
    quiz.recipe = (sq.recipe && quiz.recipes.indexOf(sq.recipe) !== -1) ? sq.recipe : (quiz.recipes[0] || '');
    quiz.plan = 'full';
    quiz.preset = sq.preset || quiz.preset || '';
    quiz.parentName = sq.parentName || '';
    quiz.parentEmail = sq.parentEmail || '';
    quiz.parentViberOptIn = sq.parentViberOptIn === true;
    quiz.parentPhone = quiz.parentViberOptIn ? (sq.parentPhone || '') : '';
    quiz.parentEmailOptIn = sq.parentEmailOptIn === false ? false : true;
    parentLeadCaptured = !!quiz.parentEmail;
    if (savedState.dogs) dogs = savedState.dogs.map(function(d) {
      d.plan = 'full';
      d.sex = d.sex || '';
      d.neutered = d.neutered || '';
      d.eatingStyle = d.eatingStyle || '';
      d.currentFoodType = d.currentFoodType || '';
      d.currentFoodBrand = d.currentFoodBrand || '';
      d.allergyIngredients = d.allergyIngredients || [];
      d.recipes = starterRecipeMixFor(d);
      d.recipe = (d.recipe && d.recipes.indexOf(d.recipe) !== -1) ? d.recipe : (d.recipes[0] || '');
      return d;
    });
    if (savedState.dogNames) dogNames = savedState.dogNames;
    if (savedState.dogCount) dogCount = savedState.dogCount;
    if (typeof savedState.activeDogIndex === 'number') activeDogIndex = savedState.activeDogIndex;
    sessionStorage.removeItem('mcduffy_quiz_state');
    goTo(13);
  } else {
    goTo(1);
    /* Track quiz start — top of funnel */
    trackQuizEventOnce('quiz_started', 'QuizStarted', { source: document.referrer || 'direct' });
  }

  /* ===== Quiz Dropoff Tracking ===== */
  window.addEventListener('beforeunload', function() {
    if (quiz.step > 1 && !quizCompleted) {
      trackFB('custom', 'QuizDropoff', {
        last_screen: quiz.step,
        dogs_completed: dogs.length,
        total_dogs: dogNames.length
      });
    }
  });

  /* ===== "View full ingredients" button → opens bottom sheet ===== */
  (function() {
    var viewBtn = $('#quiz-r-view-ingredients');
    if (!viewBtn) return;
    viewBtn.addEventListener('click', function() {
      if (typeof openSheet === 'function') {
        openSheet(quiz.recipe || 'surf_turf');
      }
    });
  })();

  /* ===== Health Issues (Screen 7) ===== */
  function syncAllergyPanel() {
    var allergyPanel = $('#quiz-allergy-panel');
    var hasAllergies = quiz.healthIssues.indexOf('allergies') !== -1;
    if (allergyPanel) allergyPanel.hidden = !hasAllergies;
    if (!hasAllergies) {
      quiz.allergyIngredients = [];
      $$('[data-allergen]').forEach(function(p) { p.classList.remove('is-on'); });
    }
  }

  $$('[data-health-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      $$('[data-health-toggle]').forEach(function(b) { b.classList.remove('is-on'); });
      btn.classList.add('is-on');
      var healthGrid = $('#quiz-health-grid');
      var healthRec = $('#quiz-health-rec');
      var allergyPanel = $('#quiz-allergy-panel');
      if (btn.dataset.healthToggle === 'none') {
        if (healthGrid) healthGrid.hidden = true;
        if (healthRec) healthRec.hidden = true;
        if (allergyPanel) allergyPanel.hidden = true;
        quiz.healthIssues = [];
        quiz.allergyIngredients = [];
        $$('[data-health]').forEach(function(p) { p.classList.remove('is-on'); });
        $$('[data-allergen]').forEach(function(p) { p.classList.remove('is-on'); });
        /* Auto-advance after short delay */
        setTimeout(function() { goTo(quiz.step + 1); }, 500);
      } else {
        if (healthGrid) healthGrid.hidden = false;
      }
    });
  });

  $$('[data-health]').forEach(function(pill) {
    pill.addEventListener('click', function() {
      pill.classList.toggle('is-on');
      /* Rebuild health issues array */
      quiz.healthIssues = [];
      $$('[data-health].is-on').forEach(function(p) {
        quiz.healthIssues.push(p.dataset.health);
      });
      recipeSelectionTouched = false;
      syncAllergyPanel();
      /* Show recipe recommendation */
      updateHealthRecommendation();
    });
  });

  $$('[data-allergen]').forEach(function(pill) {
    pill.addEventListener('click', function() {
      pill.classList.toggle('is-on');
      quiz.allergyIngredients = [];
      $$('[data-allergen].is-on').forEach(function(p) {
        quiz.allergyIngredients.push(p.dataset.allergen);
      });
      recipeSelectionTouched = false;
      updateHealthRecommendation();
    });
  });

  function updateHealthRecommendation() {
    var recEl = $('#quiz-health-rec');
    var recText = $('#quiz-health-rec-text');
    if (!recEl || !recText) return;

    if (quiz.healthIssues.length === 0) {
      recEl.hidden = true;
      return;
    }

    /* Find highest-priority health issue */
    var topIssue = null;
    for (var i = 0; i < healthPriority.length; i++) {
      if (quiz.healthIssues.indexOf(healthPriority[i]) !== -1) {
        topIssue = healthPriority[i];
        break;
      }
    }

    if (topIssue && healthReasons[topIssue]) {
      var issueNames = quiz.healthIssues.map(function(h) { return healthReasons[h] || h; });
      var issueStr = issueNames.length === 1 ? issueNames[0] : issueNames.slice(0, -1).join(', ') + ' & ' + issueNames[issueNames.length - 1];
      var allergenStr = allergyIngredientLabel(quiz.allergyIngredients);
      if (topIssue === 'allergies' && allergenStr) {
        var safeMix = allergySafeRecipeMix(quiz.allergyIngredients);
        recText.textContent = safeMix.length
          ? 'Noted. We will filter out recipes with ' + allergenStr + '.'
          : 'No current McDuffy recipe fully avoids ' + allergenStr + '. Please message us before ordering.';
      } else {
        recText.textContent = topIssue === 'allergies'
          ? 'Select the ingredient your dog is allergic to so we can filter recipes correctly.'
          : 'Noted! We\'ll recommend the best recipe for ' + issueStr + '.';
      }
      recEl.hidden = false;
    }
  }

  /* Pre-select recipe on the recipe-selection screen (data-screen="9") based
     on health issues + show "Recommended for X" badge.

     Bug fix: previously used global $$('[data-recipe]') which also matched
     pouch mockup elements on the RESULTS screen, causing the badge text
     ("RECOMMENDED FOR SENSITIVE TUMMIES" etc.) to render across all 3 hero
     bag images on the results page. Now scoped strictly to the recipe
     screen so the badge only appears where it belongs. */
  function applyHealthRecipeRecommendation() {
    var recipeScreen = root.querySelector('[data-screen="9"]');
    if (!recipeScreen) return;
    if (recipeSelectionTouched) {
      updateRecipeCards();
      updateRecipeCount();
      return;
    }
    if (quiz.healthIssues.length === 0) {
      applyRecipeSelection(DEFAULT_RECIPE_MIX, DEFAULT_RECIPE_MIX[0]);
      showRecipeNotice('');
      return;
    }
    for (var i = 0; i < healthPriority.length; i++) {
      if (quiz.healthIssues.indexOf(healthPriority[i]) !== -1) {
        var topIssue = healthPriority[i];
        var mix = recommendedRecipeMix();
        if (!mix.length) {
          applyRecipeSelection([], '');
          showRecipeNotice('No current McDuffy recipe fully avoids that allergy combination. Please message us before ordering.');
          return;
        }
        var rec = topIssue === 'allergies' ? mix[0] : healthRecipeMap[topIssue];
        applyRecipeSelection(mix, rec);
        showRecipeNotice('');
        break;
      }
    }
  }

  /* ===== Treats Upsell (Screen 14) — Qty Stepper ===== */
  function setTreatCardBilling(card, billing, silent) {
    if (!card) return;
    var locked = normalizeTreatBilling(card.dataset.treatBillingLock || '');
    var nextBilling = locked === 'one_time' ? 'one_time' : normalizeTreatBilling(billing);
    card.dataset.treatBilling = nextBilling;
    card.querySelectorAll('.quiz-treats__billing-option').forEach(function(btn) {
      var isOn = normalizeTreatBilling(btn.dataset.treatBilling) === nextBilling;
      btn.classList.toggle('is-on', isOn);
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });
    if (!silent) rebuildSelectedTreats();
  }

  function initTreatBillingControls() {
    $$('.quiz-treats__card').forEach(function(card) {
      var treatKey = card.dataset.treat || '';
      var isLockedOneTime = treatKey === 'duffybox' || card.dataset.treatBillingLock === 'one_time';
      var defaultBilling = isLockedOneTime ? 'one_time' : normalizeTreatBilling(card.dataset.treatBilling || card.dataset.treatBillingDefault || 'one_time');
      if (isLockedOneTime) card.dataset.treatBillingLock = 'one_time';
      card.dataset.treatBilling = defaultBilling;

      var info = card.querySelector('.quiz-treats__card-info');
      if (!info || card.querySelector('.quiz-treats__billing')) return;

      var billingWrap = document.createElement('div');
      billingWrap.className = 'quiz-treats__billing';
      billingWrap.setAttribute('aria-label', 'Treat billing option');

      if (isLockedOneTime) {
        billingWrap.innerHTML = '<span class="quiz-treats__billing-pill">First box only</span>';
      } else {
        billingWrap.setAttribute('role', 'group');
        billingWrap.innerHTML =
          '<button type="button" class="quiz-treats__billing-option" data-treat-billing="one_time" aria-pressed="false">First box only</button>' +
          '<button type="button" class="quiz-treats__billing-option" data-treat-billing="subscription" aria-pressed="false">Monthly</button>';
        billingWrap.querySelectorAll('.quiz-treats__billing-option').forEach(function(btn) {
          btn.addEventListener('click', function() {
            setTreatCardBilling(card, btn.dataset.treatBilling);
          });
        });
      }

      info.appendChild(billingWrap);
      setTreatCardBilling(card, defaultBilling, true);
    });
  }

  function rebuildSelectedTreats() {
    selectedTreats = [];
    $$('.quiz-treats__card').forEach(function(card) {
      var qtyEl = card.querySelector('.quiz-treats__qty-value');
      var qty = parseInt(qtyEl ? qtyEl.textContent : '0', 10) || 0;
      if (qty > 0) {
        var billing = normalizeTreatBilling(card.dataset.treatBilling || card.dataset.treatBillingDefault || card.dataset.treatBillingLock || 'one_time');
        selectedTreats.push({
          name: card.dataset.treat,
          price: parseInt(card.dataset.treatPrice, 10) || 0,
          qty: qty,
          variant: card.dataset.treatVariant || '',
          billing: billing,
          recurring: billing === 'subscription',
          billingLabel: billing === 'subscription' ? 'Monthly add-on' : 'First box only'
        });
      }
      card.classList.toggle('is-added', qty > 0);
    });
    var continueBtn = $('#quiz-treats-continue');
    if (continueBtn) {
      continueBtn.textContent = selectedTreats.length ? 'Add first-box treats \u2192' : 'Continue to checkout \u2192';
    }
  }

  $$('.quiz-treats__qty-plus').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var card = btn.closest('.quiz-treats__card');
      var qtyEl = card.querySelector('.quiz-treats__qty-value');
      var cur = parseInt(qtyEl.textContent, 10) || 0;
      if (cur < 10) { qtyEl.textContent = cur + 1; rebuildSelectedTreats(); }
    });
  });

  $$('.quiz-treats__qty-minus').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var card = btn.closest('.quiz-treats__card');
      var qtyEl = card.querySelector('.quiz-treats__qty-value');
      var cur = parseInt(qtyEl.textContent, 10) || 0;
      if (cur > 0) { qtyEl.textContent = cur - 1; rebuildSelectedTreats(); }
    });
  });

  /* Dropdown variant selector for Yak Chews / DuffyBox */
  $$('.quiz-treats__select').forEach(function(sel) {
    sel.addEventListener('change', function() {
      var card = sel.closest('.quiz-treats__card');
      var opt = sel.options[sel.selectedIndex];
      var newPrice = parseInt(opt.value, 10) || 0;
      var newVariant = opt.dataset.variant || '';
      var nextBilling = opt.dataset.billing || card.dataset.treatBillingLock || card.dataset.treatBilling || '';
      card.dataset.treatPrice = newPrice;
      card.dataset.treatVariant = newVariant;
      if (nextBilling) setTreatCardBilling(card, nextBilling, true);
      var introPrice = Math.round((newPrice * INTRO_DISCOUNT) * 100) / 100;
      var priceEl = card.querySelector('.quiz-treats__card-price');
      if (priceEl) priceEl.innerHTML = formatPeso(introPrice) + ' <s>' + formatPeso(newPrice) + '</s>';
      rebuildSelectedTreats();
    });
  });

  initTreatBillingControls();
  rebuildSelectedTreats();

  var treatsContinueBtn = $('#quiz-treats-continue');
  if (treatsContinueBtn) treatsContinueBtn.addEventListener('click', proceedToCheckout);

  var treatsSkipBtn = $('#quiz-treats-skip');
  if (treatsSkipBtn) treatsSkipBtn.addEventListener('click', function() {
    selectedTreats = [];
    $$('.quiz-treats__qty-value').forEach(function(el) { el.textContent = '0'; });
    $$('.quiz-treats__card').forEach(function(card) { card.classList.remove('is-added'); });
    proceedToCheckout();
  });

  ensureCheckoutReviewPortal();

  var reviewConfirmBtn = reviewNode('quiz-review-confirm');
  if (reviewConfirmBtn) reviewConfirmBtn.addEventListener('click', function() {
    finishCheckout(pendingCheckoutConfig || buildSubscribeConfig());
  });

  var reviewEditBtn = reviewNode('quiz-review-edit');
  if (reviewEditBtn) reviewEditBtn.addEventListener('click', function() {
    hideCheckoutReview('back_to_plan');
    goTo(13);
  });

  var reviewCloseBtn = reviewNode('quiz-review-close');
  if (reviewCloseBtn) reviewCloseBtn.addEventListener('click', function() {
    hideCheckoutReview('close_button');
  });

  var reviewScrim = document.querySelector('#quiz-checkout-review [data-review-close]');
  if (reviewScrim) reviewScrim.addEventListener('click', function() {
    hideCheckoutReview('scrim');
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') hideCheckoutReview('escape');
  });

  /* ===== Hook: Screen transition logic ===== */
  var _origGoTo = goTo;
  goTo = function(n) {
    var fromStep = quiz.step;
    /* ── Apply health recipe recommendation before recipe screen (7→8 → 8 is treats, so do it before 9) ── */
    if (n === 8 && quiz.step === 7) {
      applyHealthRecipeRecommendation();
    }

    if (n === 12 && quiz.step === 8) {
      trackQuizEvent('QuizRecipeSelected', {
        dog_index: activeDogIndex,
        recipe: quiz.recipe,
        recipes: quiz.recipes.join(','),
        mixed: quiz.recipes.length > 1
      });
    }

    /* ── Legacy screen-11 guard: contact capture now happens on screen 3 ── */
    if (n === 11) {
      if (dogs.length + 1 < dogNames.length) {
        /* More dogs remain after this one — go straight to loading */
        if (fromStep === 8) {
          trackFB('custom', 'QuizDogProfile', {
            dog_index: activeDogIndex,
            breed: quiz.breed, weight: quiz.weight, age: quiz.age,
            age_unit: quiz.ageUnit, sex: quiz.sex || '', neutered: quiz.neutered || '',
            condition: quiz.condition,
            activity: quiz.activity, health_issues: quiz.healthIssues.length,
            eating_style: quiz.eatingStyle || '',
            current_food_type: quiz.currentFoodType || ''
          });
        }
        markScreenCompleted(fromStep);
        saveQuizProgress('quiz_screen_' + fromStep + '_completed', null, {
          screen: fromStep,
          last_screen: fromStep
        });
        _origGoTo(12);
        queueQuizProgress('quiz_screen_12_viewed', 500);
        return;
      }
      n = 12;
    }

    /* ── Funnel tracking on screen transitions ── */
    if (n === 10 && quiz.step === 9) {
      /* Legacy recipe edit fallback */
      trackQuizEvent('QuizRecipeSelected', {
        dog_index: activeDogIndex,
        recipe: quiz.recipe,
        recipes: quiz.recipes.join(','),
        mixed: quiz.recipes.length > 1
      });

      /* The old conviction/current-food/priority screen was household-level.
         Ask it once for dog 1, then reuse it so multi-dog customers do not
         repeat owner-level answers for every dog. */
      if (activeDogIndex > 0) {
        applyHouseholdAnswersFromFirstDog();
        trackFB('custom', 'QuizDogProfile', {
          dog_index: activeDogIndex,
          breed: quiz.breed, weight: quiz.weight, age: quiz.age,
          age_unit: quiz.ageUnit, sex: quiz.sex || '', neutered: quiz.neutered || '',
          condition: quiz.condition,
          activity: quiz.activity, health_issues: quiz.healthIssues.length,
          eating_style: quiz.eatingStyle || '',
          current_food_type: quiz.currentFoodType || ''
        });
        markScreenCompleted(fromStep);
        saveQuizProgress('quiz_screen_' + fromStep + '_completed', null, {
          screen: fromStep,
          last_screen: fromStep,
          skipped_household_screen: true
        });
        if (dogs.length + 1 < dogNames.length) {
          _origGoTo(12);
          queueQuizProgress('quiz_screen_12_viewed', 500);
        } else {
          _origGoTo(12);
          queueQuizProgress('quiz_screen_12_viewed', 500);
        }
        return;
      }
    }
    if (n === 12 && (quiz.step === 8 || quiz.step === 10)) {
      /* Dog profile complete — all profile input done */
      trackFB('custom', 'QuizDogProfile', {
        dog_index: activeDogIndex,
        breed: quiz.breed, weight: quiz.weight, age: quiz.age,
        age_unit: quiz.ageUnit, sex: quiz.sex || '', neutered: quiz.neutered || '',
        condition: quiz.condition,
        activity: quiz.activity, health_issues: quiz.healthIssues.length,
        eating_style: quiz.eatingStyle || '',
        current_food_type: quiz.currentFoodType || ''
      });
    }

    if (n !== fromStep) {
      markScreenCompleted(fromStep);
      saveQuizProgress('quiz_screen_' + fromStep + '_completed', null, {
        screen: fromStep,
        last_screen: fromStep
      });
    }

    _origGoTo(n);
    queueQuizProgress('quiz_screen_' + n + '_viewed', 500);
  };

  /* ===== Bowl Reveal — scroll-triggered (like editorial section) ===== */
  (function() {
    var wrap = document.getElementById('quiz-r-bowl-wrap');
    var afterImg = document.getElementById('quiz-r-bowl-after');
    var divider = document.getElementById('quiz-r-bowl-divider');
    if (!wrap || !afterImg) return;

    function updateBowlReveal() {
      var rect = wrap.getBoundingClientRect();
      var vh = window.innerHeight;
      var start = vh * 0.85;
      var end = vh * 0.15;
      var center = rect.top + rect.height / 2;
      var progress = 1 - (center - end) / (start - end);
      progress = Math.max(0, Math.min(1, progress));
      var eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
      var reveal = eased * 100;
      afterImg.style.clipPath = 'inset(0 0 0 ' + (100 - reveal) + '%)';
      if (divider) {
        divider.style.left = (100 - reveal) + '%';
        divider.style.opacity = (reveal > 0.5 && reveal < 99.5) ? '1' : '0';
      }
    }

    var quizScroller = document.querySelector('.quiz-app');
    if (quizScroller) {
      quizScroller.addEventListener('scroll', function() {
        requestAnimationFrame(updateBowlReveal);
      }, { passive: true });
    }
    window.addEventListener('scroll', function() {
      requestAnimationFrame(updateBowlReveal);
    }, { passive: true });
  })();

  requestAnimationFrame(function() {
    setupScrollReveals($('.quiz-app__screen.is-active'), false);
  });

  /* ===== Countdown Timer — REMOVED =====
     Was driving the offer-bar and results "Plans reserved for 15:00 min"
     fake countdown. Removed per product decision because (a) it was hardcoded
     client-side with no enforcement and (b) trust > urgency theater. The DOM
     elements it targeted are gone, so this IIFE is no-op now. Kept here as
     a stub comment to make the removal intent clear. */

})();
